/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.0.7.0 (NJsonSchema v9.13.4.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import * as moment from 'moment';
import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
  tap,
} from 'rxjs/operators';
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
  Subject
} from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
  HttpErrorResponse
} from '@angular/common/http';
import { ToastrService } from '@shared/toastr/toastr.service';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

import { dataURItoBlob } from '@shared/service-proxies/service-proxies.utils';
import { AppAuthService } from '@shared/auth/app-auth.service';

@Injectable()
export class AccountServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @param input (optional)
   * @return Success
   */
  isTenantAvailable(
    input: IsTenantAvailableInput | null | undefined
  ): Observable<IsTenantAvailableOutput> {
    let url_ = this.baseUrl + '/api/services/app/Account/IsTenantAvailable';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(input);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIsTenantAvailable(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIsTenantAvailable(<any>response_);
            } catch (e) {
              return <Observable<IsTenantAvailableOutput>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<IsTenantAvailableOutput>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processIsTenantAvailable(
    response: HttpResponseBase
  ): Observable<IsTenantAvailableOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? IsTenantAvailableOutput.fromJS(resultData200)
            : new IsTenantAvailableOutput();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IsTenantAvailableOutput>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  register(
    input: RegisterInput | null | undefined
  ): Observable<RegisterOutput> {
    let url_ = this.baseUrl + '/api/services/app/Account/Register';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = input;

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRegister(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRegister(<any>response_);
            } catch (e) {
              return <Observable<RegisterOutput>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<RegisterOutput>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processRegister(
    response: HttpResponseBase
  ): Observable<RegisterOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? RegisterOutput.fromJS(resultData200)
            : new RegisterOutput();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RegisterOutput>(<any>null);
  }
}

@Injectable()
export class ClassServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @param courseId (optional)
   * @param keywords (optional)
   * @param instructor (optional)
   * @param progress (optional)
   * @param bookmarked (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getClassCarroussel(
    courseId: number | null | undefined,
    keywords: string[] | null | undefined,
    instructor: string | null | undefined,
    progress: Progress | null | undefined,
    bookmarked: boolean | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<PagedResultDtoOfClassOverviewDto> {
    let url_ = this.baseUrl + '/api/services/app/Class/GetClassCarroussel?';
    if (courseId !== undefined)
      url_ += 'CourseId=' + encodeURIComponent('' + courseId) + '&';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (instructor !== undefined)
      url_ += 'Instructor=' + encodeURIComponent('' + instructor) + '&';
    if (progress !== undefined)
      url_ += 'Progress=' + encodeURIComponent('' + progress) + '&';
    if (bookmarked !== undefined)
      url_ += 'Bookmarked=' + encodeURIComponent('' + bookmarked) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClassCarroussel(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClassCarroussel(<any>response_);
            } catch (e) {
              return <Observable<PagedResultDtoOfClassOverviewDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PagedResultDtoOfClassOverviewDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetClassCarroussel(
    response: HttpResponseBase
  ): Observable<PagedResultDtoOfClassOverviewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? PagedResultDtoOfClassOverviewDto.fromJS(resultData200)
            : new PagedResultDtoOfClassOverviewDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDtoOfClassOverviewDto>(<any>null);
  }

  /**
   * @param createClassDto (optional)
   * @return Success
   */
  createClass(
    createClassDto: CreateClassDto | null | undefined
  ): Observable<ClassForEditDto> {
    let url_ = this.baseUrl + '/api/services/app/Class/CreateClass';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: createClassDto,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateClass(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateClass(<any>response_);
            } catch (e) {
              return <Observable<ClassForEditDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ClassForEditDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processCreateClass(
    response: HttpResponseBase
  ): Observable<ClassForEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ClassForEditDto.fromJS(resultData200)
            : new ClassForEditDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ClassForEditDto>(<any>null);
  }

  /**
   * @param classId (optional)
   * @return Success
   */
  deleteClass(classId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Class/DeleteClass?';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteClass(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteClass(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteClass(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param updateClassDto (optional)
   * @return Success
   */
  updateClass(
    updateClassDto: UpdateClassDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Class/UpdateClass';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: updateClassDto,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateClass(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateClass(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateClass(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param updateClassStatusDto (optional)
   * @return Success
   */
  updateClassStatus(
    updateClassStatusDto: UpdateClassStatusDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Class/UpdateClassStatus';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: updateClassStatusDto,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateClassStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateClassStatus(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateClassStatus(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param updateClassThumbnailDto (optional)
   * @return Success
   */
  updateClassThumbnail(
    updateClassThumbnailDto: UpdateClassThumbnailDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Class/UpdateClassThumbnail';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateClassThumbnailDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateClassThumbnail(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateClassThumbnail(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateClassThumbnail(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param classId (optional)
   * @return Success
   */
  getClassForEdit(
    classId: number | null | undefined
  ): Observable<any> {
    let url_ = this.baseUrl + '/api/services/app/Class/GetClassForEdit?';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClassForEdit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClassForEdit(<any>response_);
            } catch (e) {
              return <Observable<ClassForEditDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ClassForEditDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetClassForEdit(
    response: HttpResponseBase
  ): Observable<ClassForEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ClassForEditDto.fromJS(resultData200)
            : new ClassForEditDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ClassForEditDto>(<any>null);
  }

  /**
   * @param classId (optional)
   * @param courseId (optional)
   * @return Success
   */
  getUserProgress(
    classId: number | null | undefined,
    courseId?: number | null | undefined
  ): Observable<UserProgressDto> {
    let url_ = this.baseUrl + '/api/services/app/Class/GetUserProgress?';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    if (courseId !== undefined)
      url_ += 'courseId=' + encodeURIComponent('' + courseId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserProgress(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserProgress(<any>response_);
            } catch (e) {
              return <Observable<UserProgressDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<UserProgressDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetUserProgress(
    response: HttpResponseBase
  ): Observable<UserProgressDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? UserProgressDto.fromJS(resultData200)
            : new UserProgressDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserProgressDto>(<any>null);
  }

  /**
   * @param userProgress (optional)
   * @return Success
   */
  setUserProgress(
    userProgress: SetUserProgressDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Class/SetUserProgress';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(userProgress);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetUserProgress(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetUserProgress(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSetUserProgress(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param classBookmarked (optional)
   * @return Success
   */
  setClassBookmarked(
    classBookmarked: SetClassBookmarkedDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Class/SetClassBookmarked';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(classBookmarked);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetClassBookmarked(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetClassBookmarked(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSetClassBookmarked(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param courseId (optional)
   * @param classId (optional)
   * @return Success
   */
  getWatchClass(
    courseId: number | null | undefined,
    classId: number | null | undefined
  ): Observable<WatchClassDto> {
    let url_ = this.baseUrl + '/api/services/app/Class/GetWatchClass?';
    if (courseId !== undefined)
      url_ += 'courseId=' + encodeURIComponent('' + courseId) + '&';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetWatchClass(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetWatchClass(<any>response_);
            } catch (e) {
              return <Observable<WatchClassDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<WatchClassDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetWatchClass(
    response: HttpResponseBase
  ): Observable<WatchClassDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? WatchClassDto.fromJS(resultData200)
            : new WatchClassDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<WatchClassDto>(<any>null);
  }

  /**
   * @param keywords (optional)
   * @param status (optional)
   * @param instructorId (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAllClassesFilteredCount(
    keywords: string[] | null | undefined,
    status: Status | null | undefined,
    instructorId: number | null | undefined,
    courses: any,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<number> {
    let url_ =
      this.baseUrl + '/api/services/app/Class/GetAllClassesFilteredCount?';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (status !== undefined)
      url_ += 'Status=' + encodeURIComponent('' + status) + '&';
    if (instructorId !== undefined)
      url_ += 'InstructorId=' + encodeURIComponent('' + instructorId) + '&';
    if (courses !== undefined)
      url_ += 'Courses=' + encodeURIComponent('' + instructorId) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllClassesFilteredCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllClassesFilteredCount(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllClassesFilteredCount(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @param keywords (optional)
   * @param status (optional)
   * @param instructorId (optional)
   * @param courses
   * @param pageNumber
   * @param maxResultCount (optional)
   * @return Success
   */
  getAllClasses(
    keywords: string[] | null | undefined,
    status: Status2 | null | undefined,
    instructorId: number | null | undefined,
    courses: any,
    pageNumber: number | null | undefined,
    maxResultCount: number | null | undefined,
    sortType: any,
    sortField: any
  ): Observable<PagedResultDtoOfClassMainInfoDto> {

    let url_ = this.baseUrl + '/api/services/app/Class/GetAllClasses?';

    if (sortType) {
      switch (sortType) {
        case 'name': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 0) + '&';
          break;
        }
        case 'code': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 1) + '&';
          break;
        }
        case 'status': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 2) + '&';
          break;
        }
        case 'lastModified': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 3) + '&';
          break;
        }
      }
    }

    if (sortField !== undefined) {
      if (sortField === 'asc') {
        url_ += 'Sort.IsAsc=' + encodeURIComponent('' + true) + '&';
      } else {
        url_ += 'Sort.IsAsc=' + encodeURIComponent('' + false) + '&';
      }
    }

    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (courses !== undefined)
      courses &&
      courses.forEach((item) => {
        url_ += 'Courses=' + encodeURIComponent('' + item) + '&';
      });
    if (status !== undefined)
      url_ += 'Status=' + encodeURIComponent('' + status) + '&';
    if (instructorId !== undefined)
      url_ += 'InstructorId=' + encodeURIComponent('' + instructorId) + '&';
    if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent(pageNumber) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllClasses(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllClasses(<any>response_);
            } catch (e) {
              return <Observable<PagedResultDtoOfClassMainInfoDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PagedResultDtoOfClassMainInfoDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllClasses(
    response: HttpResponseBase
  ): Observable<PagedResultDtoOfClassMainInfoDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? PagedResultDtoOfClassMainInfoDto.fromJS(resultData200)
            : new PagedResultDtoOfClassMainInfoDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDtoOfClassMainInfoDto>(<any>null);
  }

  /**
   * @param classId (optional)
   * @return Success
   */
  getClassNote(classId: number | null | undefined): Observable<ClassNoteDto> {
    let url_ = this.baseUrl + '/api/services/app/Class/GetClassNote?';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClassNote(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClassNote(<any>response_);
            } catch (e) {
              return <Observable<ClassNoteDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ClassNoteDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetClassNote(
    response: HttpResponseBase
  ): Observable<ClassNoteDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ClassNoteDto.fromJS(resultData200)
            : new ClassNoteDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ClassNoteDto>(<any>null);
  }

  /**
   * @param classNoteDto (optional)
   * @return Success
   */
  createOrUpdateClassNote(
    classNoteDto: CreateOrUpdateClassNoteDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Class/CreateOrUpdateClassNote';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(classNoteDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateOrUpdateClassNote(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateOrUpdateClassNote(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateOrUpdateClassNote(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param classId (optional)
   * @return Success
   */
  getClassCode(classId: number | null | undefined): Observable<ClassCodeDto> {
    let url_ = this.baseUrl + '/api/services/app/Class/GetClassCode?';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClassCode(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClassCode(<any>response_);
            } catch (e) {
              return <Observable<ClassCodeDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ClassCodeDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetClassCode(
    response: HttpResponseBase
  ): Observable<ClassCodeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ClassCodeDto.fromJS(resultData200)
            : new ClassCodeDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ClassCodeDto>(<any>null);
  }

  /**
   * @param classCodeDto (optional)
   * @return Success
   */
  createOrUpdateClassCode(
    classCodeDto: CreateOrUpdateClassCodeDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Class/CreateOrUpdateClassCode';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(classCodeDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateOrUpdateClassCode(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateOrUpdateClassCode(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateOrUpdateClassCode(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

@Injectable()
export class ClassChapterServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @param createClassChapterDto (optional)
   * @return Success
   */
  createClassChapter(
    createClassChapterDto: CreateClassChapterDto | null | undefined
  ): Observable<ChapterDto> {
    let url_ =
      this.baseUrl + '/api/services/app/ClassChapter/CreateClassChapter';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: createClassChapterDto,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateClassChapter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateClassChapter(<any>response_);
            } catch (e) {
              return <Observable<ChapterDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ChapterDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateClassChapter(
    response: HttpResponseBase
  ): Observable<ChapterDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ChapterDto.fromJS(resultData200)
            : new ChapterDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ChapterDto>(<any>null);
  }

  /**
   * @param updateClassChapterDto (optional)
   * @return Success
   */
  updateClassChapter(
    updateClassChapterDto: UpdateClassChapterDto | null | undefined
  ): Observable<ChapterDto> {
    let url_ =
      this.baseUrl + '/api/services/app/ClassChapter/UpdateClassChapter';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: updateClassChapterDto,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateClassChapter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateClassChapter(<any>response_);
            } catch (e) {
              return <Observable<ChapterDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ChapterDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateClassChapter(
    response: HttpResponseBase
  ): Observable<ChapterDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ChapterDto.fromJS(resultData200)
            : new ChapterDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ChapterDto>(<any>null);
  }

  /**
   * @param classChapterId (optional)
   * @return Success
   */
  deleteClassChapter(
    classChapterId: number | null | undefined
  ): Observable<void> {
    let url_ =
      this.baseUrl + '/api/services/app/ClassChapter/DeleteClassChapter?';
    if (classChapterId !== undefined)
      url_ += 'classChapterId=' + encodeURIComponent('' + classChapterId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteClassChapter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteClassChapter(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteClassChapter(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param classChapterId (optional)
   * @return Success
   */
  getClassChapterById(
    classChapterId: number | null | undefined
  ): Observable<ChapterDto> {
    let url_ =
      this.baseUrl + '/api/services/app/ClassChapter/GetClassChapterById?';
    if (classChapterId !== undefined)
      url_ += 'classChapterId=' + encodeURIComponent('' + classChapterId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClassChapterById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClassChapterById(<any>response_);
            } catch (e) {
              return <Observable<ChapterDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ChapterDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetClassChapterById(
    response: HttpResponseBase
  ): Observable<ChapterDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ChapterDto.fromJS(resultData200)
            : new ChapterDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ChapterDto>(<any>null);
  }

  /**
   * @param classId (optional)
   * @return Success
   */
  getClassChapters(
    classId: number | null | undefined
  ): Observable<ChapterDto[]> {
    let url_ =
      this.baseUrl + '/api/services/app/ClassChapter/GetClassChapters?';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClassChapters(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClassChapters(<any>response_);
            } catch (e) {
              return <Observable<ChapterDto[]>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ChapterDto[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetClassChapters(
    response: HttpResponseBase
  ): Observable<ChapterDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
            result200 = [];
            for (let item of resultData200)
              result200.push(ChapterDto.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ChapterDto[]>(<any>null);
  }
}

@Injectable()
export class ClassVideoServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @param classId (optional)
   * @return Success
   */
  getUploadStatus(
    classId: number | null | undefined
  ): Observable<ClassStatusDto[]> {
    let url_ = this.baseUrl + '/api/services/app/ClassVideo/GetUploadStatus?';
    if (classId !== undefined)
      url_ += 'ClassId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUploadStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUploadStatus(<any>response_);
            } catch (e) {
              return <Observable<ClassStatusDto[]>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ClassStatusDto[]>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetUploadStatus(
    response: HttpResponseBase
  ): Observable<ClassStatusDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
            result200 = [];
            for (let item of resultData200)
              result200.push(ClassStatusDto.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ClassStatusDto[]>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  uploadVideo(
    input: UploadVideoRequestDto | null | undefined
  ): Observable<ClassUploadVideoResponseDto> {
    let url_ = this.baseUrl + '/api/services/app/ClassVideo/UploadVideo';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(input);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadVideo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadVideo(<any>response_);
            } catch (e) {
              return <Observable<ClassUploadVideoResponseDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ClassUploadVideoResponseDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processUploadVideo(
    response: HttpResponseBase
  ): Observable<ClassUploadVideoResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ClassUploadVideoResponseDto.fromJS(resultData200)
            : new ClassUploadVideoResponseDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ClassUploadVideoResponseDto>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  clearClassVideo(
    input: ClearClassVideoRequestDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/ClassVideo/ClearClassVideo';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: input,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClearClassVideo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClearClassVideo(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processClearClassVideo(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

@Injectable()
export class ConfigurationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @param input (optional)
   * @return Success
   */
  changeUiTheme(
    input: ChangeUiThemeInput | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Configuration/ChangeUiTheme';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(input);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangeUiTheme(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangeUiTheme(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

@Injectable()
export class CourseServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @param courseId (optional)
   * @return Success
   */
  getCourseDetails(
    courseId: number | null | undefined
  ): Observable<CourseDetailsDto> {
    let url_ = this.baseUrl + '/api/services/app/Course/GetCourseDetails?';
    if (courseId !== undefined)
      url_ += 'courseId=' + encodeURIComponent('' + courseId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCourseDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCourseDetails(<any>response_);
            } catch (e) {
              return <Observable<CourseDetailsDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<CourseDetailsDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCourseDetails(
    response: HttpResponseBase
  ): Observable<CourseDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? CourseDetailsDto.fromJS(resultData200)
            : new CourseDetailsDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CourseDetailsDto>(<any>null);
  }

  /**
   * @param courseId (optional)
   * @return Success
   */
  getCourseSummary(
    courseId: number | null | undefined
  ): Observable<CourseSummaryDto> {
    let url_ = this.baseUrl + '/api/services/app/Course/GetCourseSummary?';
    if (courseId !== undefined)
      url_ += 'courseId=' + encodeURIComponent('' + courseId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCourseSummary(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCourseSummary(<any>response_);
            } catch (e) {
              return <Observable<CourseSummaryDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<CourseSummaryDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCourseSummary(
    response: HttpResponseBase
  ): Observable<CourseSummaryDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? CourseSummaryDto.fromJS(resultData200)
            : new CourseSummaryDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CourseSummaryDto>(<any>null);
  }

  /**
   * @param courseId (optional)
   * @return Success
   */
  getScormLaunchContext(
    courseId: number | null | undefined
  ): Observable<ScormLaunchContextDto> {
    let url_ =
      this.baseUrl + '/api/services/app/Course/GetScormLaunchContext?';
    if (courseId !== undefined)
      url_ += 'CourseId=' + encodeURIComponent('' + courseId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetScormLaunchContext(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetScormLaunchContext(<any>response_);
            } catch (e) {
              return <Observable<ScormLaunchContextDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ScormLaunchContextDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetScormLaunchContext(
    response: HttpResponseBase
  ): Observable<ScormLaunchContextDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ScormLaunchContextDto.fromJS(resultData200)
            : new ScormLaunchContextDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ScormLaunchContextDto>(<any>null);
  }

  /**
   * @param parameters (optional)
   * @return Success
   */
  countFilteredCourseClasses(
    parameters: CountCourseResultRequestDto | null | undefined
  ): Observable<number> {
    let url_ =
      this.baseUrl + '/api/services/app/Course/CountFilteredCourseClasses';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(parameters);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCountFilteredCourseClasses(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCountFilteredCourseClasses(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCountFilteredCourseClasses(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @param programId (optional)
   * @param keywords (optional)
   * @param levelOfDifficulty (optional)
   * @param instructor (optional)
   * @param progress (optional)
   * @param bookmarked (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getProgramOverviewCourses(
    programId: number | null | undefined,
    keywords: string[] | null | undefined,
    levelOfDifficulty: LevelOfDifficulty | null | undefined,
    instructor: string | null | undefined,
    progress: Progress2 | null | undefined,
    bookmarked: boolean | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<PagedResultDtoOfCourseOverviewDto> {
    let url_ =
      this.baseUrl + '/api/services/app/Course/GetProgramOverviewCourses?';
    if (programId !== undefined)
      url_ += 'ProgramId=' + encodeURIComponent('' + programId) + '&';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (levelOfDifficulty !== undefined)
      url_ +=
        'LevelOfDifficulty=' + encodeURIComponent('' + levelOfDifficulty) + '&';
    if (instructor !== undefined)
      url_ += 'Instructor=' + encodeURIComponent('' + instructor) + '&';
    if (progress !== undefined)
      url_ += 'Progress=' + encodeURIComponent('' + progress) + '&';
    if (bookmarked !== undefined)
      url_ += 'Bookmarked=' + encodeURIComponent('' + bookmarked) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProgramOverviewCourses(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProgramOverviewCourses(<any>response_);
            } catch (e) {
              return <Observable<PagedResultDtoOfCourseOverviewDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PagedResultDtoOfCourseOverviewDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetProgramOverviewCourses(
    response: HttpResponseBase
  ): Observable<PagedResultDtoOfCourseOverviewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? PagedResultDtoOfCourseOverviewDto.fromJS(resultData200)
            : new PagedResultDtoOfCourseOverviewDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDtoOfCourseOverviewDto>(<any>null);
  }

  /**
   * @param instructorId (optional)
   * @param keywords (optional)
   * @param levelOfDifficulty (optional)
   * @param progress (optional)
   * @param bookmarked (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getInstructorCourseClassesCount(
    instructorId: number | null | undefined,
    keywords: string[] | null | undefined,
    levelOfDifficulty: LevelOfDifficulty2 | null | undefined,
    progress: Progress3 | null | undefined,
    bookmarked: boolean | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<number> {
    let url_ =
      this.baseUrl +
      '/api/services/app/Course/GetInstructorCourseClassesCount?';
    if (instructorId !== undefined)
      url_ += 'InstructorId=' + encodeURIComponent('' + instructorId) + '&';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (levelOfDifficulty !== undefined)
      url_ +=
        'LevelOfDifficulty=' + encodeURIComponent('' + levelOfDifficulty) + '&';
    if (progress !== undefined)
      url_ += 'Progress=' + encodeURIComponent('' + progress) + '&';
    if (bookmarked !== undefined)
      url_ += 'Bookmarked=' + encodeURIComponent('' + bookmarked) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInstructorCourseClassesCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInstructorCourseClassesCount(
                <any>response_
              );
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetInstructorCourseClassesCount(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @param instructorId (optional)
   * @param keywords (optional)
   * @param levelOfDifficulty (optional)
   * @param progress (optional)
   * @param bookmarked (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getInstructorCourseClasses(
    instructorId: number | null | undefined,
    keywords: string[] | null | undefined,
    levelOfDifficulty: LevelOfDifficulty3 | null | undefined,
    progress: Progress4 | null | undefined,
    bookmarked: boolean | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<PagedResultDtoOfCourseOverviewDto> {
    let url_ =
      this.baseUrl + '/api/services/app/Course/GetInstructorCourseClasses?';
    if (instructorId !== undefined)
      url_ += 'InstructorId=' + encodeURIComponent('' + instructorId) + '&';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (levelOfDifficulty !== undefined)
      url_ +=
        'LevelOfDifficulty=' + encodeURIComponent('' + levelOfDifficulty) + '&';
    if (progress !== undefined)
      url_ += 'Progress=' + encodeURIComponent('' + progress) + '&';
    if (bookmarked !== undefined)
      url_ += 'Bookmarked=' + encodeURIComponent('' + bookmarked) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInstructorCourseClasses(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInstructorCourseClasses(<any>response_);
            } catch (e) {
              return <Observable<PagedResultDtoOfCourseOverviewDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PagedResultDtoOfCourseOverviewDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetInstructorCourseClasses(
    response: HttpResponseBase
  ): Observable<PagedResultDtoOfCourseOverviewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);

          result200 = resultData200
            ? PagedResultDtoOfCourseOverviewDto.fromJS(resultData200)
            : new PagedResultDtoOfCourseOverviewDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDtoOfCourseOverviewDto>(<any>null);
  }

  /**
   * @param keywords (optional)
   * @param isPublished (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAllCourses(
    keywords: string[] | null | undefined,
    isPublished: boolean | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<PagedResultDtoOfCourseMainInfoDto> {
    let url_ = this.baseUrl + '/api/services/app/Course/GetAllCourses?';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (isPublished !== undefined)
      url_ += 'IsPublished=' + encodeURIComponent('' + isPublished) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllCourses(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllCourses(<any>response_);
            } catch (e) {
              return <Observable<PagedResultDtoOfCourseMainInfoDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PagedResultDtoOfCourseMainInfoDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllCourses(
    response: HttpResponseBase
  ): Observable<PagedResultDtoOfCourseMainInfoDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? PagedResultDtoOfCourseMainInfoDto.fromJS(resultData200)
            : new PagedResultDtoOfCourseMainInfoDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDtoOfCourseMainInfoDto>(<any>null);
  }

  /**
   * @param keywords (optional)
   * @param isPublished (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAllFilteredCoursesCount(
    keywords: string[] | null | undefined,
    isPublished: boolean | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<number> {
    let url_ =
      this.baseUrl + '/api/services/app/Course/GetAllFilteredCoursesCount?';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (isPublished !== undefined)
      url_ += 'IsPublished=' + encodeURIComponent('' + isPublished) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllFilteredCoursesCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllFilteredCoursesCount(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllFilteredCoursesCount(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @param courseId (optional)
   * @return Success
   */
  getCourseForEdit(
    courseId: number | null | undefined
  ): Observable<CourseForEditDto> {
    let url_ = this.baseUrl + '/api/services/app/Course/GetCourseForEdit?';
    if (courseId !== undefined)
      url_ += 'courseId=' + encodeURIComponent('' + courseId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCourseForEdit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCourseForEdit(<any>response_);
            } catch (e) {
              return <Observable<CourseForEditDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<CourseForEditDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCourseForEdit(
    response: HttpResponseBase
  ): Observable<CourseForEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? CourseForEditDto.fromJS(resultData200)
            : new CourseForEditDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CourseForEditDto>(<any>null);
  }

  /**
   * @param createCourseDto (optional)
   * @return Success
   */
  createCourse(
    createCourseDto: CreateCourseDto | null | undefined
  ): Observable<CourseForEditDto> {
    let url_ = this.baseUrl + '/api/services/app/Course/CreateCourse';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createCourseDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateCourse(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateCourse(<any>response_);
            } catch (e) {
              return <Observable<CourseForEditDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<CourseForEditDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processCreateCourse(
    response: HttpResponseBase
  ): Observable<CourseForEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? CourseForEditDto.fromJS(resultData200)
            : new CourseForEditDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CourseForEditDto>(<any>null);
  }

  /**
   * @param updateCourseStatusDto (optional)
   * @return Success
   */
  updateCourseStatus(
    updateCourseStatusDto: UpdateCourseStatusDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Course/UpdateCourseStatus';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateCourseStatusDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCourseStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCourseStatus(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateCourseStatus(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param updateCourseDto (optional)
   * @return Success
   */
  updateCourse(
    updateCourseDto: UpdateCourseDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Course/UpdateCourse';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(updateCourseDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCourse(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCourse(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateCourse(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param courseId (optional)
   * @return Success
   */
  deleteCourse(courseId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Course/DeleteCourse?';
    if (courseId !== undefined)
      url_ += 'courseId=' + encodeURIComponent('' + courseId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteCourse(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteCourse(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteCourse(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param courseId (optional)
   * @return Success
   */
  getCourseAssociation(
    courseId: number | null | undefined
  ): Observable<CourseClassAssociationDto[]> {
    let url_ = this.baseUrl + '/api/services/app/Course/GetCourseAssociation?';
    if (courseId !== undefined)
      url_ += 'courseId=' + encodeURIComponent('' + courseId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCourseAssociation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCourseAssociation(<any>response_);
            } catch (e) {
              return <Observable<CourseClassAssociationDto[]>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<CourseClassAssociationDto[]>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCourseAssociation(
    response: HttpResponseBase
  ): Observable<CourseClassAssociationDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
            result200 = [];
            for (let item of resultData200)
              result200.push(CourseClassAssociationDto.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CourseClassAssociationDto[]>(<any>null);
  }

  /**
   * @param associateCourseDto (optional)
   * @return Success
   */
  createOrUpdateCourseAssociation(
    associateCourseDto: AssociateCourseDto | null | undefined
  ): Observable<void> {
    let url_ =
      this.baseUrl + '/api/services/app/Course/CreateOrUpdateCourseAssociation';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(associateCourseDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateOrUpdateCourseAssociation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateOrUpdateCourseAssociation(
                <any>response_
              );
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateOrUpdateCourseAssociation(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param courseId Course ID
   * @param command Save SCORM progress command
   * @return Success
   */
  saveScormProgress(
    courseId: number,
    command: SaveScormProgressCommand
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/Course/{courseId}/scorm-progress';
    if (courseId === undefined || courseId === null)
      throw new Error("The parameter 'courseId' must be defined.");
    url_ = url_.replace('{courseId}', encodeURIComponent('' + courseId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(command);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSaveScormProgress(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSaveScormProgress(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<void>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processSaveScormProgress(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param courseId Course ID
   * @return Success
   */
  getScormProgress(courseId: number): Observable<ScormProgressDto | null> {
    let url_ = this.baseUrl + '/api/Course/{courseId}/scorm-progress';
    if (courseId === undefined || courseId === null)
      throw new Error("The parameter 'courseId' must be defined.");
    url_ = url_.replace('{courseId}', encodeURIComponent('' + courseId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetScormProgress(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetScormProgress(<any>response_);
            } catch (e) {
              return <Observable<ScormProgressDto | null>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ScormProgressDto | null>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetScormProgress(
    response: HttpResponseBase
  ): Observable<ScormProgressDto | null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ScormProgressDto.fromJS(resultData200)
            : null;
          return _observableOf(result200);
        })
      );
    } else if (status === 204) {
      return _observableOf<ScormProgressDto | null>(null);
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ScormProgressDto | null>(null);
  }
}

@Injectable()
export class ImagesMigrationServiceServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @return Success
   */
  migrateAllImagesToBlob(): Observable<void> {
    let url_ =
      this.baseUrl +
      '/api/services/app/ImagesMigrationService/MigrateAllImagesToBlob';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMigrateAllImagesToBlob(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMigrateAllImagesToBlob(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMigrateAllImagesToBlob(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

@Injectable()
export class InstitutionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @return Success
   */
  downloadCsv(): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Institution/DownloadCsv';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownloadCsv(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownloadCsv(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDownloadCsv(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param institutionDto (optional)
   * @return Success
   */
  createInstitution(
    institutionDto: CreateInstitutionDto | null | undefined
  ): Observable<InstitutionDto> {
    let url_ = this.baseUrl + '/api/services/app/Institution/CreateInstitution';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: institutionDto,
      observe: 'response',
      responseType: 'blob',
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateInstitution(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateInstitution(<any>response_);
            } catch (e) {
              return <Observable<InstitutionDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<InstitutionDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processCreateInstitution(
    response: HttpResponseBase
  ): Observable<InstitutionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? InstitutionDto.fromJS(resultData200)
            : new InstitutionDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<InstitutionDto>(<any>null);
  }

  /**
   * @param institutionDto (optional)
   * @return Success
   */
  updateInstitution(
    institutionDto: UpdateInstitutionDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Institution/UpdateInstitution';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(institutionDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateInstitution(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateInstitution(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateInstitution(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param institutionId (optional)
   * @param name (optional)
   * @return Success
   */
  checkInstitutionNameExists(
    institutionId: number | null | undefined,
    name: string | null | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl +
      '/api/services/app/Institution/CheckInstitutionNameExists?';
    if (institutionId !== undefined)
      url_ += 'InstitutionId=' + encodeURIComponent('' + institutionId) + '&';
    if (name !== undefined)
      url_ += 'Name=' + encodeURIComponent('' + name) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckInstitutionNameExists(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckInstitutionNameExists(<any>response_);
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCheckInstitutionNameExists(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }

  /**
   * @param institutionDto (optional)
   * @return Success
   */
  updateInstitutionStatus(
    institutionDto: UpdateInstitutionStatusDto | null | undefined
  ): Observable<void> {
    let url_ =
      this.baseUrl + '/api/services/app/Institution/UpdateInstitutionStatus';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(institutionDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateInstitutionStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateInstitutionStatus(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateInstitutionStatus(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param institutionId (optional)
   * @return Success
   */
  deleteInstitution(
    institutionId: number | null | undefined
  ): Observable<void> {
    let url_ =
      this.baseUrl + '/api/services/app/Institution/DeleteInstitution?';
    if (institutionId !== undefined)
      url_ += 'institutionId=' + encodeURIComponent('' + institutionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteInstitution(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteInstitution(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteInstitution(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param itemsOnPage (optional)
   * @param page (optional)
   * @param keywords (optional)
   * @param isActive (optional)
   * @return Success
   */
  countFilteredInstitutions(
    itemsOnPage: number | null | undefined,
    page: number | null | undefined,
    keywords: string[] | null | undefined,
    isActive: boolean | null | undefined
  ): Observable<number> {
    let url_ =
      this.baseUrl + '/api/services/app/Institution/CountFilteredInstitutions?';
    if (itemsOnPage !== undefined)
      url_ += 'ItemsOnPage=' + encodeURIComponent('' + itemsOnPage) + '&';
    if (page !== undefined)
      url_ += 'Page=' + encodeURIComponent('' + page) + '&';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (isActive !== undefined)
      url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCountFilteredInstitutions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCountFilteredInstitutions(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCountFilteredInstitutions(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @param itemsOnPage (optional)
   * @param page (optional)
   * @param keywords (optional)
   * @param isActive (optional)
   * @return Success
   */
  getInstitutions(
    itemsOnPage: number | null | undefined,
    page: number | null | undefined,
    keywords: string[] | null | undefined,
    isActive: boolean | null | undefined
  ): Observable<GetInstitutionsResponseDto> {
    let url_ = this.baseUrl + '/api/services/app/Institution/GetInstitutions?';
    if (itemsOnPage !== undefined)
      url_ += 'ItemsOnPage=' + encodeURIComponent('' + itemsOnPage) + '&';
    if (page !== undefined)
      url_ += 'Page=' + encodeURIComponent('' + page) + '&';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (isActive !== undefined)
      url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInstitutions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInstitutions(<any>response_);
            } catch (e) {
              return <Observable<GetInstitutionsResponseDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<GetInstitutionsResponseDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetInstitutions(
    response: HttpResponseBase
  ): Observable<GetInstitutionsResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? GetInstitutionsResponseDto.fromJS(resultData200)
            : new GetInstitutionsResponseDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetInstitutionsResponseDto>(<any>null);
  }

  /**
   * @param institutionId (optional)
   * @return Success
   */
  getInstitutionById(
    institutionId: number | null | undefined
  ): Observable<InstitutionDto> {
    let url_ =
      this.baseUrl + '/api/services/app/Institution/GetInstitutionById?';
    if (institutionId !== undefined)
      url_ += 'institutionId=' + encodeURIComponent('' + institutionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInstitutionById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInstitutionById(<any>response_);
            } catch (e) {
              return <Observable<InstitutionDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<InstitutionDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetInstitutionById(
    response: HttpResponseBase
  ): Observable<InstitutionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? InstitutionDto.fromJS(resultData200)
            : new InstitutionDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<InstitutionDto>(<any>null);
  }

  /**
   * @param keywords (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getInstitutionNames(
    keywords: string[] | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<PagedResultDtoOfGetInstitutionsNameResponseDto> {
    let url_ =
      this.baseUrl + '/api/services/app/Institution/GetInstitutionNames?';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInstitutionNames(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInstitutionNames(<any>response_);
            } catch (e) {
              return <
                Observable<PagedResultDtoOfGetInstitutionsNameResponseDto>
              >(<any>_observableThrow(e));
            }
          } else
            return <Observable<PagedResultDtoOfGetInstitutionsNameResponseDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetInstitutionNames(
    response: HttpResponseBase
  ): Observable<PagedResultDtoOfGetInstitutionsNameResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? PagedResultDtoOfGetInstitutionsNameResponseDto.fromJS(
                resultData200
              )
            : new PagedResultDtoOfGetInstitutionsNameResponseDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDtoOfGetInstitutionsNameResponseDto>(
      <any>null
    );
  }
}

@Injectable()
export class InstructorServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @param userId (optional)
   * @return Success
   */
  getIstructorPreviewInfo(
    userId: number | null | undefined
  ): Observable<InstructorPreviewDto> {
    let url_ =
      this.baseUrl + '/api/services/app/Instructor/GetIstructorPreviewInfo?';
    if (userId !== undefined)
      url_ += 'id=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetIstructorPreviewInfo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetIstructorPreviewInfo(<any>response_);
            } catch (e) {
              return <Observable<InstructorPreviewDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<InstructorPreviewDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetIstructorPreviewInfo(
    response: HttpResponseBase
  ): Observable<InstructorPreviewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? InstructorPreviewDto.fromJS(resultData200)
            : new InstructorPreviewDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<InstructorPreviewDto>(<any>null);
  }

  /**
   * @param userId (optional)
   * @return Success
   */
  getInstructorProfile(
    userId: number | null | undefined
  ): Observable<InstructorProfileDto> {
    let url_ =
      this.baseUrl + '/api/services/app/Instructor/GetInstructorProfile?';
    if (userId !== undefined)
      url_ += 'id=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInstructorProfile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInstructorProfile(<any>response_);
            } catch (e) {
              return <Observable<InstructorProfileDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<InstructorProfileDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetInstructorProfile(
    response: HttpResponseBase
  ): Observable<InstructorProfileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? InstructorProfileDto.fromJS(resultData200)
            : new InstructorProfileDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<InstructorProfileDto>(<any>null);
  }

  /**
   * @param userId (optional)
   * @return Success
   */
  getInstructorFullImage(
    userId: number | null | undefined
  ): Observable<string> {
    let url_ =
      this.baseUrl + '/api/services/app/Instructor/GetInstructorFullImage?';
    if (userId !== undefined)
      url_ += 'id=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInstructorFullImage(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInstructorFullImage(<any>response_);
            } catch (e) {
              return <Observable<string>>(<any>_observableThrow(e));
            }
          } else return <Observable<string>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetInstructorFullImage(
    response: HttpResponseBase
  ): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(<any>null);
  }

  /**
   * @return Success
   */
  getInstructorNames(): Observable<InstructorNameDto[]> {
    let url_ = this.baseUrl + '/api/services/app/Instructor/GetInstructorNames';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInstructorNames(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInstructorNames(<any>response_);
            } catch (e) {
              return <Observable<InstructorNameDto[]>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<InstructorNameDto[]>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetInstructorNames(
    response: HttpResponseBase
  ): Observable<InstructorNameDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
            result200 = [];
            for (let item of resultData200)
              result200.push(InstructorNameDto.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<InstructorNameDto[]>(<any>null);
  }

  /**
   * @param keywords (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAllInstructorsFilteredCount(
    keywords: string[] | null | undefined,
    isActive: boolean | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<number> {
    let url_ =
      this.baseUrl +
      '/api/services/app/Instructor/GetAllInstructorsFilteredCount?';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (isActive !== undefined)
      url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllInstructorsFilteredCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllInstructorsFilteredCount(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllInstructorsFilteredCount(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @param keywords (optional)
   * @param isActive (optional)
   * @param pageNumber
   * @param maxResultCount (optional)
   * @param sortType
   * @param sortField
   * @return Success
   */
  getAllInstructors(
      keywords: string[] | null | undefined,
      isActive: boolean | null | undefined,
      pageNumber: number | null | undefined,
      maxResultCount: number | null | undefined,
      sortType?: any | null | undefined,
      sortField?: any | null | undefined
  ): Observable<PagedResultDtoOfInstructorMainInfoDto> {
    let url_ = this.baseUrl + '/api/services/app/Instructor/GetAllInstructors?';

    if (sortType) {
      switch (sortType) {
        case 'fullName': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 0) + '&';
          break;
        }
        case 'courses': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 2) + '&';
          break;
        }
        case 'classes': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 3) + '&';
          break;
        }
        case 'status': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 4) + '&';
          break;
        }
        case 'lastModified': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 5) + '&';
          break;
        }
      }
    }
    if (sortField !== undefined) {
      if (sortField === 'asc') {
        url_ += 'Sort.IsAsc=' + encodeURIComponent('' + true) + '&';
      } else {
        url_ += 'Sort.IsAsc=' + encodeURIComponent('' + false) + '&';
      }
    }

    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (isActive !== undefined)
      url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
    if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllInstructors(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllInstructors(<any>response_);
            } catch (e) {
              return <Observable<PagedResultDtoOfInstructorMainInfoDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PagedResultDtoOfInstructorMainInfoDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllInstructors(
    response: HttpResponseBase
  ): Observable<PagedResultDtoOfInstructorMainInfoDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? PagedResultDtoOfInstructorMainInfoDto.fromJS(resultData200)
            : new PagedResultDtoOfInstructorMainInfoDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDtoOfInstructorMainInfoDto>(<any>null);
  }

  /**
   * @param createInstructorDto (optional)
   * @return Success
   */
  createInstructor(
    createInstructorDto: ICreateInstructorDto | null | undefined
  ): Observable<InstructorProfileDto> {
    let url_ = this.baseUrl + '/api/services/app/Instructor/CreateInstructor';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: createInstructorDto,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateInstructor(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateInstructor(<any>response_);
            } catch (e) {
              return <Observable<InstructorProfileDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<InstructorProfileDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processCreateInstructor(
    response: HttpResponseBase
  ): Observable<InstructorProfileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? InstructorProfileDto.fromJS(resultData200)
            : new InstructorProfileDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<InstructorProfileDto>(<any>null);
  }

  /**
   * @param updateInstructorDto (optional)
   * @return Success
   */
  updateInstructor(
    updateInstructorDto: any | null | undefined
  ): Observable<InstructorProfileDto> {
    let url_ = this.baseUrl + '/api/services/app/Instructor/UpdateInstructor';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: updateInstructorDto,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateInstructor(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateInstructor(<any>response_);
            } catch (e) {
              return <Observable<InstructorProfileDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<InstructorProfileDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processUpdateInstructor(
    response: HttpResponseBase
  ): Observable<InstructorProfileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? InstructorProfileDto.fromJS(resultData200)
            : new InstructorProfileDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<InstructorProfileDto>(<any>null);
  }

  /**
   * @param updateInstructorStatusDto (optional)
   * @return Success
   */
  updateInstructorStatus(
    updateInstructorStatusDto:
      | { id: number; isActive: boolean }
      | null
      | undefined
  ): Observable<void> {
    let url_ =
      this.baseUrl + '/api/services/app/Instructor/UpdateInstructorStatus';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: updateInstructorStatusDto,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateInstructorStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateInstructorStatus(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateInstructorStatus(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param instructorId (optional)
   * @return Success
   */
  deleteInstructor(instructorId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Instructor/DeleteInstructor?';
    if (instructorId !== undefined)
      url_ += 'id=' + encodeURIComponent('' + instructorId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteInstructor(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteInstructor(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteInstructor(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param instructorId (optional)
   * @return Success
   */
  getInstructorById(
    instructorId: number | null | undefined
  ): Observable<InstructorForEditDto> {
    let url_ = this.baseUrl + '/api/services/app/Instructor/GetInstructorById?';
    if (instructorId !== undefined)
      url_ += 'id=' + encodeURIComponent('' + instructorId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInstructorById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInstructorById(<any>response_);
            } catch (e) {
              return <Observable<InstructorForEditDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<InstructorForEditDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetInstructorById(
    response: HttpResponseBase
  ): Observable<InstructorForEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? InstructorForEditDto.fromJS(resultData200)
            : new InstructorForEditDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<InstructorForEditDto>(<any>null);
  }
}

@Injectable()
export class MaterialServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @param classId (optional)
   * @return Success
   */
  getClassMaterial(
    classId: number | null | undefined
  ): Observable<MaterialDto[]> {
    let url_ = this.baseUrl + '/api/services/app/Material/GetClassMaterial?';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClassMaterial(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClassMaterial(<any>response_);
            } catch (e) {
              return <Observable<MaterialDto[]>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<MaterialDto[]>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetClassMaterial(
    response: HttpResponseBase
  ): Observable<MaterialDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
            result200 = [];
            for (let item of resultData200)
              result200.push(MaterialDto.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<MaterialDto[]>(<any>null);
  }

  /**
   * @param courseId (optional)
   * @return Success
   */
  getCourseMaterial(
    courseId: number | null | undefined
  ): Observable<MaterialDto[]> {
    let url_ = this.baseUrl + '/api/services/app/Material/GetCourseMaterial?';
    if (courseId !== undefined)
      url_ += 'courseId=' + encodeURIComponent('' + courseId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCourseMaterial(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCourseMaterial(<any>response_);
            } catch (e) {
              return <Observable<MaterialDto[]>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<MaterialDto[]>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCourseMaterial(
    response: HttpResponseBase
  ): Observable<MaterialDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
            result200 = [];
            for (let item of resultData200)
              result200.push(MaterialDto.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<MaterialDto[]>(<any>null);
  }

  /**
   * @param instructorId (optional)
   * @return Success
   */
  getInstructorMaterial(
    instructorId: number | null | undefined
  ): Observable<MaterialDto[]> {
    let url_ =
      this.baseUrl + '/api/services/app/Material/GetInstructorMaterial?';
    if (instructorId !== undefined)
      url_ += 'instructorId=' + encodeURIComponent('' + instructorId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetInstructorMaterial(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetInstructorMaterial(<any>response_);
            } catch (e) {
              return <Observable<MaterialDto[]>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<MaterialDto[]>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetInstructorMaterial(
    response: HttpResponseBase
  ): Observable<MaterialDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
            result200 = [];
            for (let item of resultData200)
              result200.push(MaterialDto.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<MaterialDto[]>(<any>null);
  }

  /**
   * @param classId (optional)
   * @param files (optional)
   * @return Success
   */
  uploadClassMaterial(
    classId: number | null | undefined,
    files: any[] | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Material/UploadClassMaterial?';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (files !== null && files !== undefined)
      content_.append('files', files.toString());

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadClassMaterial(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadClassMaterial(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUploadClassMaterial(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param courseId (optional)
   * @param files (optional)
   * @return Success
   */
  uploadCourseMaterial(
    courseId: number | null | undefined,
    files: any[] | null | undefined
  ): Observable<void> {
    let url_ =
      this.baseUrl + '/api/services/app/Material/UploadCourseMaterial?';
    if (courseId !== undefined)
      url_ += 'courseId=' + encodeURIComponent('' + courseId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (files !== null && files !== undefined)
      content_.append('files', files.toString());

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadCourseMaterial(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadCourseMaterial(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUploadCourseMaterial(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param instructorId (optional)
   * @param file (optional)
   * @return Success
   */
  uploadInstructorMaterial(
    instructorId: number | null | undefined,
    file: any[] | null | undefined
  ): Observable<void> {
    let url_ =
      this.baseUrl + '/api/services/app/Material/UploadInstructorMaterial?';
    if (instructorId !== undefined)
      url_ += 'instructorId=' + encodeURIComponent('' + instructorId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file !== null && file !== undefined)
      content_.append('file', file.toString());

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadInstructorMaterial(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadInstructorMaterial(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUploadInstructorMaterial(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param parameters (optional)
   * @return Success
   */
  updateMaterialDescription(
    parameters: UpdateMaterialDescriptionDto | null | undefined
  ): Observable<void> {
    let url_ =
      this.baseUrl + '/api/services/app/Material/UpdateMaterialDescription';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(parameters);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateMaterialDescription(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateMaterialDescription(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateMaterialDescription(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param instructorFileId (optional)
   * @return Success
   */
  deleteInstructorFile(
    instructorFileId: number | null | undefined
  ): Observable<void> {
    let url_ =
      this.baseUrl + '/api/services/app/Material/DeleteInstructorFile?';
    if (instructorFileId !== undefined)
      url_ +=
        'instructorFileId=' + encodeURIComponent('' + instructorFileId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteInstructorFile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteInstructorFile(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteInstructorFile(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param materialId (optional)
   * @return Success
   */
  deleteMaterial(materialId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Material/DeleteMaterial?';
    if (materialId !== undefined)
      url_ += 'materialId=' + encodeURIComponent('' + materialId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteMaterial(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteMaterial(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteMaterial(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

@Injectable()
export class ProgramServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  getTenantByInstIds(arrayValues: any) {
    let url_ = this.baseUrl + '/api/services/app/Tenant/GetTenantsByInstitutionIds';

    if (arrayValues.length > 0) {
      url_ += '?'
      arrayValues.forEach(item => {
        url_ += `institutionIds=${item}&`;
      })
    }

    return this.http.get(url_);
  }

  /**
   * @return Success
   */
  getPrograms(): Observable<ListResultDtoOfProgramOverviewDto> {
    let url_ = this.baseUrl + '/api/services/app/Program/GetPrograms';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPrograms(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPrograms(<any>response_);
            } catch (e) {
              return <Observable<ListResultDtoOfProgramOverviewDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ListResultDtoOfProgramOverviewDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetPrograms(
    response: HttpResponseBase
  ): Observable<ListResultDtoOfProgramOverviewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ListResultDtoOfProgramOverviewDto.fromJS(resultData200)
            : new ListResultDtoOfProgramOverviewDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ListResultDtoOfProgramOverviewDto>(<any>null);
  }

  /**
   * @param keywords (optional)
   * @param isActive (optional)
   * @param access (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAllPrograms(
    keywords: string[] | null | undefined,
    isActive: boolean | null | undefined,
    access: Access | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<PagedResultDtoOfPagedProgramsResponseDto> {
    let url_ = this.baseUrl + '/api/services/app/Program/GetAllPrograms?';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (isActive !== undefined)
      url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
    if (access !== undefined)
      url_ += 'Access=' + encodeURIComponent('' + access) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPrograms(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPrograms(<any>response_);
            } catch (e) {
              return <Observable<PagedResultDtoOfPagedProgramsResponseDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PagedResultDtoOfPagedProgramsResponseDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllPrograms(
    response: HttpResponseBase
  ): Observable<PagedResultDtoOfPagedProgramsResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? PagedResultDtoOfPagedProgramsResponseDto.fromJS(resultData200)
            : new PagedResultDtoOfPagedProgramsResponseDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDtoOfPagedProgramsResponseDto>(<any>null);
  }

  /**
   * @param keywords (optional)
   * @param isActive (optional)
   * @param access (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAllFilteredProgramsCount(
    keywords: string[] | null | undefined,
    isActive: boolean | null | undefined,
    access: Access2 | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<number> {
    let url_ =
      this.baseUrl + '/api/services/app/Program/GetAllFilteredProgramsCount?';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (isActive !== undefined)
      url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
    if (access !== undefined)
      url_ += 'Access=' + encodeURIComponent('' + access) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllFilteredProgramsCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllFilteredProgramsCount(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllFilteredProgramsCount(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @param createProgramDto (optional)
   * @return Success
   */
  createProgram(
    createProgramDto: CreateProgramDto | null | undefined
  ): Observable<ProgramResponseDto> {
    let url_ = this.baseUrl + '/api/services/app/Program/CreateProgram';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(createProgramDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateProgram(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateProgram(<any>response_);
            } catch (e) {
              return <Observable<ProgramResponseDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ProgramResponseDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processCreateProgram(
    response: HttpResponseBase
  ): Observable<ProgramResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ProgramResponseDto.fromJS(resultData200)
            : new ProgramResponseDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProgramResponseDto>(<any>null);
  }

  /**
   * @param programId (optional)
   * @param name (optional)
   * @return Success
   */
  checkProgramNameExists(
    programId: number | null | undefined,
    name: string | null | undefined
  ): Observable<boolean> {
    let url_ =
      this.baseUrl + '/api/services/app/Program/CheckProgramNameExists?';
    if (programId !== undefined)
      url_ += 'ProgramId=' + encodeURIComponent('' + programId) + '&';
    if (name !== undefined)
      url_ += 'Name=' + encodeURIComponent('' + name) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckProgramNameExists(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckProgramNameExists(<any>response_);
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCheckProgramNameExists(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }

  /**
   * @param programId (optional)
   * @return Success
   */
  getProgramById(
    programId: number | null | undefined
  ): Observable<ProgramResponseDto> {
    let url_ = this.baseUrl + '/api/services/app/Program/GetProgramById?';
    if (programId !== undefined)
      url_ += 'programId=' + encodeURIComponent('' + programId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProgramById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProgramById(<any>response_);
            } catch (e) {
              return <Observable<ProgramResponseDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ProgramResponseDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetProgramById(
    response: HttpResponseBase
  ): Observable<ProgramResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ProgramResponseDto.fromJS(resultData200)
            : new ProgramResponseDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProgramResponseDto>(<any>null);
  }

  /**
   * @param programDto (optional)
   * @return Success
   */
  updateProgram(
    programDto: UpdateProgramDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Program/UpdateProgram';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(programDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateProgram(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateProgram(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateProgram(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  updateProgramStatus(
    input: UpdateProgramStatusDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Program/UpdateProgramStatus';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(input);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateProgramStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateProgramStatus(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateProgramStatus(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param programId (optional)
   * @return Success
   */
  deleteProgram(programId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Program/DeleteProgram?';
    if (programId !== undefined)
      url_ += 'programId=' + encodeURIComponent('' + programId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteProgram(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteProgram(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteProgram(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param reorderProgramsDto (optional)
   * @return Success
   */
  reorderPrograms(
    reorderProgramsDto: ProgramOrderDto[] | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Program/ReorderPrograms';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(reorderProgramsDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processReorderPrograms(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processReorderPrograms(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processReorderPrograms(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param programId (optional)
   * @return Success
   */
  getProgramAssociation(
    programId: number | null | undefined
  ): Observable<ProgramAssociationDto[]> {
    let url_ =
      this.baseUrl + '/api/services/app/Program/GetProgramAssociation?';
    if (programId !== undefined)
      url_ += 'programId=' + encodeURIComponent('' + programId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProgramAssociation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProgramAssociation(<any>response_);
            } catch (e) {
              return <Observable<ProgramAssociationDto[]>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ProgramAssociationDto[]>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetProgramAssociation(
    response: HttpResponseBase
  ): Observable<ProgramAssociationDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
            result200 = [];
            for (let item of resultData200)
              result200.push(ProgramAssociationDto.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProgramAssociationDto[]>(<any>null);
  }

  /**
   * @param associateProgramDto (optional)
   * @return Success
   */
  createOrUpdateProgramAssociation(
    associateProgramDto: AssociateProgramDto | null | undefined
  ): Observable<void> {
    let url_ =
      this.baseUrl +
      '/api/services/app/Program/CreateOrUpdateProgramAssociation';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(associateProgramDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateOrUpdateProgramAssociation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateOrUpdateProgramAssociation(
                <any>response_
              );
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreateOrUpdateProgramAssociation(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

@Injectable()
export class QuizServiceProxy {
  private http: HttpClient;
  private baseUrl: string;

  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @param contentType (optional)
   * @param contentDisposition (optional)
   * @param headers (optional)
   * @param length (optional)
   * @param name (optional)
   * @param fileName (optional)
   * @param classId (optional)
   * @return Success
   */
  importQuiz(
    contentType: string | null | undefined,
    contentDisposition: string | null | undefined,
    headers: any | null | undefined,
    length: number | null | undefined,
    name: string | null | undefined,
    fileName: string | null | undefined,
    classId: number | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Quiz/ImportQuiz?';
    if (contentType !== undefined)
      url_ += 'ContentType=' + encodeURIComponent('' + contentType) + '&';
    if (contentDisposition !== undefined)
      url_ +=
        'ContentDisposition=' +
        encodeURIComponent('' + contentDisposition) +
        '&';
    if (headers !== undefined)
      url_ += 'Headers=' + encodeURIComponent('' + headers) + '&';
    if (length !== undefined)
      url_ += 'Length=' + encodeURIComponent('' + length) + '&';
    if (name !== undefined)
      url_ += 'Name=' + encodeURIComponent('' + name) + '&';
    if (fileName !== undefined)
      url_ += 'FileName=' + encodeURIComponent('' + fileName) + '&';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processImportQuiz(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processImportQuiz(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  /**
   * @param impersonateTenantId (required)
   * @param startDate (required)
   * @param endDate (required)
   * @param quizFileType (required)
   * @return Success
   */
   downloadQuizResults(
    impersonateTenantId: number,
    startDate: string,
    endDate: string,
    quizFileType: number
  ): Observable<any> {
    let url_ = this.baseUrl + '/api/services/app/Quiz/DownloadQuizResults';

    const bodyParams: any = {
      ImpersonateTenantId: impersonateTenantId,
      StartDate: startDate,
      EndDate: endDate,
      QuizFileType: quizFileType,
    };

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .post(url_, bodyParams, options_)
      .pipe(
          _observableMergeMap((response_: any) => {
            return this.processDownloadQuizResult(response_);
          })
        )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownloadQuizResult(<any>response_);
            } catch (e) {
              return <Observable<HttpResponse<Blob>>>(<any>_observableThrow(e));
            }
          } else return <Observable<HttpResponse<Blob>>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDownloadQuizResult(response: HttpResponseBase): Observable<HttpResponse<Blob>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;
    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<HttpResponse<Blob>>(<any>response);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<HttpResponse<Blob>>(<any>null);
  }

  protected processImportQuiz(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param classId (optional)
   * @return Success
   */
  getClassQuiz(classId: number | null | undefined): Observable<QuizDto> {
    let url_ = this.baseUrl + '/api/services/app/Quiz/GetClassQuiz?';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClassQuiz(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClassQuiz(<any>response_);
            } catch (e) {
              return <Observable<QuizDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<QuizDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetClassQuiz(
    response: HttpResponseBase
  ): Observable<QuizDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? QuizDto.fromJS(resultData200)
            : new QuizDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<QuizDto>(<any>null);
  }

  /**
   * @param classId (optional)
   * @return Success
   */
  deleteQuizResults(classId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Quiz/DeleteQuizResults?';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteQuizResults(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteQuizResults(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteQuizResults(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param classId (optional)
   * @return Success
   */
  deleteQuiz(classId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Quiz/DeleteQuiz?';
    if (classId !== undefined)
      url_ += 'classId=' + encodeURIComponent('' + classId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteQuiz(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteQuiz(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDeleteQuiz(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param quizAnswersDto (optional)
   * @return Success
   */
  checkQuiz(
    quizAnswersDto: QuizAnswersDto | null | undefined
  ): Observable<QuizResultDto> {
    let url_ = this.baseUrl + '/api/services/app/Quiz/CheckQuiz';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: quizAnswersDto,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckQuiz(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckQuiz(<any>response_);
            } catch (e) {
              return <Observable<QuizResultDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<QuizResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processCheckQuiz(
    response: HttpResponseBase
  ): Observable<QuizResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? QuizResultDto.fromJS(resultData200)
            : new QuizResultDto();

          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<QuizResultDto>(<any>null);
  }

  /**
   * @param quizId (optional)
   * @return Success
   */
  getQuizResult(quizId: number | null | undefined): Observable<QuizResultDto> {
    let url_ = this.baseUrl + '/api/services/app/Quiz/GetQuizResult?';
    if (quizId !== undefined)
      url_ += 'quizId=' + encodeURIComponent('' + quizId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .get(url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetQuizResult(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetQuizResult(<any>response_);
            } catch (e) {
              return <Observable<QuizResultDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<QuizResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );

  }

  protected processGetQuizResult(
    response: HttpResponseBase
  ): Observable<QuizResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? QuizResultDto.fromJS(resultData200)
            : new QuizResultDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<QuizResultDto>(<any>null);
  }

  /**
   * @param quizId (optional)
   * @param userId (optional)
   * @param resultQuizId (optional)
   * @return Success
   */
  getUserQuizResult(
    quizId: number | null | undefined,
    userId: number | null | undefined,
    resultQuizId: number | null | undefined
  ): Observable<UserQuizResultDto> {
    let url_ = this.baseUrl + '/api/services/app/Quiz/GetUserQuizResult?';
    if (quizId !== undefined)
      url_ += 'quizId=' + encodeURIComponent('' + quizId) + '&';
    if (userId !== undefined)
      url_ += 'userId=' + encodeURIComponent('' + userId) + '&';

    if (resultQuizId !== undefined)
      url_ += 'resultQuizId=' + encodeURIComponent('' + resultQuizId) + '&';

    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserQuizResult(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserQuizResult(<any>response_);
            } catch (e) {
              return <Observable<UserQuizResultDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<UserQuizResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetUserQuizResult(
    response: HttpResponseBase
  ): Observable<UserQuizResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? UserQuizResultDto.fromJS(resultData200)
            : new UserQuizResultDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserQuizResultDto>(<any>null);
  }

  /**
   * @param keywords (optional)
   * @param pageNumber (optional)
   * @param maxResultCount (optional)
   * @param ImpersonateTenantId
   * @param sortType
   * @param sortField
   * @return Success
   */
  getClassQuizzes(
    keywords: string[] | null | undefined,
    pageNumber: number | null | undefined,
    maxResultCount: number | null | undefined,
    ImpersonateTenantId: number = null,
    sortType: any | null | undefined,
    sortField: any | null | undefined
  ): Observable<PagedResultDtoOfClassItemDto> {
    let url_ = this.baseUrl + '/api/services/app/Quiz/GetClassQuizzes?';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';

    switch (sortField) {
      case 'className': {
        url_ += 'Sort.Field=' + encodeURIComponent('' + 0) + '&';
        break;
      }
      case 'completed': {
        url_ += 'Sort.Field=' + encodeURIComponent('' + 1) + '&';
        break;
      }
      case 'averageScore': {
        url_ += 'Sort.Field=' + encodeURIComponent('' + 2) + '&';
        break;
      }
      case 'highestScore': {
        url_ += 'Sort.Field=' + encodeURIComponent('' + 3) + '&';
        break;
      }
      case 'lowestScore': {
        url_ += 'Sort.Field=' + encodeURIComponent('' + 4) + '&';
        break;
      }
    }
    if (sortType !== undefined) {
      if (sortType === 'asc') {
        url_ += 'Sort.IsAsc=' + encodeURIComponent('' + true) + '&';
      } else {
        url_ += 'Sort.IsAsc=' + encodeURIComponent('' + false) + '&';
      }
    }

    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (ImpersonateTenantId)
      url_ +=
        'ImpersonateTenantId=' +
        encodeURIComponent('' + ImpersonateTenantId) +
        '&';
    // url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGeClassQuizes(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGeClassQuizes(<any>response_);
            } catch (e) {
              return <Observable<PagedResultDtoOfClassItemDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PagedResultDtoOfClassItemDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGeClassQuizes(
    response: HttpResponseBase
  ): Observable<PagedResultDtoOfClassItemDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? PagedResultDtoOfClassItemDto.fromJS(resultData200)
            : new PagedResultDtoOfClassItemDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDtoOfClassItemDto>(<any>null);
  }

  /**
   * @param classId (optional)
   * @param keywords (optional)
   * @param pageNumber (optional)
   * @param maxResultCount (optional)
   * @param ImpersonateTenantId
   * @param sortType
   * @param sortField
   * @return Success
   */
  getClassQuizResults(
    classId: number | null | undefined,
    keywords: string[] | null | undefined,
    pageNumber: number | null | undefined,
    maxResultCount: number | null | undefined,
    ImpersonateTenantId: number = null,
    sortType: any | null | undefined,
    sortField: any | null | undefined
  ): Observable<ClassQuizResultDto> {
    let url_ = this.baseUrl + '/api/services/app/Quiz/GetClassQuizResults?';
    if (classId !== undefined)
      url_ += 'ClassId=' + encodeURIComponent('' + classId) + '&';

    switch (sortField) {
      case 'studentName': {
        url_ += 'Sort.Field=' + encodeURIComponent('' + 0) + '&';
        break;
      }
      case 'score': {
        url_ += 'Sort.Field=' + encodeURIComponent('' + 2) + '&';
        break;
      }
      case 'lastCompletion': {
        url_ += 'Sort.Field=' + encodeURIComponent('' + 3) + '&';
        break;
      }
      case 'classStartedDate': {
        url_ += 'Sort.Field=' + encodeURIComponent('' + 4) + '&';
        break;
      }
      case 'classCompletedDate': {
        url_ += 'Sort.Field=' + encodeURIComponent('' + 5) + '&';
        break;
      }
    }
    if (sortType !== undefined) {
      if (sortType === 'asc') {
        url_ += 'Sort.IsAsc=' + encodeURIComponent('' + true) + '&';
      } else {
        url_ += 'Sort.IsAsc=' + encodeURIComponent('' + false) + '&';
      }
    }


    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (ImpersonateTenantId)
      url_ +=
        'ImpersonateTenantId=' +
        encodeURIComponent('' + ImpersonateTenantId) +
        '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetClassQuizResults(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetClassQuizResults(<any>response_);
            } catch (e) {
              return <Observable<ClassQuizResultDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<ClassQuizResultDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetClassQuizResults(
    response: HttpResponseBase
  ): Observable<ClassQuizResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ClassQuizResultDto.fromJS(resultData200)
            : new ClassQuizResultDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ClassQuizResultDto>(<any>null);
  }
}

@Injectable()
export class RoleServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @param input (optional)
   * @return Success
   */
  create(input: CreateRoleDto | null | undefined): Observable<RoleDto> {
    let url_ = this.baseUrl + '/api/services/app/Role/Create';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(input);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(<any>response_);
            } catch (e) {
              return <Observable<RoleDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<RoleDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? RoleDto.fromJS(resultData200)
            : new RoleDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RoleDto>(<any>null);
  }

  /**
   * @param permission (optional)
   * @return Success
   */
  getRolesAsync(
    permission: string | null | undefined
  ): Observable<ListResultDtoOfRoleListDto> {
    let url_ = this.baseUrl + '/api/services/app/Role/GetRolesAsync?';
    if (permission !== undefined)
      url_ += 'Permission=' + encodeURIComponent('' + permission) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRolesAsync(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRolesAsync(<any>response_);
            } catch (e) {
              return <Observable<ListResultDtoOfRoleListDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ListResultDtoOfRoleListDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetRolesAsync(
    response: HttpResponseBase
  ): Observable<ListResultDtoOfRoleListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ListResultDtoOfRoleListDto.fromJS(resultData200)
            : new ListResultDtoOfRoleListDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ListResultDtoOfRoleListDto>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  update(input: RoleDto | null | undefined): Observable<RoleDto> {
    let url_ = this.baseUrl + '/api/services/app/Role/Update';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(input);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(<any>response_);
            } catch (e) {
              return <Observable<RoleDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<RoleDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? RoleDto.fromJS(resultData200)
            : new RoleDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RoleDto>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Role/Delete?';
    if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @return Success
   */
  getAllPermissions(): Observable<ListResultDtoOfPermissionDto> {
    let url_ = this.baseUrl + '/api/services/app/Role/GetAllPermissions';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPermissions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPermissions(<any>response_);
            } catch (e) {
              return <Observable<ListResultDtoOfPermissionDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ListResultDtoOfPermissionDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAllPermissions(
    response: HttpResponseBase
  ): Observable<ListResultDtoOfPermissionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ListResultDtoOfPermissionDto.fromJS(resultData200)
            : new ListResultDtoOfPermissionDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ListResultDtoOfPermissionDto>(<any>null);
  }

  /**
   * @param identityResult (optional)
   * @return Success
   */
  checkErrors(
    identityResult: IdentityResult | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Role/CheckErrors';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(identityResult);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckErrors(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckErrors(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCheckErrors(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getRoleForEdit(
    id: number | null | undefined
  ): Observable<GetRoleForEditOutput> {
    let url_ = this.baseUrl + '/api/services/app/Role/GetRoleForEdit?';
    if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRoleForEdit(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRoleForEdit(<any>response_);
            } catch (e) {
              return <Observable<GetRoleForEditOutput>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<GetRoleForEditOutput>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetRoleForEdit(
    response: HttpResponseBase
  ): Observable<GetRoleForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? GetRoleForEditOutput.fromJS(resultData200)
            : new GetRoleForEditOutput();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetRoleForEditOutput>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | null | undefined): Observable<RoleDto> {
    let url_ = this.baseUrl + '/api/services/app/Role/Get?';
    if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(<any>response_);
            } catch (e) {
              return <Observable<RoleDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<RoleDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<RoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? RoleDto.fromJS(resultData200)
            : new RoleDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RoleDto>(<any>null);
  }

  /**
   * @param keyword (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keyword: string | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<PagedResultDtoOfRoleDto> {
    let url_ = this.baseUrl + '/api/services/app/Role/GetAll?';
    if (keyword !== undefined)
      url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(<any>response_);
            } catch (e) {
              return <Observable<PagedResultDtoOfRoleDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PagedResultDtoOfRoleDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAll(
    response: HttpResponseBase
  ): Observable<PagedResultDtoOfRoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? PagedResultDtoOfRoleDto.fromJS(resultData200)
            : new PagedResultDtoOfRoleDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDtoOfRoleDto>(<any>null);
  }
}

@Injectable()
export class SessionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @param ImpersonateTenantId (optional)
   * @return Success
   */
  getCurrentLoginInformations(
    ImpersonateTenantId: number | null | undefined
  ): Observable<GetCurrentLoginInformationsOutput> {
    let url_ =
      this.baseUrl + '/api/services/app/Session/GetCurrentLoginInformation?';
    if (ImpersonateTenantId !== undefined)
      url_ +=
        'ImpersonateTenantId=' + encodeURIComponent('' + ImpersonateTenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCurrentLoginInformations(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCurrentLoginInformations(<any>response_);
            } catch (e) {
              return <Observable<GetCurrentLoginInformationsOutput>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<GetCurrentLoginInformationsOutput>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetCurrentLoginInformations(
    response: HttpResponseBase
  ): Observable<GetCurrentLoginInformationsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);

          result200 = resultData200
            ? GetCurrentLoginInformationsOutput.fromJS(resultData200)
            : new GetCurrentLoginInformationsOutput();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
  }
}

@Injectable()
export class TenantServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @param input (optional)
   * @return Success
   */
  create(input: CreateTenantDto | null | undefined): Observable<TenantDto> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/Create';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(input);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(<any>response_);
            } catch (e) {
              return <Observable<TenantDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<TenantDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? TenantDto.fromJS(resultData200)
            : new TenantDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TenantDto>(<any>null);
  }

  /**
   * @param keywords (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAllFilteredTenantsCount(
    keywords: string[] | null | undefined,
    isActive: boolean | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<number> {
    let url_ =
      this.baseUrl + '/api/services/app/Tenant/GetAllFilteredTenantsCount?';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (isActive !== undefined)
      url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllFilteredTenantsCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllFilteredTenantsCount(<any>response_);
            } catch (e) {
              return <Observable<number>>(<any>_observableThrow(e));
            }
          } else return <Observable<number>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetAllFilteredTenantsCount(
    response: HttpResponseBase
  ): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(<any>null);
  }

  /**
   * @param institutionId (optional)
   * @return Success
   */
  getByInstitution(
    institutionId: number | null | undefined
  ): Observable<TenantDto[]> {
    let url_ =
      this.baseUrl + '/api/services/app/Tenant/GetTenantsByInstitution?';
    if (institutionId !== undefined)
      url_ += 'InstitutionId=' + encodeURIComponent('' + institutionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetByInstitution(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetByInstitution(<any>response_);
            } catch (e) {
              return <Observable<TenantDto[]>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<TenantDto[]>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGetByInstitution(
    response: HttpResponseBase
  ): Observable<TenantDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
            result200 = [];
            for (let item of resultData200)
              result200.push(TenantDto.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TenantDto[]>(<any>null);
  }

  /**
   * @param keywords (optional)
   * @param isActive (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    keywords: string[] | null | undefined,
    isActive: boolean | null | undefined,
    skipCount: number | null | undefined,
    maxResultCount: number | null | undefined
  ): Observable<PagedResultDtoOfTenantDto> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/GetAll?';
    if (keywords !== undefined)
      keywords &&
        keywords.forEach((item) => {
          url_ += 'Keywords=' + encodeURIComponent('' + item) + '&';
        });
    if (isActive !== undefined)
      url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
    if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(<any>response_);
            } catch (e) {
              return <Observable<PagedResultDtoOfTenantDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PagedResultDtoOfTenantDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAll(
    response: HttpResponseBase
  ): Observable<PagedResultDtoOfTenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? PagedResultDtoOfTenantDto.fromJS(resultData200)
            : new PagedResultDtoOfTenantDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDtoOfTenantDto>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | null | undefined): Observable<TenantDto> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/Get?';
    if (id !== undefined)
      url_ += 'tenantId=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(<any>response_);
            } catch (e) {
              return <Observable<TenantDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<TenantDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<TenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? TenantDto.fromJS(resultData200)
            : new TenantDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TenantDto>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/Delete?';
    if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  updateStatus(
    input: UpdateTenantStatusDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/UpdateStatus';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(input);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateStatus(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateStatus(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  updateTenantName(
    input: UpdateTenantNameDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/UpdateTenantName';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = input;

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateTenantName(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateTenantName(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateTenantName(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  update(input: UpdateTenantDto | null | undefined): Observable<TenantDto> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/Update';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(input);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(<any>response_);
            } catch (e) {
              return <Observable<TenantDto>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<TenantDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? TenantDto.fromJS(resultData200)
            : new TenantDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TenantDto>(<any>null);
  }
}

@Injectable()
export class TokenAuthServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  /**
   * @return Success
   */
  googleAuthRequest(): Observable<GoogleAuthRequestDto> {
    let url_ = this.baseUrl + '/api/TokenAuth/GoogleAuthRequest';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGoogleAuthRequest(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGoogleAuthRequest(<any>response_);
            } catch (e) {
              return <Observable<GoogleAuthRequestDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<GoogleAuthRequestDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGoogleAuthRequest(
    response: HttpResponseBase
  ): Observable<GoogleAuthRequestDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? GoogleAuthRequestDto.fromJS(resultData200)
            : new GoogleAuthRequestDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GoogleAuthRequestDto>(<any>null);
  }

  /**
   * @return Success
   */
  googleAccessAuth(): Observable<void> {
    let url_ = this.baseUrl + '/api/TokenAuth/GoogleAccessAuth';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGoogleAccessAuth(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGoogleAccessAuth(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGoogleAccessAuth(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @return Success
   */
  getWhiteLabel(): Observable<InstitutionWhiteLabelDto> {
    let url_ = this.baseUrl + '/api/TokenAuth/GetWhiteLabel';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetWhiteLabel(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetWhiteLabel(<any>response_);
            } catch (e) {
              return <Observable<InstitutionWhiteLabelDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<InstitutionWhiteLabelDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetWhiteLabel(
    response: HttpResponseBase
  ): Observable<InstitutionWhiteLabelDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? InstitutionWhiteLabelDto.fromJS(resultData200)
            : new InstitutionWhiteLabelDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<InstitutionWhiteLabelDto>(<any>null);
  }

  /**
   * @param model (optional)
   * @return Success
   */
  authenticate(
    model: AuthenticateModel | null | undefined
  ): Observable<AuthenticateResultModel> {
    let url_ = this.baseUrl + '/api/TokenAuth/Authenticate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuthenticate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuthenticate(<any>response_);
            } catch (e) {
              return <Observable<AuthenticateResultModel>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<AuthenticateResultModel>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processAuthenticate(
    response: HttpResponseBase
  ): Observable<AuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? AuthenticateResultModel.fromJS(resultData200)
            : new AuthenticateResultModel();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AuthenticateResultModel>(<any>null);
  }

  /**
   * @return Success
   */
  getExternalAuthenticationProviders(): Observable<
    ExternalLoginProviderInfoModel[]
  > {
    let url_ =
      this.baseUrl + '/api/TokenAuth/GetExternalAuthenticationProviders';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetExternalAuthenticationProviders(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetExternalAuthenticationProviders(
                <any>response_
              );
            } catch (e) {
              return <Observable<ExternalLoginProviderInfoModel[]>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ExternalLoginProviderInfoModel[]>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetExternalAuthenticationProviders(
    response: HttpResponseBase
  ): Observable<ExternalLoginProviderInfoModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (resultData200 && resultData200.constructor === Array) {
            result200 = [];
            for (let item of resultData200)
              result200.push(ExternalLoginProviderInfoModel.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
  }

  /**
   * @param model (optional)
   * @return Success
   */
  externalAuthenticate(
    model: ExternalAuthenticateModel | null | undefined
  ): Observable<ExternalAuthenticateResultModel> {
    let url_ = this.baseUrl + '/api/TokenAuth/ExternalAuthenticate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processExternalAuthenticate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processExternalAuthenticate(<any>response_);
            } catch (e) {
              return <Observable<ExternalAuthenticateResultModel>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ExternalAuthenticateResultModel>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processExternalAuthenticate(
    response: HttpResponseBase
  ): Observable<ExternalAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ExternalAuthenticateResultModel.fromJS(resultData200)
            : new ExternalAuthenticateResultModel();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ExternalAuthenticateResultModel>(<any>null);
  }
}

@Injectable()
export class UserServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(
    private toastr: ToastrService,
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string,
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }

  handleError = (error: HttpErrorResponse) => {
    this.toastr.showError('An error occurred', error.error.error.message);
  };

    /**
   * @param userId (optional)
   * @param userEmailAddress (optional)
   * @return Success
   */
  public checkUserEmailExist = (
    userEmailAddress: string,
    userId?: number
  ): Subject<boolean> => {
    const subject = new Subject<boolean>();
    const params = {
      UserEmailAddress: userEmailAddress,
      UserId: String(userId)
    };

    if (!userId) {
      delete params.UserId;
    }

    this.http
      .get(
        this.baseUrl +
          '/api/services/app/User/CheckIsUserEmailExist',
        { params }
      )
      .subscribe(
        (response: { result: boolean }) => subject.next(response.result),
        this.handleError
      );

    return subject;
  };

  /**
   * @param forgotPasswordModel (optional)
   * @return Success
   */
  forgotPassword(
    userEmail: ForgotPasswordModel | { email: string } | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/User/ForgotPassword';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: userEmail,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processForgotPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processForgotPassword(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processForgotPassword(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let message = _getErrorMessage(_responseText);
          return throwException(message, status, _responseText, _headers);
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param resetPassworModel (optional)
   * @return Success
   */
  resetPassword(
    resetPassworModel: ResetPasswordModel | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/User/ResetPassword';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(resetPassworModel);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetPassword(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processResetPassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param activateUserDto (optional)
   * @return Success
   */
  activate(
    activateUserDto: ActivateUserDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/User/Activate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(activateUserDto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActivate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActivate(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processActivate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  create(userData: CreateUserDto | null | undefined): Observable<UserDto> {
    let url_ = this.baseUrl + '/api/services/app/User/Create';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: userData,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(<any>response_);
            } catch (e) {
              return <Observable<UserDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<UserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? UserDto.fromJS(resultData200)
            : new UserDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          const message = _getErrorMessage(_responseText);
          return throwException(message, status, _responseText, _headers);
        })
      );
    }
    return _observableOf<UserDto>(<any>null);
  }

  /**
   * @param keyword (optional)
   * @param roleId - Deprecated: Since API scheme changed. Use roleNames param
   * @param isActive (optional)
   * @param ImpersonateTenantId (optional)
   * @param pageNumber (optional)
   * @param maxResultCount (optional)
   * @param roleNames (optional)
   * @param group
   * @param sortType
   * @param sortField
   * @return Success
   */
  getAll(
    keyword: string | null | undefined,
    roleId: number | null | undefined,
    isActive: boolean | null | undefined,
    ImpersonateTenantId: number | null | undefined,
    pageNumber: number | null | undefined,
    maxResultCount: number | null | undefined,
    roleNames: string[] | undefined = undefined,
    tenant?: number | null | undefined,
    sortType?: any | undefined,
    sortField?: any | undefined,
  ): Observable<PagedResultDtoOfUserDto> {
    let url_ = this.baseUrl + '/api/services/app/User/GetAll?';

    if (tenant) {
      url_ += 'GroupId=' + encodeURIComponent('' + tenant) + '&';
    }

    if (sortField) {
      switch (sortField) {
        case 'fullName': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 0) + '&';
          break;
        }
        case 'emailAddress': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 1) + '&';
          break;
        }
        case 'status': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 2) + '&';
          break;
        }
        case 'lastModified': {
          url_ += 'Sort.Field=' + encodeURIComponent('' + 3) + '&';
          break;
        }
      }
    }
    if (sortType !== undefined) {
      if (sortType === 'asc') {
        url_ += 'Sort.IsAsc=' + encodeURIComponent('' + true) + '&';
      } else {
        url_ += 'Sort.IsAsc=' + encodeURIComponent('' + false) + '&';
      }
    }

    if (keyword !== undefined)
      url_ += 'Keywords=' + encodeURIComponent('' + keyword) + '&';
    if (roleId !== undefined)
      url_ += 'RoleId=' + encodeURIComponent('' + roleId) + '&';
    if (isActive !== undefined)
      url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
    if (ImpersonateTenantId !== undefined)
      url_ +=
        'ImpersonateTenantId=' + encodeURIComponent('' + ImpersonateTenantId) + '&';
    if (pageNumber !== undefined)
      url_ += 'PageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (roleNames !== undefined) {
      for (let role of roleNames) {
        url_ += 'RoleNames=' + encodeURIComponent('' + role) + '&';
      }
    }
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(<any>response_);
            } catch (e) {
              return <Observable<PagedResultDtoOfUserDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<PagedResultDtoOfUserDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetAll(
    response: HttpResponseBase
  ): Observable<PagedResultDtoOfUserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? PagedResultDtoOfUserDto.fromJS(resultData200)
            : new PagedResultDtoOfUserDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDtoOfUserDto>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | null | undefined): Observable<UserDto> {
    let url_ = this.baseUrl + '/api/services/app/User/Get?';
    if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(<any>response_);
            } catch (e) {
              return <Observable<UserDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<UserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? UserDto.fromJS(resultData200)
            : new UserDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserDto>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  update(userData: UpdateUserDto | null | undefined): Observable<UserDto> {
    let url_ = this.baseUrl + '/api/services/app/User/Update';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: userData,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(<any>response_);
            } catch (e) {
              return <Observable<UserDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<UserDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? UserDto.fromJS(resultData200)
            : new UserDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
            const resp = JSON.parse(_responseText);
          return throwException(
            resp.error.message,
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserDto>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  updateStatus(
    userData:
      | { isActive: boolean; ImpersonateTenantId?: number; id?: number }
      | null
      | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/User/UpdateStatus';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      body: userData,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateStatus(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processUpdateStatus(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/User/Delete?';
    if (id !== undefined) url_ += 'UserId=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param ImpersonateTenantId (optional)
   * @return Success
   */
  getRoles(
    ImpersonateTenantId: number | null | undefined
  ): Observable<ListResultDtoOfRoleDto> {
    let url_ = this.baseUrl + '/api/services/app/Role/GetAll?';
    if (ImpersonateTenantId !== undefined)
      url_ +=
        'ImpersonateTenantId=' + encodeURIComponent('' + ImpersonateTenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRoles(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRoles(<any>response_);
            } catch (e) {
              return <Observable<ListResultDtoOfRoleDto>>(
                (<any>_observableThrow(e))
              );
            }
          } else
            return <Observable<ListResultDtoOfRoleDto>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetRoles(
    response: HttpResponseBase
  ): Observable<ListResultDtoOfRoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200
            ? ListResultDtoOfRoleDto.fromJS(resultData200)
            : new ListResultDtoOfRoleDto();
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ListResultDtoOfRoleDto>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  changeLanguage(
    input: ChangeUserLanguageDto | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/User/ChangeLanguage';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(input);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangeLanguage(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangeLanguage(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processChangeLanguage(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param identityResult (optional)
   * @return Success
   */
  checkErrors(
    identityResult: IdentityResult | null | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/User/CheckErrors';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(identityResult);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckErrors(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckErrors(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCheckErrors(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param input (optional)
   * @return Success
   */
  changePassword(
    input: ChangePasswordDto | null | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/User/ChangePassword';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(input);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePassword(<any>response_);
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processChangePassword(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
  tenancyName: string;

  constructor(data?: IIsTenantAvailableInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.tenancyName = data['tenancyName'];
    }
  }

  static fromJS(data: any): IsTenantAvailableInput {
    data = typeof data === 'object' ? data : {};
    let result = new IsTenantAvailableInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenancyName'] = this.tenancyName;
    return data;
  }

  clone(): IsTenantAvailableInput {
    const json = this.toJSON();
    let result = new IsTenantAvailableInput();
    result.init(json);
    return result;
  }
}

export interface IIsTenantAvailableInput {
  tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
  state: IsTenantAvailableOutputState | undefined;
  tenantId: number | undefined;

  constructor(data?: IIsTenantAvailableOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.state = data['state'];
      this.tenantId = data['tenantId'];
    }
  }

  static fromJS(data: any): IsTenantAvailableOutput {
    data = typeof data === 'object' ? data : {};
    let result = new IsTenantAvailableOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['state'] = this.state;
    data['tenantId'] = this.tenantId;
    return data;
  }

  clone(): IsTenantAvailableOutput {
    const json = this.toJSON();
    let result = new IsTenantAvailableOutput();
    result.init(json);
    return result;
  }
}

export interface IIsTenantAvailableOutput {
  state: IsTenantAvailableOutputState | undefined;
  tenantId: number | undefined;
}

export class RegisterInput implements IRegisterInput {
  fullName: string;
  userName: string;
  emailAddress: string;
  password: string;
  captchaResponse: string | undefined;

  constructor(data?: IRegisterInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.fullName = data['fullName'];
      this.userName = data['userName'];
      this.emailAddress = data['emailAddress'];
      this.password = data['password'];
      this.captchaResponse = data['captchaResponse'];
    }
  }

  static fromJS(data: any): RegisterInput {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['fullName'] = this.fullName;
    data['userName'] = this.userName;
    data['emailAddress'] = this.emailAddress;
    data['password'] = this.password;
    data['captchaResponse'] = this.captchaResponse;
    return data;
  }

  clone(): RegisterInput {
    const json = this.toJSON();
    let result = new RegisterInput();
    result.init(json);
    return result;
  }
}

export interface IRegisterInput {
  fullName: string;
  userName: string;
  emailAddress: string;
  password: string;
  captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
  canLogin: boolean | undefined;

  constructor(data?: IRegisterOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.canLogin = data['canLogin'];
    }
  }

  static fromJS(data: any): RegisterOutput {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['canLogin'] = this.canLogin;
    return data;
  }

  clone(): RegisterOutput {
    const json = this.toJSON();
    let result = new RegisterOutput();
    result.init(json);
    return result;
  }
}

export interface IRegisterOutput {
  canLogin: boolean | undefined;
}

export class PagedResultDtoOfClassOverviewDto
  implements IPagedResultDtoOfClassOverviewDto {
  totalCount: number | undefined;
  items: ClassOverviewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfClassOverviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(ClassOverviewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfClassOverviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfClassOverviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultDtoOfClassOverviewDto {
    const json = this.toJSON();
    let result = new PagedResultDtoOfClassOverviewDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultDtoOfClassOverviewDto {
  totalCount: number | undefined;
  items: ClassOverviewDto[] | undefined;
}

export class ClassOverviewDto implements IClassOverviewDto {
  name: string | undefined;
  instructorId: number | undefined;
  isInstructorActive: boolean | undefined;
  instructorFullName: string | undefined;
  instructorImage: string | undefined;
  instructorImageUrl: string | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
  bookmarked: boolean | undefined;
  isCompleted: boolean | undefined;
  indexNumber: number | undefined;
  progressStatus: ClassOverviewDtoProgressStatus | undefined;
  id: number | undefined;

  constructor(data?: IClassOverviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.instructorId = data['instructorId'];
      this.isInstructorActive = data['isInstructorActive'];
      this.instructorFullName = data['instructorFullName'];
      this.instructorImage = data['instructorImage'];
      this.instructorImageUrl = data['instructorImageUrl'];
      this.thumbnail = data['thumbnail'];
      this.thumbnailUrl = data['thumbnailUrl'];
      this.bookmarked = data['bookmarked'];
      this.isCompleted = data['isCompleted'];
      this.indexNumber = data['indexNumber'];
      this.progressStatus = data['progressStatus'];
      this.id = data['id'];
    }
  }

  static fromJS(data: any): ClassOverviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClassOverviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['instructorId'] = this.instructorId;
    data['isInstructorActive'] = this.isInstructorActive;
    data['instructorFullName'] = this.instructorFullName;
    data['instructorImage'] = this.instructorImage;
    data['instructorImageUrl'] = this.instructorImageUrl;
    data['thumbnail'] = this.thumbnail;
    data['thumbnailUrl'] = this.thumbnailUrl;
    data['bookmarked'] = this.bookmarked;
    data['isCompleted'] = this.isCompleted;
    data['indexNumber'] = this.indexNumber;
    data['progressStatus'] = this.progressStatus;
    data['id'] = this.id;
    return data;
  }

  clone(): ClassOverviewDto {
    const json = this.toJSON();
    let result = new ClassOverviewDto();
    result.init(json);
    return result;
  }
}

export interface IClassOverviewDto {
  name: string | undefined;
  instructorId: number | undefined;
  isInstructorActive: boolean | undefined;
  instructorFullName: string | undefined;
  instructorImage: string | undefined;
  instructorImageUrl: string | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
  bookmarked: boolean | undefined;
  isCompleted: boolean | undefined;
  indexNumber: number | undefined;
  progressStatus: ClassOverviewDtoProgressStatus | undefined;
  id: number | undefined;
}

export class CreateClassDto implements ICreateClassDto {
  className: string;
  instructorId: number;
  classDescription: string | undefined;
  instructorNotes: string | undefined;
  useCodeEditorTab: boolean | undefined;
  access: CreateClassDtoAccess | undefined;
  institutions: number[] | undefined;

  constructor(data?: ICreateClassDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.className = data['className'];
      this.instructorId = data['instructorId'];
      this.classDescription = data['classDescription'];
      this.instructorNotes = data['instructorNotes'];
      this.useCodeEditorTab = data['useCodeEditorTab'];
      this.access = data['access'];
      if (data['institutions'] && data['institutions'].constructor === Array) {
        this.institutions = [];
        for (let item of data['institutions']) this.institutions.push(item);
      }
    }
  }

  static fromJS(data: any): CreateClassDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateClassDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['className'] = this.className;
    data['instructorId'] = this.instructorId;
    data['classDescription'] = this.classDescription;
    data['instructorNotes'] = this.instructorNotes;
    data['useCodeEditorTab'] = this.useCodeEditorTab;
    data['access'] = this.access;
    if (this.institutions && this.institutions.constructor === Array) {
      data['institutions'] = [];
      for (let item of this.institutions) data['institutions'].push(item);
    }
    return data;
  }

  clone(): CreateClassDto {
    const json = this.toJSON();
    let result = new CreateClassDto();
    result.init(json);
    return result;
  }
}

export interface ICreateClassDto {
  className: string;
  instructorId: number;
  classDescription: string | undefined;
  instructorNotes: string | undefined;
  useCodeEditorTab: boolean | undefined;
  access: CreateClassDtoAccess | undefined;
  institutions?: number[] | undefined;
}

export class ClassForEditDto implements IClassForEditDto {
  id: number | undefined;
  name: string | undefined;
  instructorId: number | undefined;
  description: string | undefined;
  instructorNotes: string | undefined;
  isSingleClassVideo: boolean | undefined;
  isQuizAttached: boolean | undefined;
  status: ClassForEditDtoStatus | undefined;
  courses: any;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
  useCodeEditorTab: boolean | undefined;
  code: string | undefined;
  additionalInfo: string | undefined;
  additionalInfo1: string | undefined;
  useIFrameTab: boolean | undefined;
  iFrameLink: string | boolean;
  lastModificationTime: moment.Moment | undefined;
  lastPublicationTime: moment.Moment | undefined;
  durationTicks: number | undefined;
  materials: MaterialDto[];

  constructor(data?: IClassForEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      (this.materials = data['materials']), (this.name = data['name']);
      this.instructorId = data['instructorId'];
      this.description = data['description'];
      this.instructorNotes = data['instructorNotes'];
      this.isSingleClassVideo = data['isSingleClassVideo'];
      this.isQuizAttached = data['isQuizAttached'];
      this.status = data['status'];
      this.code = data['code'];
      this.additionalInfo = data['additionalInfo'];
      this.additionalInfo1 = data['additionalInfo1'];
      this.thumbnail = data['thumbnail'];
      this.thumbnailUrl = data['thumbnailUrl'];
      this.useCodeEditorTab = data['useCodeEditorTab'];
      this.iFrameLink = data['iFrameLink'];
      this.useIFrameTab = data['iFrameLink'];
      this.lastModificationTime = data['lastModificationTime']
        ? moment(data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastPublicationTime = data['lastPublicationTime']
        ? moment(data['lastPublicationTime'].toString())
        : <any>undefined;
      this.courses = data['courses'];
      this.durationTicks = data['durationTicks'];
    }
  }

  static fromJS(data: any): ClassForEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClassForEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['instructorId'] = this.instructorId;
    data['description'] = this.description;
    data['instructorNotes'] = this.instructorNotes;
    data['isSingleClassVideo'] = this.isSingleClassVideo;
    data['isQuizAttached'] = this.isQuizAttached;
    data['status'] = this.status;
    data['code'] = this.code;
    data['additionalInfo'] = this.additionalInfo;
    data['additionalInfo1'] = this.additionalInfo1;
    data['thumbnail'] = this.thumbnail;
    data['thumbnailUrl'] = this.thumbnailUrl;
    data['useCodeEditorTab'] = this.useCodeEditorTab;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastPublicationTime'] = this.lastPublicationTime
      ? this.lastPublicationTime.toISOString()
      : <any>undefined;
    data['courses'] = this.courses;
    data['durationTicks'] = this.durationTicks;
    return data;
  }

  clone(): ClassForEditDto {
    const json = this.toJSON();
    let result = new ClassForEditDto();
    result.init(json);
    return result;
  }
}

export interface IClassForEditDto {
  id: number | undefined;
  name: string | undefined;
  instructorId: number | undefined;
  description: string | undefined;
  instructorNotes: string | undefined;
  isSingleClassVideo: boolean | undefined;
  isQuizAttached: boolean | undefined;
  status: ClassForEditDtoStatus | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
  useCodeEditorTab: boolean | undefined;
  lastModificationTime: moment.Moment | undefined;
  lastPublicationTime: moment.Moment | undefined;
  durationTicks: number | undefined;
}

export class InstitutionShort implements IInstitutionShort {
  id: number | undefined;
  name: string | undefined;

  constructor(data?: IInstitutionShort) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
    }
  }

  static fromJS(data: any): InstitutionShort {
    data = typeof data === 'object' ? data : {};
    let result = new InstitutionShort();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }

  clone(): InstitutionShort {
    const json = this.toJSON();
    let result = new InstitutionShort();
    result.init(json);
    return result;
  }
}

export interface IInstitutionShort {
  id: number | undefined;
  name: string | undefined;
}

export class UpdateClassDto implements IUpdateClassDto {
  classId: number | undefined;
  thumbnail: string | undefined;
  isSingleClassVideo: boolean | undefined;
  className: string;
  additionalInfo: string;
  additionalInfo1: string;
  instructorId: number;
  classDescription: string | undefined;
  instructorNotes: string | undefined;
  useCodeEditorTab: boolean | undefined;
  courses: [];
  materials?: File[] = [];
  useIFrameTab: boolean | undefined;
  iFrameLink: string | undefined;
  code: string | undefined;

  constructor(data?: IUpdateClassDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.classId = data['classId'];
      this.materials = data['materials'];
      this.thumbnail = data['thumbnail'];
      this.code = data['code'];
      this.additionalInfo = data['additionalInfo'];
      this.additionalInfo1 = data['additionalInfo1'];
      this.isSingleClassVideo = data['isSingleClassVideo'];
      this.className = data['className'];
      this.instructorId = data['instructorId'];
      this.classDescription = data['classDescription'];
      this.instructorNotes = data['instructorNotes'];
      this.useCodeEditorTab = data['useCodeEditorTab'];
      this.useIFrameTab = data['useIFrameTab'];
      this.iFrameLink = data['iFrameLink'];
    }
  }

  static fromJS(data: any): UpdateClassDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateClassDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['classId'] = this.classId;
    data['thumbnail'] = this.thumbnail;
    data['isSingleClassVideo'] = this.isSingleClassVideo;
    data['className'] = this.className;
    data['instructorId'] = this.instructorId;
    data['additionalInfo'] = this.additionalInfo;
    data['additionalInfo1'] = this.additionalInfo1;
    data['code'] = this.code;
    data['classDescription'] = this.classDescription;
    data['instructorNotes'] = this.instructorNotes;
    data['useIFrameTab'] = this.useIFrameTab;
    data['iFrameLink'] = this.iFrameLink;
    data['useCodeEditorTab'] = this.useCodeEditorTab;
    return data;
  }

  clone(): UpdateClassDto {
    const json = this.toJSON();
    let result = new UpdateClassDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateClassDto {
  classId: number | undefined;
  thumbnail: string | undefined;
  isSingleClassVideo: boolean | undefined;
  className: string;
  instructorId: number;
  classDescription: string | undefined;
  instructorNotes: string | undefined;
  useCodeEditorTab: boolean | undefined;
  removeThumbnail?: boolean;
  courses: [];
  code: string | undefined;
  additionalInfo: string | undefined;
  additionalInfo1: string | undefined;
  materials?: File[];
  useIFrameTab?: boolean;
  iFrameLink?: string;
}

export class UpdateClassStatusDto implements IUpdateClassStatusDto {
  classId: number | undefined;
  isPublished: boolean | undefined;

  constructor(data?: IUpdateClassStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.classId = data['classId'];
      this.isPublished = data['isPublished'];
    }
  }

  static fromJS(data: any): UpdateClassStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateClassStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['classId'] = this.classId;
    data['isPublished'] = this.isPublished;
    return data;
  }

  clone(): UpdateClassStatusDto {
    const json = this.toJSON();
    let result = new UpdateClassStatusDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateClassStatusDto {
  classId: number | undefined;
  isPublished: boolean | undefined;
}

export class UpdateClassThumbnailDto implements IUpdateClassThumbnailDto {
  classId: number | undefined;
  thumbnail: string | undefined;

  constructor(data?: IUpdateClassThumbnailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.classId = data['classId'];
      this.thumbnail = data['thumbnail'];
    }
  }

  static fromJS(data: any): UpdateClassThumbnailDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateClassThumbnailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['classId'] = this.classId;
    data['thumbnail'] = this.thumbnail;
    return data;
  }

  clone(): UpdateClassThumbnailDto {
    const json = this.toJSON();
    let result = new UpdateClassThumbnailDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateClassThumbnailDto {
  classId: number | undefined;
  thumbnail: string | undefined;
}

export class UserProgressDto implements IUserProgressDto {
  timeTicks: number | undefined;
  isCompleted: boolean | undefined;

  constructor(data?: IUserProgressDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.timeTicks = data['timeTicks'];
      this.isCompleted = data['isCompleted'];
    }
  }

  static fromJS(data: any): UserProgressDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserProgressDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['timeTicks'] = this.timeTicks;
    data['isCompleted'] = this.isCompleted;
    return data;
  }

  clone(): UserProgressDto {
    const json = this.toJSON();
    let result = new UserProgressDto();
    result.init(json);
    return result;
  }
}

export interface IUserProgressDto {
  timeTicks: number | undefined;
  isCompleted: boolean | undefined;
}

export class SetUserProgressDto implements ISetUserProgressDto {
  classId: number | undefined;
  timeTicks: number | undefined;
  isCompleted: boolean | undefined;

  constructor(data?: ISetUserProgressDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.classId = data['classId'];
      this.timeTicks = data['timeTicks'];
      this.isCompleted = data['isCompleted'];
    }
  }

  static fromJS(data: any): SetUserProgressDto {
    data = typeof data === 'object' ? data : {};
    let result = new SetUserProgressDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['classId'] = this.classId;
    data['timeTicks'] = this.timeTicks;
    data['isCompleted'] = this.isCompleted;
    return data;
  }

  clone(): SetUserProgressDto {
    const json = this.toJSON();
    let result = new SetUserProgressDto();
    result.init(json);
    return result;
  }
}

export interface ISetUserProgressDto {
  classId: number | undefined;
  timeTicks: number | undefined;
  isCompleted: boolean | undefined;
}

export class SetClassBookmarkedDto implements ISetClassBookmarkedDto {
  classId: number | undefined;
  bookmarked: boolean | undefined;

  constructor(data?: ISetClassBookmarkedDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.classId = data['classId'];
      this.bookmarked = data['bookmarked'];
    }
  }

  static fromJS(data: any): SetClassBookmarkedDto {
    data = typeof data === 'object' ? data : {};
    let result = new SetClassBookmarkedDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['classId'] = this.classId;
    data['bookmarked'] = this.bookmarked;
    return data;
  }

  clone(): SetClassBookmarkedDto {
    const json = this.toJSON();
    let result = new SetClassBookmarkedDto();
    result.init(json);
    return result;
  }
}

export interface ISetClassBookmarkedDto {
  classId: number | undefined;
  bookmarked: boolean | undefined;
}

export class WatchClassDto implements IWatchClassDto {
  name: string | undefined;
  description: string | undefined;
  instructorId: number | undefined;
  isInstructorActive: boolean | undefined;
  isSingleClassVideo: boolean | undefined;
  instructorFullName: string | undefined;
  instructorImage: string | undefined;
  instructorImageUrl: string | undefined;
  instructorNotes: string | undefined;
  quizId: number | undefined;
  courseName: string | undefined;
  courseIcon: string | undefined;
  programIcon: string | undefined;
  programId: number | undefined;
  classNumber: number | undefined;
  classTotal: number | undefined;
  useCodeEditorTab: boolean | undefined;
  videos: ClassVideoDto[] | undefined;
  chapters: ClassChapterDto[] | undefined;
  materials: MaterialDto[] | undefined;
  id: number | undefined;

  constructor(data?: IWatchClassDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.description = data['description'];
      this.instructorId = data['instructorId'];
      this.isInstructorActive = data['isInstructorActive'];
      this.isSingleClassVideo = data['isSingleClassVideo'];
      this.instructorFullName = data['instructorFullName'];
      this.instructorImage = data['instructorImage'];
      this.instructorImageUrl = data['instructorImageUrl'];
      this.instructorNotes = data['instructorNotes'];
      this.quizId = data['quizId'];
      this.courseName = data['courseName'];
      this.courseIcon = data['courseIcon'];
      this.programIcon = data['programIcon'];
      this.programId = data['programId'];
      this.classNumber = data['classNumber'];
      this.classTotal = data['classTotal'];
      this.useCodeEditorTab = data['useCodeEditorTab'];
      if (data['videos'] && data['videos'].constructor === Array) {
        this.videos = [];
        for (let item of data['videos'])
          this.videos.push(ClassVideoDto.fromJS(item));
      }
      if (data['chapters'] && data['chapters'].constructor === Array) {
        this.chapters = [];
        for (let item of data['chapters'])
          this.chapters.push(ClassChapterDto.fromJS(item));
      }
      if (data['materials'] && data['materials'].constructor === Array) {
        this.materials = [];
        for (let item of data['materials'])
          this.materials.push(MaterialDto.fromJS(item));
      }
      this.id = data['id'];
    }
  }

  static fromJS(data: any): WatchClassDto {
    data = typeof data === 'object' ? data : {};
    let result = new WatchClassDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    data['instructorId'] = this.instructorId;
    data['isInstructorActive'] = this.isInstructorActive;
    data['isSingleClassVideo'] = this.isSingleClassVideo;
    data['instructorFullName'] = this.instructorFullName;
    data['instructorImage'] = this.instructorImage;
    data['instructorImageUrl'] = this.instructorImageUrl;
    data['instructorNotes'] = this.instructorNotes;
    data['quizId'] = this.quizId;
    data['courseName'] = this.courseName;
    data['courseIcon'] = this.courseIcon;
    data['programIcon'] = this.programIcon;
    data['programId'] = this.programId;
    data['classNumber'] = this.classNumber;
    data['classTotal'] = this.classTotal;
    data['useCodeEditorTab'] = this.useCodeEditorTab;
    if (this.videos && this.videos.constructor === Array) {
      data['videos'] = [];
      for (let item of this.videos) data['videos'].push(item.toJSON());
    }
    if (this.chapters && this.chapters.constructor === Array) {
      data['chapters'] = [];
      for (let item of this.chapters) data['chapters'].push(item.toJSON());
    }
    if (this.materials && this.materials.constructor === Array) {
      data['materials'] = [];
      for (let item of this.materials) data['materials'].push(item.toJSON());
    }
    data['id'] = this.id;
    return data;
  }

  clone(): WatchClassDto {
    const json = this.toJSON();
    let result = new WatchClassDto();
    result.init(json);
    return result;
  }
}

export interface IWatchClassDto {
  name: string | undefined;
  description: string | undefined;
  instructorId: number | undefined;
  isInstructorActive: boolean | undefined;
  isSingleClassVideo: boolean | undefined;
  instructorFullName: string | undefined;
  instructorImage: string | undefined;
  instructorImageUrl: string | undefined;
  instructorNotes: string | undefined;
  quizId: number | undefined;
  courseName: string | undefined;
  courseIcon: string | undefined;
  programIcon: string | undefined;
  programId: number | undefined;
  classNumber: number | undefined;
  classTotal: number | undefined;
  useCodeEditorTab: boolean | undefined;
  videos: ClassVideoDto[] | undefined;
  chapters: ClassChapterDto[] | undefined;
  materials: MaterialDto[] | undefined;
  id: number | undefined;
}

export class ClassVideoDto implements IClassVideoDto {
  name: string | undefined;
  videoId: string | undefined;

  constructor(data?: IClassVideoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.videoId = data['videoId'];
    }
  }

  static fromJS(data: any): ClassVideoDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClassVideoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['videoId'] = this.videoId;
    return data;
  }

  clone(): ClassVideoDto {
    const json = this.toJSON();
    let result = new ClassVideoDto();
    result.init(json);
    return result;
  }
}

export interface IClassVideoDto {
  name: string | undefined;
  videoId: string | undefined;
}

export class ClassChapterDto implements IClassChapterDto {
  title: string | undefined;
  timeTicks: number | undefined;
  time: string | undefined;

  constructor(data?: IClassChapterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.title = data['title'];
      this.timeTicks = data['timeTicks'];
      this.time = data['time'];
    }
  }

  static fromJS(data: any): ClassChapterDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClassChapterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['title'] = this.title;
    data['timeTicks'] = this.timeTicks;
    data['time'] = this.time;
    return data;
  }

  clone(): ClassChapterDto {
    const json = this.toJSON();
    let result = new ClassChapterDto();
    result.init(json);
    return result;
  }
}

export interface IClassChapterDto {
  title: string | undefined;
  timeTicks: number | undefined;
  time: string | undefined;
}

export class MaterialDto implements IMaterialDto {
  id: number | undefined;
  icon: string | undefined;
  fileName: string | undefined;
  fileURI: string | undefined;
  isValidType?: boolean;

  constructor(data?: IMaterialDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.icon = data['icon'];
      this.fileName = data['fileName'];
      this.fileURI = data['fileURI'];
    }
  }

  static fromJS(data: any): MaterialDto {
    data = typeof data === 'object' ? data : {};
    let result = new MaterialDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['icon'] = this.icon;
    data['fileName'] = this.fileName;
    data['fileURI'] = this.fileURI;
    return data;
  }

  clone(): MaterialDto {
    const json = this.toJSON();
    let result = new MaterialDto();
    result.init(json);
    return result;
  }
}

export interface IMaterialDto {
  id: number | undefined;
  icon: string | undefined;
  fileName: string | undefined;
  fileURI: string | undefined;
  isValidType?: boolean;
}

export class PagedResultDtoOfClassMainInfoDto
  implements IPagedResultDtoOfClassMainInfoDto {
  totalCount: number | undefined;
  items: ClassMainInfoDto[] | undefined;

  constructor(data?: IPagedResultDtoOfClassMainInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(ClassMainInfoDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfClassMainInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfClassMainInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultDtoOfClassMainInfoDto {
    const json = this.toJSON();
    let result = new PagedResultDtoOfClassMainInfoDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultDtoOfClassMainInfoDto {
  totalCount: number | undefined;
  items: ClassMainInfoDto[] | undefined;
}

export class ClassMainInfoDto implements IClassMainInfoDto {
  id: number | undefined;
  name: string | undefined;
  instructor: string | undefined;
  views: number | undefined;
  completed: number | undefined;
  courses: any | undefined;
  code: any;
  isQuizAttached: boolean | undefined;
  isClassVideoExists: boolean | undefined;
  status: ClassMainInfoDtoStatus | undefined;
  lastModificationTime: moment.Moment | undefined;

  constructor(data?: IClassMainInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.courses = data['courses'];
      this.code = data['code'];
      this.instructor = data['instructor'];
      this.views = data['views'];
      this.completed = data['completed'];
      this.isQuizAttached = data['isQuizAttached'];
      this.isClassVideoExists = data['isClassVideoExists'];
      this.status = data['status'];
      this.lastModificationTime = data['lastModificationTime']
        ? moment(data['lastModificationTime'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): ClassMainInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClassMainInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['instructor'] = this.instructor;
    data['views'] = this.views;
    data['code'] = this.code;
    data['courses'] = this.courses;
    data['completed'] = this.completed;
    data['isQuizAttached'] = this.isQuizAttached;
    data['isClassVideoExists'] = this.isClassVideoExists;
    data['status'] = this.status;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    return data;
  }

  clone(): ClassMainInfoDto {
    const json = this.toJSON();
    let result = new ClassMainInfoDto();
    result.init(json);
    return result;
  }
}

export interface IClassMainInfoDto {
  id: number | undefined;
  name: string | undefined;
  instructor: string | undefined;
  views: number | undefined;
  completed: number | undefined;
  isQuizAttached: boolean | undefined;
  isClassVideoExists: boolean | undefined;
  status: ClassMainInfoDtoStatus | undefined;
  lastModificationTime: moment.Moment | undefined;
}

export class ClassNoteDto implements IClassNoteDto {
  id: number | undefined;
  note: string | undefined;
  lastModificationTime: moment.Moment | undefined;
  creationTime: moment.Moment | undefined;
  classId: number | undefined;

  constructor(data?: IClassNoteDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.note = data['note'];
      this.lastModificationTime = data['lastModificationTime']
        ? moment(data['lastModificationTime'].toString())
        : <any>undefined;
      this.creationTime = data['creationTime']
        ? moment(data['creationTime'].toString())
        : <any>undefined;
      this.classId = data['classId'];
    }
  }

  static fromJS(data: any): ClassNoteDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClassNoteDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['note'] = this.note;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['creationTime'] = this.creationTime
      ? this.creationTime.toISOString()
      : <any>undefined;
    data['classId'] = this.classId;
    return data;
  }

  clone(): ClassNoteDto {
    const json = this.toJSON();
    let result = new ClassNoteDto();
    result.init(json);
    return result;
  }
}

export interface IClassNoteDto {
  id: number | undefined;
  note: string | undefined;
  lastModificationTime: moment.Moment | undefined;
  creationTime: moment.Moment | undefined;
  classId: number | undefined;
}

export class CreateOrUpdateClassNoteDto implements ICreateOrUpdateClassNoteDto {
  note: string | undefined;
  classId: number | undefined;

  constructor(data?: ICreateOrUpdateClassNoteDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.note = data['note'];
      this.classId = data['classId'];
    }
  }

  static fromJS(data: any): CreateOrUpdateClassNoteDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrUpdateClassNoteDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['note'] = this.note;
    data['classId'] = this.classId;
    return data;
  }

  clone(): CreateOrUpdateClassNoteDto {
    const json = this.toJSON();
    let result = new CreateOrUpdateClassNoteDto();
    result.init(json);
    return result;
  }
}

export interface ICreateOrUpdateClassNoteDto {
  note: string | undefined;
  classId: number | undefined;
}

export class ClassCodeDto implements IClassCodeDto {
  id: number | undefined;
  code: string | undefined;
  lastModificationTime: moment.Moment | undefined;
  creationTime: moment.Moment | undefined;
  classId: number | undefined;

  constructor(data?: IClassCodeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.code = data['code'];
      this.lastModificationTime = data['lastModificationTime']
        ? moment(data['lastModificationTime'].toString())
        : <any>undefined;
      this.creationTime = data['creationTime']
        ? moment(data['creationTime'].toString())
        : <any>undefined;
      this.classId = data['classId'];
    }
  }

  static fromJS(data: any): ClassCodeDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClassCodeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['code'] = this.code;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['creationTime'] = this.creationTime
      ? this.creationTime.toISOString()
      : <any>undefined;
    data['classId'] = this.classId;
    return data;
  }

  clone(): ClassCodeDto {
    const json = this.toJSON();
    let result = new ClassCodeDto();
    result.init(json);
    return result;
  }
}

export interface IClassCodeDto {
  id: number | undefined;
  code: string | undefined;
  lastModificationTime: moment.Moment | undefined;
  creationTime: moment.Moment | undefined;
  classId: number | undefined;
}

export class CreateOrUpdateClassCodeDto implements ICreateOrUpdateClassCodeDto {
  code: string | undefined;
  classId: number | undefined;

  constructor(data?: ICreateOrUpdateClassCodeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.code = data['code'];
      this.classId = data['classId'];
    }
  }

  static fromJS(data: any): CreateOrUpdateClassCodeDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrUpdateClassCodeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['code'] = this.code;
    data['classId'] = this.classId;
    return data;
  }

  clone(): CreateOrUpdateClassCodeDto {
    const json = this.toJSON();
    let result = new CreateOrUpdateClassCodeDto();
    result.init(json);
    return result;
  }
}

export interface ICreateOrUpdateClassCodeDto {
  code: string | undefined;
  classId: number | undefined;
}

export class CreateClassChapterDto implements ICreateClassChapterDto {
  classId: number;
  title: string;
  timeTicks: number;

  constructor(data?: ICreateClassChapterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.classId = data['classId'];
      this.title = data['title'];
      this.timeTicks = data['timeTicks'];
    }
  }

  static fromJS(data: any): CreateClassChapterDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateClassChapterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['classId'] = this.classId;
    data['title'] = this.title;
    data['timeTicks'] = this.timeTicks;
    return data;
  }

  clone(): CreateClassChapterDto {
    const json = this.toJSON();
    let result = new CreateClassChapterDto();
    result.init(json);
    return result;
  }
}

export interface ICreateClassChapterDto {
  classId: number;
  title: string;
  timeTicks: number;
}

export class ChapterDto implements IChapterDto {
  id: number | undefined;
  title: string | undefined;
  timeTicks: number | undefined;
  time: string | undefined;

  constructor(data?: IChapterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.title = data['title'];
      this.timeTicks = data['timeTicks'];
      this.time = data['time'];
    }
  }

  static fromJS(data: any): ChapterDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChapterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['title'] = this.title;
    data['timeTicks'] = this.timeTicks;
    data['time'] = this.time;
    return data;
  }

  clone(): ChapterDto {
    const json = this.toJSON();
    let result = new ChapterDto();
    result.init(json);
    return result;
  }
}

export interface IChapterDto {
  id: number | undefined;
  title: string | undefined;
  timeTicks: number | undefined;
  time: string | undefined;
}

export class UpdateClassChapterDto implements IUpdateClassChapterDto {
  id: number;
  title: string;
  timeTicks: number;

  constructor(data?: IUpdateClassChapterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.title = data['title'];
      this.timeTicks = data['timeTicks'];
    }
  }

  static fromJS(data: any): UpdateClassChapterDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateClassChapterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['title'] = this.title;
    data['timeTicks'] = this.timeTicks;
    return data;
  }

  clone(): UpdateClassChapterDto {
    const json = this.toJSON();
    let result = new UpdateClassChapterDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateClassChapterDto {
  id: number;
  title: string;
  timeTicks: number;
}

export class ClassStatusDto implements IClassStatusDto {
  id: number | undefined;
  status: string | undefined;
  videoType: string | undefined;
  videoId: string | undefined;
  originalFileName: string | undefined;
  durationTicks: string | undefined;
  driveDurationTicks: string | undefined;
  error: string | undefined;

  constructor(data?: IClassStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.status = data['status'];
      this.videoType = data['videoType'];
      this.videoId = data['videoId'];
      this.originalFileName = data['originalFileName'];
      this.durationTicks = data['durationTicks'];
      this.driveDurationTicks = data['driveDurationTicks'];
      this.error = data['error'];
    }
  }

  static fromJS(data: any): ClassStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClassStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['status'] = this.status;
    data['videoType'] = this.videoType;
    data['videoId'] = this.videoId;
    data['originalFileName'] = this.originalFileName;
    data['durationTicks'] = this.durationTicks;
    data['driveDurationTicks'] = this.driveDurationTicks;
    data['error'] = this.error;
    return data;
  }

  clone(): ClassStatusDto {
    const json = this.toJSON();
    let result = new ClassStatusDto();
    result.init(json);
    return result;
  }
}

export interface IClassStatusDto {
  id: number | undefined;
  status: string | undefined;
  videoType: string | undefined;
  videoId: string | undefined;
  originalFileName: string | undefined;
  durationTicks: string | undefined;
  driveDurationTicks: string | undefined;
  error: string | undefined;
}

export class UploadVideoRequestDto implements IUploadVideoRequestDto {
  classId: number | undefined;
  videoType: UploadVideoRequestDtoVideoType | undefined;
  originalUrl: string | undefined;
  isDebug: boolean | undefined;

  constructor(data?: IUploadVideoRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.classId = data['classId'];
      this.videoType = data['videoType'];
      this.originalUrl = data['originalUrl'];
      this.isDebug = data['isDebug'];
    }
  }

  static fromJS(data: any): UploadVideoRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new UploadVideoRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['classId'] = this.classId;
    data['videoType'] = this.videoType;
    data['originalUrl'] = this.originalUrl;
    data['isDebug'] = this.isDebug;
    return data;
  }

  clone(): UploadVideoRequestDto {
    const json = this.toJSON();
    let result = new UploadVideoRequestDto();
    result.init(json);
    return result;
  }
}

export interface IUploadVideoRequestDto {
  classId: number | undefined;
  videoType: UploadVideoRequestDtoVideoType | undefined;
  originalUrl: string | undefined;
  isDebug: boolean | undefined;
}

export class ClassUploadVideoResponseDto
  implements IClassUploadVideoResponseDto {
  success: boolean | undefined;
  error: string | undefined;
  videoMetadata: VideoMetadataDto | undefined;

  constructor(data?: IClassUploadVideoResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.success = data['success'];
      this.error = data['error'];
      this.videoMetadata = data['videoMetadata']
        ? VideoMetadataDto.fromJS(data['videoMetadata'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ClassUploadVideoResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClassUploadVideoResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['success'] = this.success;
    data['error'] = this.error;
    data['videoMetadata'] = this.videoMetadata
      ? this.videoMetadata.toJSON()
      : <any>undefined;
    return data;
  }

  clone(): ClassUploadVideoResponseDto {
    const json = this.toJSON();
    let result = new ClassUploadVideoResponseDto();
    result.init(json);
    return result;
  }
}

export interface IClassUploadVideoResponseDto {
  success: boolean | undefined;
  error: string | undefined;
  videoMetadata: VideoMetadataDto | undefined;
}

export class VideoMetadataDto implements IVideoMetadataDto {
  originalFileName: string | undefined;
  durationTicks: number | undefined;

  constructor(data?: IVideoMetadataDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.originalFileName = data['originalFileName'];
      this.durationTicks = data['durationTicks'];
    }
  }

  static fromJS(data: any): VideoMetadataDto {
    data = typeof data === 'object' ? data : {};
    let result = new VideoMetadataDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['originalFileName'] = this.originalFileName;
    data['durationTicks'] = this.durationTicks;
    return data;
  }

  clone(): VideoMetadataDto {
    const json = this.toJSON();
    let result = new VideoMetadataDto();
    result.init(json);
    return result;
  }
}

export interface IVideoMetadataDto {
  originalFileName: string | undefined;
  durationTicks: number | undefined;
}

export class ClearClassVideoRequestDto implements IClearClassVideoRequestDto {
  videoType: ClearClassVideoRequestDtoVideoType | undefined;
  classId: number | undefined;

  constructor(data?: IClearClassVideoRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.videoType = data['videoType'];
      this.classId = data['classId'];
    }
  }

  static fromJS(data: any): ClearClassVideoRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClearClassVideoRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['videoType'] = this.videoType;
    data['classId'] = this.classId;
    return data;
  }

  clone(): ClearClassVideoRequestDto {
    const json = this.toJSON();
    let result = new ClearClassVideoRequestDto();
    result.init(json);
    return result;
  }
}

export interface IClearClassVideoRequestDto {
  videoType: ClearClassVideoRequestDtoVideoType | undefined;
  classId: number | undefined;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
  theme: string;

  constructor(data?: IChangeUiThemeInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.theme = data['theme'];
    }
  }

  static fromJS(data: any): ChangeUiThemeInput {
    data = typeof data === 'object' ? data : {};
    let result = new ChangeUiThemeInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['theme'] = this.theme;
    return data;
  }

  clone(): ChangeUiThemeInput {
    const json = this.toJSON();
    let result = new ChangeUiThemeInput();
    result.init(json);
    return result;
  }
}

export interface IChangeUiThemeInput {
  theme: string;
}

export class CourseDetailsDto implements ICourseDetailsDto {
  icon: string | undefined;
  name: string | undefined;
  description: string | undefined;
  whoIsThisFor: string | undefined;
  skills: string | undefined;
  requiredTools: string | undefined;
  preRequisites: string | undefined;
  courseDurationHours: number | undefined;
  classDurationAverage: number | undefined;
  classDurationAverageLabel: string | undefined;
  classesCount: number | undefined;
  program: ProgramSummaryDto | undefined;
  instructors: InstructorDto[] | undefined;
  material: MaterialDto[] | undefined;
  contentMode: CourseContentMode | undefined;
  scormPackage: ScormPackageDto | undefined;
  id: number | undefined;

  constructor(data?: ICourseDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.icon = data['icon'];
      this.name = data['name'];
      this.description = data['description'];
      this.whoIsThisFor = data['whoIsThisFor'];
      this.skills = data['skills'];
      this.requiredTools = data['requiredTools'];
      this.preRequisites = data['preRequisites'];
      this.courseDurationHours = data['courseDurationHours'];
      this.classDurationAverage = data['classDurationAverage'];
      this.classDurationAverageLabel = data['classDurationAverageLabel'];
      this.classesCount = data['classesCount'];
      this.program = data['program']
        ? ProgramSummaryDto.fromJS(data['program'])
        : <any>undefined;
      if (data['instructors'] && data['instructors'].constructor === Array) {
        this.instructors = [];
        for (let item of data['instructors'])
          this.instructors.push(InstructorDto.fromJS(item));
      }
      if (data['material'] && data['material'].constructor === Array) {
        this.material = [];
        for (let item of data['material'])
          this.material.push(MaterialDto.fromJS(item));
      }
      this.contentMode = data['contentMode'];
      this.scormPackage = data['scormPackage']
        ? ScormPackageDto.fromJS(data['scormPackage'])
        : <any>undefined;
      this.id = data['id'];
    }
  }

  static fromJS(data: any): CourseDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new CourseDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['icon'] = this.icon;
    data['name'] = this.name;
    data['description'] = this.description;
    data['whoIsThisFor'] = this.whoIsThisFor;
    data['skills'] = this.skills;
    data['requiredTools'] = this.requiredTools;
    data['preRequisites'] = this.preRequisites;
    data['courseDurationHours'] = this.courseDurationHours;
    data['classDurationAverage'] = this.classDurationAverage;
    data['classDurationAverageLabel'] = this.classDurationAverageLabel;
    data['classesCount'] = this.classesCount;
    data['program'] = this.program ? this.program.toJSON() : <any>undefined;
    if (this.instructors && this.instructors.constructor === Array) {
      data['instructors'] = [];
      for (let item of this.instructors)
        data['instructors'].push(item.toJSON());
    }
    if (this.material && this.material.constructor === Array) {
      data['material'] = [];
      for (let item of this.material) data['material'].push(item.toJSON());
    }
    data['contentMode'] = this.contentMode;
    data['scormPackage'] = this.scormPackage
      ? this.scormPackage.toJSON()
      : <any>undefined;
    data['id'] = this.id;
    return data;
  }

  clone(): CourseDetailsDto {
    const json = this.toJSON();
    let result = new CourseDetailsDto();
    result.init(json);
    return result;
  }
}

export interface ICourseDetailsDto {
  icon: string | undefined;
  name: string | undefined;
  description: string | undefined;
  whoIsThisFor: string | undefined;
  skills: string | undefined;
  requiredTools: string | undefined;
  preRequisites: string | undefined;
  courseDurationHours: number | undefined;
  classDurationAverage: number | undefined;
  classDurationAverageLabel: string | undefined;
  classesCount: number | undefined;
  program: ProgramSummaryDto | undefined;
  instructors: InstructorDto[] | undefined;
  material: MaterialDto[] | undefined;
  contentMode: CourseContentMode | undefined;
  scormPackage: ScormPackageDto | undefined;
  id: number | undefined;
}

export class ScormPackageDto implements IScormPackageDto {
  id: number | undefined;
  packageName: string | undefined;
  launchFile: string | undefined;
  manifestIdentifier: string | undefined;
  manifestVersion: string | undefined;
  extractedSizeBytes: number | undefined;
  status: ScormPackageStatus | undefined;
  processedOn: moment.Moment | undefined;
  hasProgressTracking: boolean | undefined;

  constructor(data?: IScormPackageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.packageName = data['packageName'];
      this.launchFile = data['launchFile'];
      this.manifestIdentifier = data['manifestIdentifier'];
      this.manifestVersion = data['manifestVersion'];
      this.extractedSizeBytes = data['extractedSizeBytes'];
      this.status = data['status'];
      this.processedOn = data['processedOn']
        ? moment(data['processedOn'].toString())
        : <any>undefined;
      this.hasProgressTracking = data['hasProgressTracking'];
    }
  }

  static fromJS(data: any): ScormPackageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ScormPackageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['packageName'] = this.packageName;
    data['launchFile'] = this.launchFile;
    data['manifestIdentifier'] = this.manifestIdentifier;
    data['manifestVersion'] = this.manifestVersion;
    data['extractedSizeBytes'] = this.extractedSizeBytes;
    data['status'] = this.status;
    data['processedOn'] = this.processedOn
      ? this.processedOn.toISOString()
      : <any>undefined;
    data['hasProgressTracking'] = this.hasProgressTracking;
    return data;
  }

  clone(): ScormPackageDto {
    const json = this.toJSON();
    let result = new ScormPackageDto();
    result.init(json);
    return result;
  }
}

export interface IScormPackageDto {
  id: number | undefined;
  packageName: string | undefined;
  launchFile: string | undefined;
  manifestIdentifier: string | undefined;
  manifestVersion: string | undefined;
  extractedSizeBytes: number | undefined;
  status: ScormPackageStatus | undefined;
  processedOn: moment.Moment | undefined;
  hasProgressTracking: boolean | undefined;
}

export enum CourseContentMode {
  Classes = 0,
  Scorm = 1,
}

export enum ScormPackageStatus {
  Uploaded = 0,
  Processed = 1,
  Failed = 2,
}

export class SaveScormProgressCommand implements ISaveScormProgressCommand {
  courseId: number | undefined;
  progressPercentage: number | undefined;

  constructor(data?: ISaveScormProgressCommand) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.courseId = data['courseId'];
      this.progressPercentage = data['progressPercentage'];
    }
  }

  static fromJS(data: any): SaveScormProgressCommand {
    data = typeof data === 'object' ? data : {};
    let result = new SaveScormProgressCommand();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['courseId'] = this.courseId;
    data['progressPercentage'] = this.progressPercentage;
    return data;
  }

  clone(): SaveScormProgressCommand {
    const json = this.toJSON();
    let result = new SaveScormProgressCommand();
    result.init(json);
    return result;
  }
}

export interface ISaveScormProgressCommand {
  courseId: number | undefined;
  progressPercentage: number | undefined;
}

export class ScormProgressDto implements IScormProgressDto {
  id: number | undefined;
  courseId: number | undefined;
  userId: number | undefined;
  progressPercentage: number | undefined;
  isCompleted: boolean | undefined;
  courseStartedDate: moment.Moment | undefined;
  courseCompletedDate: moment.Moment | undefined;
  lastAccessDate: moment.Moment | undefined;

  constructor(data?: IScormProgressDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.courseId = data['courseId'];
      this.userId = data['userId'];
      this.progressPercentage = data['progressPercentage'];
      this.isCompleted = data['isCompleted'];
      this.courseStartedDate = data['courseStartedDate']
        ? moment(data['courseStartedDate'].toString())
        : <any>undefined;
      this.courseCompletedDate = data['courseCompletedDate']
        ? moment(data['courseCompletedDate'].toString())
        : <any>undefined;
      this.lastAccessDate = data['lastAccessDate']
        ? moment(data['lastAccessDate'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): ScormProgressDto {
    data = typeof data === 'object' ? data : {};
    let result = new ScormProgressDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['courseId'] = this.courseId;
    data['userId'] = this.userId;
    data['progressPercentage'] = this.progressPercentage;
    data['isCompleted'] = this.isCompleted;
    data['courseStartedDate'] = this.courseStartedDate
      ? this.courseStartedDate.toISOString()
      : <any>undefined;
    data['courseCompletedDate'] = this.courseCompletedDate
      ? this.courseCompletedDate.toISOString()
      : <any>undefined;
    data['lastAccessDate'] = this.lastAccessDate
      ? this.lastAccessDate.toISOString()
      : <any>undefined;
    return data;
  }

  clone(): ScormProgressDto {
    const json = this.toJSON();
    let result = new ScormProgressDto();
    result.init(json);
    return result;
  }
}

export interface IScormProgressDto {
  id: number | undefined;
  courseId: number | undefined;
  userId: number | undefined;
  progressPercentage: number | undefined;
  isCompleted: boolean | undefined;
  courseStartedDate: moment.Moment | undefined;
  courseCompletedDate: moment.Moment | undefined;
  lastAccessDate: moment.Moment | undefined;
}

export class ProgramSummaryDto implements IProgramSummaryDto {
  id: number | undefined;
  name: string | undefined;
  icon: string | undefined;

  constructor(data?: IProgramSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.icon = data['icon'];
    }
  }

  static fromJS(data: any): ProgramSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['icon'] = this.icon;
    return data;
  }

  clone(): ProgramSummaryDto {
    const json = this.toJSON();
    let result = new ProgramSummaryDto();
    result.init(json);
    return result;
  }
}

export interface IProgramSummaryDto {
  id: number | undefined;
  name: string | undefined;
  icon: string | undefined;
}

export class InstructorDto implements IInstructorDto {
  id: number | undefined;
  fullName: string | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
  isActive: boolean | undefined;
  userId?: number;

  constructor(data?: IInstructorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.userId = data['userId'];
      this.fullName = data['fullName'];
      this.thumbnail = data['thumbnail'];
      this.thumbnailUrl = data['thumbnailUrl'];
      this.isActive = data['isActive'];
    }
  }

  static fromJS(data: any): InstructorDto {
    data = typeof data === 'object' ? data : {};
    let result = new InstructorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['thumbnail'] = this.thumbnail;
    data['thumbnailUrl'] = this.thumbnailUrl;
    data['isActive'] = this.isActive;
    return data;
  }

  clone(): InstructorDto {
    const json = this.toJSON();
    let result = new InstructorDto();
    result.init(json);
    return result;
  }
}

export interface IInstructorDto {
  id: number | undefined;
  fullName: string | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
  isActive: boolean | undefined;
}

export class ScormLaunchContextDto implements IScormLaunchContextDto {
  courseId: number | undefined;
  courseName: string | undefined;
  contentMode: CourseContentMode | undefined;
  launchUrl: string | undefined;
  package: ScormPackageDto | undefined;

  constructor(data?: IScormLaunchContextDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.courseId = data['courseId'];
      this.courseName = data['courseName'];
      this.contentMode = data['contentMode'];
      this.launchUrl = data['launchUrl'];
      this.package = data['package']
        ? ScormPackageDto.fromJS(data['package'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ScormLaunchContextDto {
    data = typeof data === 'object' ? data : {};
    let result = new ScormLaunchContextDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['courseId'] = this.courseId;
    data['courseName'] = this.courseName;
    data['contentMode'] = this.contentMode;
    data['launchUrl'] = this.launchUrl;
    data['package'] = this.package ? this.package.toJSON() : <any>undefined;
    return data;
  }

  clone(): ScormLaunchContextDto {
    const json = this.toJSON();
    let result = new ScormLaunchContextDto();
    result.init(json);
    return result;
  }
}

export interface IScormLaunchContextDto {
  courseId: number | undefined;
  courseName: string | undefined;
  contentMode: CourseContentMode | undefined;
  launchUrl: string | undefined;
  package: ScormPackageDto | undefined;
}

export class CourseSummaryDto implements ICourseSummaryDto {
  icon: string | undefined;
  courseName: string | undefined;
  programName: string | undefined;
  progress: number | undefined;
  introVideo: string | undefined;
  description: string | undefined;
  whoIsThisFor: string | undefined;
  skills: string | undefined;
  tools: string | undefined;
  skillsLearned: string[] | undefined;
  requiredTools: string[] | undefined;
  preRequisites: string[] | undefined;
  courseDurationHours: number | undefined;
  classDurationAverage: number | undefined;
  classDurationAverageLabel: string | undefined;
  instructors: InstructorDto[] | undefined;
  material: MaterialDto[] | undefined;
  contentMode: CourseContentMode | undefined;
  scormPackage: ScormPackageDto | undefined;
  id: number | undefined;

  constructor(data?: ICourseSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.icon = data['icon'];
      this.courseName = data['courseName'];
      this.programName = data['programName'];
      this.progress = data['progress'];
      this.introVideo = data['introVideo'];
      this.description = data['description'];
      this.whoIsThisFor = data['whoIsThisFor'];
      this.skills = data['skills'];
      this.tools = data['tools'];
      if (
        data['skillsLearned'] &&
        data['skillsLearned'].constructor === Array
      ) {
        this.skillsLearned = [];
        for (let item of data['skillsLearned']) this.skillsLearned.push(item);
      }
      if (
        data['requiredTools'] &&
        data['requiredTools'].constructor === Array
      ) {
        this.requiredTools = [];
        for (let item of data['requiredTools']) this.requiredTools.push(item);
      }
      if (
        data['preRequisites'] &&
        data['preRequisites'].constructor === Array
      ) {
        this.preRequisites = [];
        for (let item of data['preRequisites']) this.preRequisites.push(item);
      }
      this.courseDurationHours = data['courseDurationHours'];
      this.classDurationAverage = data['classDurationAverage'];
      this.classDurationAverageLabel = data['classDurationAverageLabel'];
      if (data['instructors'] && data['instructors'].constructor === Array) {
        this.instructors = [];
        for (let item of data['instructors'])
          this.instructors.push(InstructorDto.fromJS(item));
      }
      if (data['material'] && data['material'].constructor === Array) {
        this.material = [];
        for (let item of data['material'])
          this.material.push(MaterialDto.fromJS(item));
      }
      this.contentMode = data['contentMode'];
      this.scormPackage = data['scormPackage']
        ? ScormPackageDto.fromJS(data['scormPackage'])
        : <any>undefined;
      this.id = data['id'];
    }
  }

  static fromJS(data: any): CourseSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new CourseSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['icon'] = this.icon;
    data['courseName'] = this.courseName;
    data['programName'] = this.programName;
    data['progress'] = this.progress;
    data['introVideo'] = this.introVideo;
    data['description'] = this.description;
    data['whoIsThisFor'] = this.whoIsThisFor;
    data['skills'] = this.skills;
    data['tools'] = this.tools;
    if (this.skillsLearned && this.skillsLearned.constructor === Array) {
      data['skillsLearned'] = [];
      for (let item of this.skillsLearned) data['skillsLearned'].push(item);
    }
    if (this.requiredTools && this.requiredTools.constructor === Array) {
      data['requiredTools'] = [];
      for (let item of this.requiredTools) data['requiredTools'].push(item);
    }
    if (this.preRequisites && this.preRequisites.constructor === Array) {
      data['preRequisites'] = [];
      for (let item of this.preRequisites) data['preRequisites'].push(item);
    }
    data['courseDurationHours'] = this.courseDurationHours;
    data['classDurationAverage'] = this.classDurationAverage;
    data['classDurationAverageLabel'] = this.classDurationAverageLabel;
    if (this.instructors && this.instructors.constructor === Array) {
      data['instructors'] = [];
      for (let item of this.instructors)
        data['instructors'].push(item.toJSON());
    }
    if (this.material && this.material.constructor === Array) {
      data['material'] = [];
      for (let item of this.material) data['material'].push(item.toJSON());
    }
    data['contentMode'] = this.contentMode;
    data['scormPackage'] = this.scormPackage
      ? this.scormPackage.toJSON()
      : <any>undefined;
    data['id'] = this.id;
    return data;
  }

  clone(): CourseSummaryDto {
    const json = this.toJSON();
    let result = new CourseSummaryDto();
    result.init(json);
    return result;
  }
}

export interface ICourseSummaryDto {
  icon: string | undefined;
  courseName: string | undefined;
  programName: string | undefined;
  progress: number | undefined;
  introVideo: string | undefined;
  description: string | undefined;
  whoIsThisFor: string | undefined;
  skills: string | undefined;
  tools: string | undefined;
  skillsLearned: string[] | undefined;
  requiredTools: string[] | undefined;
  preRequisites: string[] | undefined;
  courseDurationHours: number | undefined;
  classDurationAverage: number | undefined;
  classDurationAverageLabel: string | undefined;
  instructors: InstructorDto[] | undefined;
  material: MaterialDto[] | undefined;
  contentMode: CourseContentMode | undefined;
  scormPackage: ScormPackageDto | undefined;
  id: number | undefined;
}

export class CountCourseResultRequestDto
  implements ICountCourseResultRequestDto {
  programId: number | undefined;
  keywords: string[] | undefined;
  levelOfDifficulty: CountCourseResultRequestDtoLevelOfDifficulty | undefined;
  instructor: string | undefined;
  progress: CountCourseResultRequestDtoProgress | undefined;
  bookmarked: boolean | undefined;

  constructor(data?: ICountCourseResultRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.programId = data['programId'];
      if (data['keywords'] && data['keywords'].constructor === Array) {
        this.keywords = [];
        for (let item of data['keywords']) this.keywords.push(item);
      }
      this.levelOfDifficulty = data['levelOfDifficulty'];
      this.instructor = data['instructor'];
      this.progress = data['progress'];
      this.bookmarked = data['bookmarked'];
    }
  }

  static fromJS(data: any): CountCourseResultRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new CountCourseResultRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['programId'] = this.programId;
    if (this.keywords && this.keywords.constructor === Array) {
      data['keywords'] = [];
      for (let item of this.keywords) data['keywords'].push(item);
    }
    data['levelOfDifficulty'] = this.levelOfDifficulty;
    data['instructor'] = this.instructor;
    data['progress'] = this.progress;
    data['bookmarked'] = this.bookmarked;
    return data;
  }

  clone(): CountCourseResultRequestDto {
    const json = this.toJSON();
    let result = new CountCourseResultRequestDto();
    result.init(json);
    return result;
  }
}

export interface ICountCourseResultRequestDto {
  programId: number | undefined;
  keywords: string[] | undefined;
  levelOfDifficulty: CountCourseResultRequestDtoLevelOfDifficulty | undefined;
  instructor: string | undefined;
  progress: CountCourseResultRequestDtoProgress | undefined;
  bookmarked: boolean | undefined;
}

export class PagedResultDtoOfCourseOverviewDto
  implements IPagedResultDtoOfCourseOverviewDto {
  totalCount: number | undefined;
  items: CourseOverviewDto[] | undefined;

  constructor(data?: IPagedResultDtoOfCourseOverviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(CourseOverviewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfCourseOverviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfCourseOverviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultDtoOfCourseOverviewDto {
    const json = this.toJSON();
    let result = new PagedResultDtoOfCourseOverviewDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultDtoOfCourseOverviewDto {
  totalCount: number | undefined;
  items: CourseOverviewDto[] | undefined;
}

export class CourseOverviewDto implements ICourseOverviewDto {
  name: string | undefined;
  icon: string | undefined;
  levelOfDifficulty: CourseOverviewDtoLevelOfDifficulty | undefined;
  classes: PagedResultDtoOfClassOverviewDto | undefined;
  instructors: InstructorDto[] | undefined;
  progress: number | undefined;
  id: number | undefined;
  indexNumber: number | undefined;
  isCompletedOutside: boolean | undefined;
  contentMode: CourseContentMode | undefined;
  scormPackage: ScormPackageDto | undefined;

  constructor(data?: ICourseOverviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.icon = data['icon'];
      this.levelOfDifficulty = data['levelOfDifficulty'];
      this.classes = data['classes']
        ? PagedResultDtoOfClassOverviewDto.fromJS(data['classes'])
        : <any>undefined;
      if (data['instructors'] && data['instructors'].constructor === Array) {
        this.instructors = [];
        for (let item of data['instructors'])
          this.instructors.push(InstructorDto.fromJS(item));
      }
      this.progress = data['progress'];
      this.id = data['id'];
      this.indexNumber = data['indexNumber'];
      this.isCompletedOutside = data['isCompletedOutside'];
      this.contentMode = data['contentMode'];
      this.scormPackage = data['scormPackage']
        ? ScormPackageDto.fromJS(data['scormPackage'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CourseOverviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new CourseOverviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['icon'] = this.icon;
    data['levelOfDifficulty'] = this.levelOfDifficulty;
    data['classes'] = this.classes ? this.classes.toJSON() : <any>undefined;
    if (this.instructors && this.instructors.constructor === Array) {
      data['instructors'] = [];
      for (let item of this.instructors)
        data['instructors'].push(item.toJSON());
    }
    data['progress'] = this.progress;
    data['id'] = this.id;
    data['indexNumber'] = this.indexNumber;
    data['isCompletedOutside'] = this.isCompletedOutside;
    data['contentMode'] = this.contentMode;
    data['scormPackage'] = this.scormPackage
      ? this.scormPackage.toJSON()
      : <any>undefined;
    return data;
  }

  clone(): CourseOverviewDto {
    const json = this.toJSON();
    let result = new CourseOverviewDto();
    result.init(json);
    return result;
  }
}

export interface ICourseOverviewDto {
  name: string | undefined;
  icon: string | undefined;
  levelOfDifficulty: CourseOverviewDtoLevelOfDifficulty | undefined;
  classes: PagedResultDtoOfClassOverviewDto | undefined;
  instructors: InstructorDto[] | undefined;
  progress: number | undefined;
  id: number | undefined;
  indexNumber: number | undefined;
  isCompletedOutside: boolean | undefined;
  contentMode: CourseContentMode | undefined;
  scormPackage: ScormPackageDto | undefined;
}

export class PagedResultDtoOfCourseMainInfoDto
  implements IPagedResultDtoOfCourseMainInfoDto {
  totalCount: number | undefined;
  items: CourseMainInfoDto[] | undefined;

  constructor(data?: IPagedResultDtoOfCourseMainInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(CourseMainInfoDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfCourseMainInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfCourseMainInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultDtoOfCourseMainInfoDto {
    const json = this.toJSON();
    let result = new PagedResultDtoOfCourseMainInfoDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultDtoOfCourseMainInfoDto {
  totalCount: number | undefined;
  items: CourseMainInfoDto[] | undefined;
}

export class CourseMainInfoDto implements ICourseMainInfoDto {
  id: number | undefined;
  name: string | undefined;
  icon: string | undefined;
  classesCount: number | undefined;
  isPublished: boolean | undefined;
  lastModificationTime: moment.Moment | undefined;
  lastPublicationTime: moment.Moment | undefined;
  contentMode: CourseContentMode | undefined;
  scormPackage: ScormPackageDto | undefined;

  constructor(data?: ICourseMainInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.icon = data['icon'];
      this.classesCount = data['classesCount'];
      this.isPublished = data['isPublished'];
      this.lastModificationTime = data['lastModificationTime']
        ? moment(data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastPublicationTime = data['lastPublicationTime']
        ? moment(data['lastPublicationTime'].toString())
        : <any>undefined;
      this.contentMode = data['contentMode'];
      this.scormPackage = data['scormPackage']
        ? ScormPackageDto.fromJS(data['scormPackage'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CourseMainInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new CourseMainInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['icon'] = this.icon;
    data['classesCount'] = this.classesCount;
    data['isPublished'] = this.isPublished;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastPublicationTime'] = this.lastPublicationTime
      ? this.lastPublicationTime.toISOString()
      : <any>undefined;
    data['contentMode'] = this.contentMode;
    data['scormPackage'] = this.scormPackage
      ? this.scormPackage.toJSON()
      : <any>undefined;
    return data;
  }

  clone(): CourseMainInfoDto {
    const json = this.toJSON();
    let result = new CourseMainInfoDto();
    result.init(json);
    return result;
  }
}

export interface ICourseMainInfoDto {
  id: number | undefined;
  name: string | undefined;
  icon: string | undefined;
  classesCount: number | undefined;
  isPublished: boolean | undefined;
  lastModificationTime: moment.Moment | undefined;
  lastPublicationTime: moment.Moment | undefined;
  contentMode: CourseContentMode | undefined;
  scormPackage: ScormPackageDto | undefined;
}

export class CourseForEditDto implements ICourseForEditDto {
  id: number | undefined;
  name: string;
  description: string | undefined;
  icon: string | undefined;
  whoIsThisFor: string | undefined;
  preRequisites: string | undefined;
  skills: string | undefined;
  requiredTools: string | undefined;

  constructor(data?: ICourseForEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.description = data['description'];
      this.icon = data['icon'];
      this.whoIsThisFor = data['whoIsThisFor'];
      this.preRequisites = data['preRequisites'];
      this.skills = data['skills'];
      this.requiredTools = data['requiredTools'];
    }
  }

  static fromJS(data: any): CourseForEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new CourseForEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    data['icon'] = this.icon;
    data['whoIsThisFor'] = this.whoIsThisFor;
    data['preRequisites'] = this.preRequisites;
    data['skills'] = this.skills;
    data['requiredTools'] = this.requiredTools;
    return data;
  }

  clone(): CourseForEditDto {
    const json = this.toJSON();
    let result = new CourseForEditDto();
    result.init(json);
    return result;
  }
}

export interface ICourseForEditDto {
  id: number | undefined;
  name: string;
  description: string | undefined;
  icon: string | undefined;
  whoIsThisFor: string | undefined;
  preRequisites: string | undefined;
  skills: string | undefined;
  requiredTools: string | undefined;
}

export class CreateCourseDto implements ICreateCourseDto {
  name: string;
  description: string | undefined;
  icon: string | undefined;
  whoIsThisFor: string | undefined;
  preRequisites: string | undefined;
  skills: string | undefined;
  requiredTools: string | undefined;
  tenantId: number | undefined;

  constructor(data?: ICreateCourseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.description = data['description'];
      this.icon = data['icon'];
      this.whoIsThisFor = data['whoIsThisFor'];
      this.preRequisites = data['preRequisites'];
      this.skills = data['skills'];
      this.requiredTools = data['requiredTools'];
      this.tenantId = data['tenantId'];
    }
  }

  static fromJS(data: any): CreateCourseDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateCourseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    data['icon'] = this.icon;
    data['whoIsThisFor'] = this.whoIsThisFor;
    data['preRequisites'] = this.preRequisites;
    data['skills'] = this.skills;
    data['requiredTools'] = this.requiredTools;
    data['tenantId'] = this.tenantId;
    return data;
  }

  clone(): CreateCourseDto {
    const json = this.toJSON();
    let result = new CreateCourseDto();
    result.init(json);
    return result;
  }
}

export interface ICreateCourseDto {
  name: string;
  description: string | undefined;
  icon: string | undefined;
  whoIsThisFor: string | undefined;
  preRequisites: string | undefined;
  skills: string | undefined;
  requiredTools: string | undefined;
  tenantId: number | undefined;
}

export class UpdateCourseStatusDto implements IUpdateCourseStatusDto {
  courseId: number | undefined;
  isPublished: boolean | undefined;

  constructor(data?: IUpdateCourseStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.courseId = data['courseId'];
      this.isPublished = data['isPublished'];
    }
  }

  static fromJS(data: any): UpdateCourseStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateCourseStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['courseId'] = this.courseId;
    data['isPublished'] = this.isPublished;
    return data;
  }

  clone(): UpdateCourseStatusDto {
    const json = this.toJSON();
    let result = new UpdateCourseStatusDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateCourseStatusDto {
  courseId: number | undefined;
  isPublished: boolean | undefined;
}

export class UpdateCourseDto implements IUpdateCourseDto {
  courseId: number | undefined;
  name: string;
  description: string | undefined;
  icon: string | undefined;
  whoIsThisFor: string | undefined;
  preRequisites: string | undefined;
  skills: string | undefined;
  requiredTools: string | undefined;

  constructor(data?: IUpdateCourseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.courseId = data['courseId'];
      this.name = data['name'];
      this.description = data['description'];
      this.icon = data['icon'];
      this.whoIsThisFor = data['whoIsThisFor'];
      this.preRequisites = data['preRequisites'];
      this.skills = data['skills'];
      this.requiredTools = data['requiredTools'];
    }
  }

  static fromJS(data: any): UpdateCourseDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateCourseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['courseId'] = this.courseId;
    data['name'] = this.name;
    data['description'] = this.description;
    data['icon'] = this.icon;
    data['whoIsThisFor'] = this.whoIsThisFor;
    data['preRequisites'] = this.preRequisites;
    data['skills'] = this.skills;
    data['requiredTools'] = this.requiredTools;
    return data;
  }

  clone(): UpdateCourseDto {
    const json = this.toJSON();
    let result = new UpdateCourseDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateCourseDto {
  courseId: number | undefined;
  name: string;
  description: string | undefined;
  icon: string | undefined;
  whoIsThisFor: string | undefined;
  preRequisites: string | undefined;
  skills: string | undefined;
  requiredTools: string | undefined;
}

export class CourseClassAssociationDto implements ICourseClassAssociationDto {
  id: number | undefined;
  indexNumber: number | undefined;
  name: string | undefined;
  isSelected: boolean | undefined;
  isPublished: boolean | undefined;

  constructor(data?: ICourseClassAssociationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.indexNumber = data['indexNumber'];
      this.name = data['name'];
      this.isSelected = data['isSelected'];
      this.isPublished = data['isPublished'];
    }
  }

  static fromJS(data: any): CourseClassAssociationDto {
    data = typeof data === 'object' ? data : {};
    let result = new CourseClassAssociationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['indexNumber'] = this.indexNumber;
    data['name'] = this.name;
    data['isSelected'] = this.isSelected;
    data['isPublished'] = this.isPublished;
    return data;
  }

  clone(): CourseClassAssociationDto {
    const json = this.toJSON();
    let result = new CourseClassAssociationDto();
    result.init(json);
    return result;
  }
}

export interface ICourseClassAssociationDto {
  id: number | undefined;
  indexNumber: number | undefined;
  name: string | undefined;
  isSelected: boolean | undefined;
  isPublished: boolean | undefined;
}

export class AssociateCourseDto implements IAssociateCourseDto {
  courseId: number | undefined;
  associationOrder: CreateOrUpdateCourseAssociationDto[] | undefined;

  constructor(data?: IAssociateCourseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.courseId = data['courseId'];
      if (
        data['associationOrder'] &&
        data['associationOrder'].constructor === Array
      ) {
        this.associationOrder = [];
        for (let item of data['associationOrder'])
          this.associationOrder.push(
            CreateOrUpdateCourseAssociationDto.fromJS(item)
          );
      }
    }
  }

  static fromJS(data: any): AssociateCourseDto {
    data = typeof data === 'object' ? data : {};
    let result = new AssociateCourseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['courseId'] = this.courseId;
    if (this.associationOrder && this.associationOrder.constructor === Array) {
      data['associationOrder'] = [];
      for (let item of this.associationOrder)
        data['associationOrder'].push(item.toJSON());
    }
    return data;
  }

  clone(): AssociateCourseDto {
    const json = this.toJSON();
    let result = new AssociateCourseDto();
    result.init(json);
    return result;
  }
}

export interface IAssociateCourseDto {
  courseId: number | undefined;
  associationOrder: CreateOrUpdateCourseAssociationDto[] | undefined;
}

export class CreateOrUpdateCourseAssociationDto
  implements ICreateOrUpdateCourseAssociationDto {
  classId: number | undefined;
  indexNumber: number | undefined;

  constructor(data?: ICreateOrUpdateCourseAssociationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.classId = data['classId'];
      this.indexNumber = data['indexNumber'];
    }
  }

  static fromJS(data: any): CreateOrUpdateCourseAssociationDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrUpdateCourseAssociationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['classId'] = this.classId;
    data['indexNumber'] = this.indexNumber;
    return data;
  }

  clone(): CreateOrUpdateCourseAssociationDto {
    const json = this.toJSON();
    let result = new CreateOrUpdateCourseAssociationDto();
    result.init(json);
    return result;
  }
}

export interface ICreateOrUpdateCourseAssociationDto {
  classId: number | undefined;
  indexNumber: number | undefined;
}

export class CreateInstitutionDto implements ICreateInstitutionDto {
  name: string | undefined;
  description: string | undefined;
  image: string | undefined;
  isCustomizationEnabled: boolean | undefined;
  subdomain: string | undefined;
  isHideFooter: boolean | undefined;
  mainLogo: string | undefined;
  loginLogo: string | undefined;

  constructor(data?: ICreateInstitutionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.description = data['description'];
      this.image = data['image'];
      this.isCustomizationEnabled = data['isCustomizationEnabled'];
      this.subdomain = data['subdomain'];
      this.isHideFooter = data['isHideFooter'];
      this.mainLogo = data['mainLogo'];
      this.loginLogo = data['loginLogo'];
    }
  }

  static fromJS(data: any): CreateInstitutionDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateInstitutionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    data['image'] = this.image;
    data['isCustomizationEnabled'] = this.isCustomizationEnabled;
    data['subdomain'] = this.subdomain;
    data['isHideFooter'] = this.isHideFooter;
    data['mainLogo'] = this.mainLogo;
    data['loginLogo'] = this.loginLogo;
    return data;
  }

  clone(): CreateInstitutionDto {
    const json = this.toJSON();
    let result = new CreateInstitutionDto();
    result.init(json);
    return result;
  }
}

export interface ICreateInstitutionDto {
  name: string | undefined;
  description: string | undefined;
  image: string | undefined;
  isCustomizationEnabled: boolean | undefined;
  subdomain: string | undefined;
  isHideFooter: boolean | undefined;
  mainLogo: string | undefined;
  loginLogo: string | undefined;
}

export class InstitutionDto implements IInstitutionDto {
  id: number | undefined;
  name: string | undefined;
  subdomain: string | undefined;
  description: string | undefined;
  isActive: boolean | undefined;
  lastModificationTime: moment.Moment | undefined;
  picture: string | undefined;
  pictureUrl: string | undefined;
  isCustomizationEnabled: boolean | undefined;
  isHideFooter: boolean | undefined;
  mainLogo: string | undefined;
  loginLogo: string | undefined;
  favIcon: string | undefined;

  constructor(data?: IInstitutionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.subdomain = data['subdomain'];
      this.description = data['description'];
      this.isActive = data['isActive'];
      this.lastModificationTime = data['lastModificationTime']
        ? moment(data['lastModificationTime'].toString())
        : <any>undefined;
      this.picture = data['picture'];
      this.pictureUrl = data['pictureUrl'];
      this.isCustomizationEnabled = data['isCustomizationEnabled'];
      this.isHideFooter = data['isHideFooter'];
      this.mainLogo = data['mainLogo'];
      this.loginLogo = data['loginLogo'];
      this.favIcon = data['favIcon'];
    }
  }

  static fromJS(data: any): InstitutionDto {
    data = typeof data === 'object' ? data : {};
    let result = new InstitutionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['subdomain'] = this.subdomain;
    data['description'] = this.description;
    data['isActive'] = this.isActive;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['picture'] = this.picture;
    data['pictureUrl'] = this.pictureUrl;
    data['isCustomizationEnabled'] = this.isCustomizationEnabled;
    data['isHideFooter'] = this.isHideFooter;
    data['mainLogo'] = this.mainLogo;
    data['loginLogo'] = this.loginLogo;
    data['favIcon'] = this.favIcon;
    return data;
  }

  clone(): InstitutionDto {
    const json = this.toJSON();
    let result = new InstitutionDto();
    result.init(json);
    return result;
  }
}

export interface IInstitutionDto {
  id: number | undefined;
  name: string | undefined;
  subdomain: string | undefined;
  description: string | undefined;
  isActive: boolean | undefined;
  lastModificationTime: moment.Moment | undefined;
  picture: string | undefined;
  pictureUrl: string | undefined;
  isCustomizationEnabled: boolean | undefined;
  isHideFooter: boolean | undefined;
  mainLogo: string | undefined;
  loginLogo: string | undefined;
  favIcon: string | undefined;
}

export class UpdateInstitutionDto implements IUpdateInstitutionDto {
  id: number | undefined;
  name: string | undefined;
  description: string | undefined;
  image: string | undefined;
  isCustomizationEnabled: boolean | undefined;
  subdomain: string | undefined;
  isHideFooter: boolean | undefined;
  mainLogo: string | undefined;
  loginLogo: string | undefined;

  constructor(data?: IUpdateInstitutionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.description = data['description'];
      this.image = data['image'];
      this.isCustomizationEnabled = data['isCustomizationEnabled'];
      this.subdomain = data['subdomain'];
      this.isHideFooter = data['isHideFooter'];
      this.mainLogo = data['mainLogo'];
      this.loginLogo = data['loginLogo'];
    }
  }

  static fromJS(data: any): UpdateInstitutionDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateInstitutionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    data['image'] = this.image;
    data['isCustomizationEnabled'] = this.isCustomizationEnabled;
    data['subdomain'] = this.subdomain;
    data['isHideFooter'] = this.isHideFooter;
    data['mainLogo'] = this.mainLogo;
    data['loginLogo'] = this.loginLogo;
    return data;
  }

  clone(): UpdateInstitutionDto {
    const json = this.toJSON();
    let result = new UpdateInstitutionDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateInstitutionDto {
  id: number | undefined;
  name: string | undefined;
  description: string | undefined;
  image: string | undefined;
  isCustomizationEnabled: boolean | undefined;
  subdomain: string | undefined;
  isHideFooter: boolean | undefined;
  mainLogo: string | undefined;
  loginLogo: string | undefined;
}

export class UpdateInstitutionStatusDto implements IUpdateInstitutionStatusDto {
  id: number | undefined;
  isActive: boolean | undefined;

  constructor(data?: IUpdateInstitutionStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.isActive = data['isActive'];
    }
  }

  static fromJS(data: any): UpdateInstitutionStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateInstitutionStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['isActive'] = this.isActive;
    return data;
  }

  clone(): UpdateInstitutionStatusDto {
    const json = this.toJSON();
    let result = new UpdateInstitutionStatusDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateInstitutionStatusDto {
  id: number | undefined;
  isActive: boolean | undefined;
}

export class GetInstitutionsResponseDto implements IGetInstitutionsResponseDto {
  currentPage: number | undefined;
  totalPages: number | undefined;
  institutionsCount: number | undefined;
  institutions: InstitutionResponseDto[] | undefined;

  constructor(data?: IGetInstitutionsResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.currentPage = data['currentPage'];
      this.totalPages = data['totalPages'];
      this.institutionsCount = data['institutionsCount'];
      if (data['institutions'] && data['institutions'].constructor === Array) {
        this.institutions = [];
        for (let item of data['institutions'])
          this.institutions.push(InstitutionResponseDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetInstitutionsResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetInstitutionsResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['institutionsCount'] = this.institutionsCount;
    if (this.institutions && this.institutions.constructor === Array) {
      data['institutions'] = [];
      for (let item of this.institutions)
        data['institutions'].push(item.toJSON());
    }
    return data;
  }

  clone(): GetInstitutionsResponseDto {
    const json = this.toJSON();
    let result = new GetInstitutionsResponseDto();
    result.init(json);
    return result;
  }
}

export interface IGetInstitutionsResponseDto {
  currentPage: number | undefined;
  totalPages: number | undefined;
  institutionsCount: number | undefined;
  institutions: InstitutionResponseDto[] | undefined;
}

export class InstitutionResponseDto implements IInstitutionResponseDto {
  id: number | undefined;
  name: string | undefined;
  isActive: boolean | undefined;
  accountsCount: number | undefined;
  lastModificationTime: moment.Moment | undefined;
  picture: string | undefined;
  pictureUrl: string | undefined;

  constructor(data?: IInstitutionResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.isActive = data['isActive'];
      this.accountsCount = data['accountsCount'];
      this.lastModificationTime = data['lastModificationTime']
        ? moment(data['lastModificationTime'].toString())
        : <any>undefined;
      this.picture = data['picture'];
      this.pictureUrl = data['pictureUrl'];
    }
  }

  static fromJS(data: any): InstitutionResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new InstitutionResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['isActive'] = this.isActive;
    data['accountsCount'] = this.accountsCount;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['picture'] = this.picture;
    data['pictureUrl'] = this.pictureUrl;
    return data;
  }

  clone(): InstitutionResponseDto {
    const json = this.toJSON();
    let result = new InstitutionResponseDto();
    result.init(json);
    return result;
  }
}

export interface IInstitutionResponseDto {
  id: number | undefined;
  name: string | undefined;
  isActive: boolean | undefined;
  accountsCount: number | undefined;
  lastModificationTime: moment.Moment | undefined;
  picture: string | undefined;
  pictureUrl: string | undefined;
}

export class PagedResultDtoOfGetInstitutionsNameResponseDto
  implements IPagedResultDtoOfGetInstitutionsNameResponseDto {
  totalCount: number | undefined;
  items: GetInstitutionsNameResponseDto[] | undefined;

  constructor(data?: IPagedResultDtoOfGetInstitutionsNameResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(GetInstitutionsNameResponseDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetInstitutionsNameResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetInstitutionsNameResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultDtoOfGetInstitutionsNameResponseDto {
    const json = this.toJSON();
    let result = new PagedResultDtoOfGetInstitutionsNameResponseDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultDtoOfGetInstitutionsNameResponseDto {
  totalCount: number | undefined;
  items: GetInstitutionsNameResponseDto[] | undefined;
}

export class GetInstitutionsNameResponseDto
  implements IGetInstitutionsNameResponseDto {
  id: number | undefined;
  name: string | undefined;
  maximumUsers: any;

  constructor(data?: IGetInstitutionsNameResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.maximumUsers = data['maximumUsers'];
    }
  }

  static fromJS(data: any): GetInstitutionsNameResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetInstitutionsNameResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['maximumUsers'] = this.maximumUsers;
    return data;
  }

  clone(): GetInstitutionsNameResponseDto {
    const json = this.toJSON();
    let result = new GetInstitutionsNameResponseDto();
    result.init(json);
    return result;
  }
}

export interface IGetInstitutionsNameResponseDto {
  id: number | undefined;
  name: string | undefined;
  maximumUsers: number | undefined;

}

export class InstructorPreviewDto implements IInstructorPreviewDto {
  id: number | undefined;
  fullName: string | undefined;
  specialization: string | undefined;
  biography: string | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
  coursesCount: number | undefined;
  classesCount: number | undefined;
  classHoursCount: number | undefined;
  linkedInLink: string | undefined;
  facebookLink: string | undefined;
  instagramLink: string | undefined;
  twitterLink: string | undefined;

  constructor(data?: IInstructorPreviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.fullName = data['fullName'];
      this.specialization = data['specialization'];
      this.biography = data['biography'];
      this.thumbnail = data['thumbnail'];
      this.thumbnailUrl = data['thumbnailUrl'];
      this.coursesCount = data['coursesCount'];
      this.classesCount = data['classesCount'];
      this.classHoursCount = data['classHoursCount'];
      this.linkedInLink = data['linkedInLink'];
      this.facebookLink = data['facebookLink'];
      this.instagramLink = data['instagramLink'];
      this.twitterLink = data['twitterLink'];
    }
  }

  static fromJS(data: any): InstructorPreviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new InstructorPreviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['specialization'] = this.specialization;
    data['biography'] = this.biography;
    data['thumbnail'] = this.thumbnail;
    data['thumbnailUrl'] = this.thumbnailUrl;
    data['coursesCount'] = this.coursesCount;
    data['classesCount'] = this.classesCount;
    data['classHoursCount'] = this.classHoursCount;
    data['linkedInLink'] = this.linkedInLink;
    data['facebookLink'] = this.facebookLink;
    data['instagramLink'] = this.instagramLink;
    data['twitterLink'] = this.twitterLink;
    return data;
  }

  clone(): InstructorPreviewDto {
    const json = this.toJSON();
    let result = new InstructorPreviewDto();
    result.init(json);
    return result;
  }
}

export interface IInstructorPreviewDto {
  id: number | undefined;
  fullName: string | undefined;
  specialization: string | undefined;
  biography: string | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
  coursesCount: number | undefined;
  classesCount: number | undefined;
  classHoursCount: number | undefined;
  linkedInLink: string | undefined;
  facebookLink: string | undefined;
  instagramLink: string | undefined;
  twitterLink: string | undefined;
}

export class InstructorProfileDto implements IInstructorProfileDto {
  websiteLink: string | undefined;
  instructorId: number | undefined;
  videoId: string | undefined;
  videoLink: string | undefined;
  experience: string | undefined;
  files: InstructorFileDto[] | undefined;
  id: number | undefined;
  fullName: string | undefined;
  specialization: string | undefined;
  biography: string | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
  coursesCount: number | undefined;
  classesCount: number | undefined;
  classHoursCount: number | undefined;
  linkedInLink: string | undefined;
  facebookLink: string | undefined;
  instagramLink: string | undefined;
  twitterLink: string | undefined;

  constructor(data?: IInstructorProfileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.websiteLink = data['websiteLink'];
      this.instructorId = data['instructorId'];
      this.videoLink = data['videoLink'];
      this.experience = data['experience'];
      if (data['files'] && data['files'].constructor === Array) {
        this.files = [];
        for (let item of data['files'])
          this.files.push(InstructorFileDto.fromJS(item));
      }
      this.id = data['id'];
      this.fullName = data['fullName'];
      this.specialization = data['specialization'];
      this.biography = data['biography'];
      this.thumbnail = data['thumbnail'];
      this.thumbnailUrl = data['thumbnailUrl'];
      this.coursesCount = data['coursesCount'];
      this.classesCount = data['classesCount'];
      this.classHoursCount = data['classHoursCount'];
      this.linkedInLink = data['linkedInLink'];
      this.facebookLink = data['facebookLink'];
      this.instagramLink = data['instagramLink'];
      this.twitterLink = data['twitterLink'];
    }
  }

  static fromJS(data: any): InstructorProfileDto {
    data = typeof data === 'object' ? data : {};
    let result = new InstructorProfileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['websiteLink'] = this.websiteLink;
    data['instructorId'] = this.instructorId;
    data['videoLink'] = this.videoLink;
    data['experience'] = this.experience;
    if (this.files && this.files.constructor === Array) {
      data['files'] = [];
      for (let item of this.files) data['files'].push(item.toJSON());
    }
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['specialization'] = this.specialization;
    data['biography'] = this.biography;
    data['thumbnail'] = this.thumbnail;
    data['thumbnailUrl'] = this.thumbnailUrl;
    data['coursesCount'] = this.coursesCount;
    data['classesCount'] = this.classesCount;
    data['classHoursCount'] = this.classHoursCount;
    data['linkedInLink'] = this.linkedInLink;
    data['facebookLink'] = this.facebookLink;
    data['instagramLink'] = this.instagramLink;
    data['twitterLink'] = this.twitterLink;
    return data;
  }

  clone(): InstructorProfileDto {
    const json = this.toJSON();
    let result = new InstructorProfileDto();
    result.init(json);
    return result;
  }
}

export interface IInstructorProfileDto {
  websiteLink: string | undefined;
  instructorId: number | undefined;
  videoId: string | undefined;
  videoLink: string | undefined;
  experience: string | undefined;
  files: InstructorFileDto[] | undefined;
  id: number | undefined;
  fullName: string | undefined;
  specialization: string | undefined;
  biography: string | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
  coursesCount: number | undefined;
  classesCount: number | undefined;
  classHoursCount: number | undefined;
  linkedInLink: string | undefined;
  facebookLink: string | undefined;
  instagramLink: string | undefined;
  twitterLink: string | undefined;
}

export class InstructorFileDto implements IInstructorFileDto {
  id: number | undefined;
  icon: string | undefined;
  fileName: string | undefined;
  fileURI: string | undefined;

  constructor(data?: IInstructorFileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.icon = data['icon'];
      this.fileName = data['fileName'];
      this.fileURI = data['fileURI'];
    }
  }

  static fromJS(data: any): InstructorFileDto {
    data = typeof data === 'object' ? data : {};
    let result = new InstructorFileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['icon'] = this.icon;
    data['fileName'] = this.fileName;
    data['fileURI'] = this.fileURI;
    return data;
  }

  clone(): InstructorFileDto {
    const json = this.toJSON();
    let result = new InstructorFileDto();
    result.init(json);
    return result;
  }
}

export interface IInstructorFileDto {
  id: number | undefined;
  icon: string | undefined;
  fileName: string | undefined;
  fileURI: string | undefined;
}

export class InstructorNameDto implements IInstructorNameDto {
  id: number | undefined;
  fullName: string | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;

  constructor(data?: IInstructorNameDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.fullName = data['fullName'];
      this.thumbnail = data['thumbnail'];
      this.thumbnailUrl = data['thumbnailUrl'];
    }
  }

  static fromJS(data: any): InstructorNameDto {
    data = typeof data === 'object' ? data : {};
    let result = new InstructorNameDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['thumbnail'] = this.thumbnail;
    data['thumbnailUrl'] = this.thumbnailUrl;
    return data;
  }

  clone(): InstructorNameDto {
    const json = this.toJSON();
    let result = new InstructorNameDto();
    result.init(json);
    return result;
  }
}

export interface IInstructorNameDto {
  id: number | undefined;
  fullName: string | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
}

export class PagedResultDtoOfInstructorMainInfoDto
  implements IPagedResultDtoOfInstructorMainInfoDto {
  totalCount: number | undefined;
  items: InstructorMainInfoDto[] | undefined;

  constructor(data?: IPagedResultDtoOfInstructorMainInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(InstructorMainInfoDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfInstructorMainInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfInstructorMainInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultDtoOfInstructorMainInfoDto {
    const json = this.toJSON();
    let result = new PagedResultDtoOfInstructorMainInfoDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultDtoOfInstructorMainInfoDto {
  totalCount: number | undefined;
  items: InstructorMainInfoDto[] | undefined;
}

export class InstructorMainInfoDto implements IInstructorMainInfoDto {
  id: number | undefined;
  fullName: string | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
  specialization: string | undefined;
  coursesCount: number | undefined;
  classesCount: number | undefined;
  lastModificationTime: moment.Moment | undefined;
  isActive: boolean | undefined;

  constructor(data?: IInstructorMainInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.fullName = data['fullName'];
      this.thumbnail = data['thumbnail'];
      this.thumbnailUrl = data['thumbnailUrl'];
      this.specialization = data['specialization'];
      this.coursesCount = data['coursesCount'];
      this.classesCount = data['classesCount'];
      this.lastModificationTime = data['lastModificationTime']
        ? moment(data['lastModificationTime'].toString())
        : <any>undefined;
      this.isActive = data['isActive'];
    }
  }

  static fromJS(data: any): InstructorMainInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new InstructorMainInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['thumbnail'] = this.thumbnail;
    data['thumbnailUrl'] = this.thumbnailUrl;
    data['specialization'] = this.specialization;
    data['coursesCount'] = this.coursesCount;
    data['classesCount'] = this.classesCount;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['isActive'] = this.isActive;
    return data;
  }

  clone(): InstructorMainInfoDto {
    const json = this.toJSON();
    let result = new InstructorMainInfoDto();
    result.init(json);
    return result;
  }
}

export interface IInstructorMainInfoDto {
  id: number | undefined;
  fullName: string | undefined;
  thumbnail: string | undefined;
  thumbnailUrl: string | undefined;
  specialization: string | undefined;
  coursesCount: number | undefined;
  classesCount: number | undefined;
  lastModificationTime: moment.Moment | undefined;
  isActive: boolean | undefined;
}

export class CreateInstructorDto implements ICreateInstructorDto {
  fullName: string;
  specialization: string | undefined;
  biography: string | undefined;
  experience: string | undefined;
  thumbnail: string | undefined;
  picture: string | undefined;

  constructor(data?: ICreateInstructorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.fullName = data['fullName'];
      this.specialization = data['specialization'];
      this.biography = data['biography'];
      this.experience = data['experience'];
      this.thumbnail = data['thumbnail'];
      this.picture = data['picture'];
    }
  }

  static fromJS(data: any): CreateInstructorDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateInstructorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['fullName'] = this.fullName;
    data['specialization'] = this.specialization;
    data['biography'] = this.biography;
    data['experience'] = this.experience;
    data['thumbnail'] = this.thumbnail;
    data['picture'] = this.picture;
    return data;
  }

  clone(): CreateInstructorDto {
    const json = this.toJSON();
    let result = new CreateInstructorDto();
    result.init(json);
    return result;
  }
}

export interface ICreateInstructorDto {
  fullName: string;
  specialization: string | undefined;
  biography: string| undefined;
  experience: string | undefined;
  thumbnail: string | undefined;
  picture: string | undefined;
}

export class UpdateInstructorDto implements IUpdateInstructorDto {
  id: number | undefined;
  fullName: string;
  specialization: string | undefined;
  biography: string | undefined;
  experience: string | undefined;
  thumbnail: string | undefined;
  picture: string | undefined;
  linkedInLink: string | undefined;
  facebookLink: string | undefined;
  instagramLink: string | undefined;
  twitterLink: string | undefined;
  websiteLink: string | undefined;
  videoLink: string | undefined;

  constructor(data?: IUpdateInstructorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.fullName = data['fullName'];
      this.specialization = data['specialization'];
      this.biography = data['biography'];
      this.experience = data['experience'];
      this.thumbnail = data['thumbnail'];
      this.picture = data['picture'];
      this.linkedInLink = data['linkedInLink'];
      this.facebookLink = data['facebookLink'];
      this.instagramLink = data['instagramLink'];
      this.twitterLink = data['twitterLink'];
      this.websiteLink = data['websiteLink'];
      this.videoLink = data['videoLink'];
    }
  }

  static fromJS(data: any): UpdateInstructorDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateInstructorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['specialization'] = this.specialization;
    data['biography'] = this.biography;
    data['experience'] = this.experience;
    data['thumbnail'] = this.thumbnail;
    data['picture'] = this.picture;
    data['linkedInLink'] = this.linkedInLink;
    data['facebookLink'] = this.facebookLink;
    data['instagramLink'] = this.instagramLink;
    data['twitterLink'] = this.twitterLink;
    data['websiteLink'] = this.websiteLink;
    data['videoLink'] = this.videoLink;
    return data;
  }

  clone(): UpdateInstructorDto {
    const json = this.toJSON();
    let result = new UpdateInstructorDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateInstructorDto {
  id: number | undefined;
  fullName: string;
  specialization: string | undefined;
  biography: string | undefined;
  experience: string | undefined;
  thumbnail: string | undefined;
  picture: string | undefined;
  linkedInLink: string | undefined;
  facebookLink: string | undefined;
  instagramLink: string | undefined;
  twitterLink: string | undefined;
  websiteLink: string | undefined;
  videoLink: string | undefined;
}

export class UpdateInstructorStatusDto implements IUpdateInstructorStatusDto {
  id: number | undefined;
  isActive: boolean | undefined;

  constructor(data?: IUpdateInstructorStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.isActive = data['isActive'];
    }
  }

  static fromJS(data: any): UpdateInstructorStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateInstructorStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['isActive'] = this.isActive;
    return data;
  }

  clone(): UpdateInstructorStatusDto {
    const json = this.toJSON();
    let result = new UpdateInstructorStatusDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateInstructorStatusDto {
  id: number | undefined;
  isActive: boolean | undefined;
}

export class InstructorForEditDto implements IInstructorForEditDto {
  id: number | undefined;
  instructorId: number | undefined;
  fullName: string | undefined;
  specialization: string | undefined;
  biography: string | undefined;
  experience: string | undefined;
  thumbnail: string | undefined;
  picture: string | undefined;
  linkedInLink: string | undefined;
  facebookLink: string | undefined;
  instagramLink: string | undefined;
  twitterLink: string | undefined;
  websiteLink: string | undefined;
  videoLink: string | undefined;
  videoId: string | undefined;
  file: InstructorFileDto | undefined;
  thumbnailUrl: string | undefined;
  pictureUrl: string | undefined;

  constructor(data?: IInstructorForEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.instructorId = data['instructorId'];
      this.fullName = data['fullName'];
      this.specialization = data['specialization'];
      this.biography = data['biography'];
      this.experience = data['experience'];
      this.thumbnail = data['thumbnail'];
      this.picture = data['picture'];
      this.linkedInLink = data['linkedInLink'];
      this.facebookLink = data['facebookLink'];
      this.instagramLink = data['instagramLink'];
      this.twitterLink = data['twitterLink'];
      this.websiteLink = data['websiteLink'];
      this.videoLink = data['videoLink'];
      this.videoId = data['videoId'];
      this.file = data['file']
        ? InstructorFileDto.fromJS(data['file'])
        : <any>undefined;
      this.thumbnailUrl = data['thumbnailUrl'];
      this.pictureUrl = data['pictureUrl'];
    }
  }

  static fromJS(data: any): InstructorForEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new InstructorForEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['instructorId'] = this.instructorId;
    data['fullName'] = this.fullName;
    data['specialization'] = this.specialization;
    data['biography'] = this.biography;
    data['experience'] = this.experience;
    data['thumbnail'] = this.thumbnail;
    data['picture'] = this.picture;
    data['linkedInLink'] = this.linkedInLink;
    data['facebookLink'] = this.facebookLink;
    data['instagramLink'] = this.instagramLink;
    data['twitterLink'] = this.twitterLink;
    data['websiteLink'] = this.websiteLink;
    data['videoLink'] = this.videoLink;
    data['videoId'] = this.videoId;
    data['file'] = this.file ? this.file.toJSON() : <any>undefined;
    data['pictureUrl'] = this.pictureUrl;
    data['thumbnailUrl'] = this.thumbnailUrl;
    return data;
  }

  clone(): InstructorForEditDto {
    const json = this.toJSON();
    let result = new InstructorForEditDto();
    result.init(json);
    return result;
  }
}

export interface IInstructorForEditDto {
  id: number | undefined;
  instructorId: number | undefined;
  fullName: string | undefined;
  specialization: string | undefined;
  biography: string | undefined;
  experience: string | undefined;
  thumbnail: string | undefined;
  picture: string | undefined;
  linkedInLink: string | undefined;
  facebookLink: string | undefined;
  instagramLink: string | undefined;
  twitterLink: string | undefined;
  websiteLink: string | undefined;
  videoLink: string | undefined;
  videoId: string | undefined;
  file: InstructorFileDto | undefined;
  thumbnailUrl: string | undefined;
  pictureUrl: string | undefined;
}

export class IFormFile implements IIFormFile {
  contentType: string | undefined;
  contentDisposition: string | undefined;
  headers: { [key: string]: string[] } | undefined;
  length: number | undefined;
  name: string | undefined;
  fileName: string | undefined;

  constructor(data?: IIFormFile) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.contentType = data['contentType'];
      this.contentDisposition = data['contentDisposition'];
      if (data['headers']) {
        this.headers = {};
        for (let key in data['headers']) {
          if (data['headers'].hasOwnProperty(key))
            this.headers[key] =
              data['headers'][key] !== undefined ? data['headers'][key] : [];
        }
      }
      this.length = data['length'];
      this.name = data['name'];
      this.fileName = data['fileName'];
    }
  }

  static fromJS(data: any): IFormFile {
    data = typeof data === 'object' ? data : {};
    let result = new IFormFile();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contentType'] = this.contentType;
    data['contentDisposition'] = this.contentDisposition;
    if (this.headers) {
      data['headers'] = {};
      for (let key in this.headers) {
        if (this.headers.hasOwnProperty(key))
          data['headers'][key] = this.headers[key];
      }
    }
    data['length'] = this.length;
    data['name'] = this.name;
    data['fileName'] = this.fileName;
    return data;
  }

  clone(): IFormFile {
    const json = this.toJSON();
    let result = new IFormFile();
    result.init(json);
    return result;
  }
}

export interface IIFormFile {
  contentType: string | undefined;
  contentDisposition: string | undefined;
  headers: { [key: string]: string[] } | undefined;
  length: number | undefined;
  name: string | undefined;
  fileName: string | undefined;
}

export class UpdateMaterialDescriptionDto
  implements IUpdateMaterialDescriptionDto {
  id: number | undefined;
  description: string | undefined;

  constructor(data?: IUpdateMaterialDescriptionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.description = data['description'];
    }
  }

  static fromJS(data: any): UpdateMaterialDescriptionDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateMaterialDescriptionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['description'] = this.description;
    return data;
  }

  clone(): UpdateMaterialDescriptionDto {
    const json = this.toJSON();
    let result = new UpdateMaterialDescriptionDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateMaterialDescriptionDto {
  id: number | undefined;
  description: string | undefined;
}

export class ListResultDtoOfProgramOverviewDto
  implements IListResultDtoOfProgramOverviewDto {
  items: ProgramOverviewDto[] | undefined;

  constructor(data?: IListResultDtoOfProgramOverviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(ProgramOverviewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfProgramOverviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfProgramOverviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): ListResultDtoOfProgramOverviewDto {
    const json = this.toJSON();
    let result = new ListResultDtoOfProgramOverviewDto();
    result.init(json);
    return result;
  }
}

export interface IListResultDtoOfProgramOverviewDto {
  items: ProgramOverviewDto[] | undefined;
}

export class ProgramOverviewDto implements IProgramOverviewDto {
  name: string | undefined;
  description: string | undefined;
  icon: string | undefined;
  backgroundImage: string | undefined;
  colorTheme: string | undefined;
  indexNumber: number | undefined;
  courses: string[] | undefined;
  coursesCount: number | undefined;
  classesCount: number | undefined;
  instructors: ProgramInstructorDto[] | undefined;
  instructorsCount: number | undefined;
  progressPercentage: number | undefined;
  id: number | undefined;

  constructor(data?: IProgramOverviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.description = data['description'];
      this.icon = data['icon'];
      this.backgroundImage = data['backgroundImage'];
      this.colorTheme = data['colorTheme'];
      this.indexNumber = data['indexNumber'];
      if (data['courses'] && data['courses'].constructor === Array) {
        this.courses = [];
        for (let item of data['courses']) this.courses.push(item);
      }
      this.coursesCount = data['coursesCount'];
      this.classesCount = data['classesCount'];
      if (data['instructors'] && data['instructors'].constructor === Array) {
        this.instructors = [];
        for (let item of data['instructors'])
          this.instructors.push(ProgramInstructorDto.fromJS(item));
      }
      this.instructorsCount = data['instructorsCount'];
      this.progressPercentage = data['progressPercentage'];
      this.id = data['id'];
    }
  }

  static fromJS(data: any): ProgramOverviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramOverviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    data['icon'] = this.icon;
    data['backgroundImage'] = this.backgroundImage;
    data['colorTheme'] = this.colorTheme;
    data['indexNumber'] = this.indexNumber;
    if (this.courses && this.courses.constructor === Array) {
      data['courses'] = [];
      for (let item of this.courses) data['courses'].push(item);
    }
    data['coursesCount'] = this.coursesCount;
    data['classesCount'] = this.classesCount;
    if (this.instructors && this.instructors.constructor === Array) {
      data['instructors'] = [];
      for (let item of this.instructors)
        data['instructors'].push(item.toJSON());
    }
    data['instructorsCount'] = this.instructorsCount;
    data['progressPercentage'] = this.progressPercentage;
    data['id'] = this.id;
    return data;
  }

  clone(): ProgramOverviewDto {
    const json = this.toJSON();
    let result = new ProgramOverviewDto();
    result.init(json);
    return result;
  }
}

export interface IProgramOverviewDto {
  name: string | undefined;
  description: string | undefined;
  icon: string | undefined;
  backgroundImage: string | undefined;
  colorTheme: string | undefined;
  indexNumber: number | undefined;
  courses: string[] | undefined;
  coursesCount: number | undefined;
  classesCount: number | undefined;
  instructors: ProgramInstructorDto[] | undefined;
  instructorsCount: number | undefined;
  progressPercentage: number | undefined;
  id: number | undefined;
}

export class ProgramInstructorDto implements IProgramInstructorDto {
  id: number | undefined;
  fullName: string | undefined;
  thumbnail: string | undefined;
  isActive: boolean | undefined;

  constructor(data?: IProgramInstructorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.fullName = data['fullName'];
      this.thumbnail = data['thumbnail'];
      this.isActive = data['isActive'];
    }
  }

  static fromJS(data: any): ProgramInstructorDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramInstructorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['thumbnail'] = this.thumbnail;
    data['isActive'] = this.isActive;
    return data;
  }

  clone(): ProgramInstructorDto {
    const json = this.toJSON();
    let result = new ProgramInstructorDto();
    result.init(json);
    return result;
  }
}

export interface IProgramInstructorDto {
  id: number | undefined;
  fullName: string | undefined;
  thumbnail: string | undefined;
  isActive: boolean | undefined;
}

export class PagedResultDtoOfPagedProgramsResponseDto
  implements IPagedResultDtoOfPagedProgramsResponseDto {
  totalCount: number | undefined;
  items: PagedProgramsResponseDto[] | undefined;

  constructor(data?: IPagedResultDtoOfPagedProgramsResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(PagedProgramsResponseDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfPagedProgramsResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfPagedProgramsResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultDtoOfPagedProgramsResponseDto {
    const json = this.toJSON();
    let result = new PagedResultDtoOfPagedProgramsResponseDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultDtoOfPagedProgramsResponseDto {
  totalCount: number | undefined;
  items: PagedProgramsResponseDto[] | undefined;
}

export class PagedProgramsResponseDto implements IPagedProgramsResponseDto {
  id: number | undefined;
  name: string | undefined;
  lastModificationTime: moment.Moment | undefined;
  lastActivationTime: moment.Moment | undefined;
  isActive: boolean | undefined;
  isCourseAssociationExists: boolean | undefined;
  color: string | undefined;
  indexNumber: number | undefined;
  access: PagedProgramsResponseDtoAccess | undefined;

  constructor(data?: IPagedProgramsResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.lastModificationTime = data['lastModificationTime']
        ? moment(data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastActivationTime = data['lastActivationTime']
        ? moment(data['lastActivationTime'].toString())
        : <any>undefined;
      this.isActive = data['isActive'];
      this.isCourseAssociationExists = data['isCourseAssociationExists'];
      this.color = data['color'];
      this.indexNumber = data['indexNumber'];
      this.access = data['access'];
    }
  }

  static fromJS(data: any): PagedProgramsResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedProgramsResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastActivationTime'] = this.lastActivationTime
      ? this.lastActivationTime.toISOString()
      : <any>undefined;
    data['isActive'] = this.isActive;
    data['isCourseAssociationExists'] = this.isCourseAssociationExists;
    data['color'] = this.color;
    data['indexNumber'] = this.indexNumber;
    data['access'] = this.access;
    return data;
  }

  clone(): PagedProgramsResponseDto {
    const json = this.toJSON();
    let result = new PagedProgramsResponseDto();
    result.init(json);
    return result;
  }
}

export interface IPagedProgramsResponseDto {
  id: number | undefined;
  name: string | undefined;
  lastModificationTime: moment.Moment | undefined;
  lastActivationTime: moment.Moment | undefined;
  isActive: boolean | undefined;
  isCourseAssociationExists: boolean | undefined;
  color: string | undefined;
  indexNumber: number | undefined;
  access: PagedProgramsResponseDtoAccess | undefined;
}

export class CreateProgramDto implements ICreateProgramDto {
  name: string;
  description: string | undefined;
  backgroundImage: string | undefined;
  colorTheme: string | undefined;
  icon: string | undefined;
  access: CreateProgramDtoAccess | undefined;
  institutions: number[] | undefined;

  constructor(data?: ICreateProgramDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.description = data['description'];
      this.backgroundImage = data['backgroundImage'];
      this.colorTheme = data['colorTheme'];
      this.icon = data['icon'];
      this.access = data['access'];
      if (data['institutions'] && data['institutions'].constructor === Array) {
        this.institutions = [];
        for (let item of data['institutions']) this.institutions.push(item);
      }
    }
  }

  static fromJS(data: any): CreateProgramDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateProgramDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    data['backgroundImage'] = this.backgroundImage;
    data['colorTheme'] = this.colorTheme;
    data['icon'] = this.icon;
    data['access'] = this.access;
    if (this.institutions && this.institutions.constructor === Array) {
      data['institutions'] = [];
      for (let item of this.institutions) data['institutions'].push(item);
    }
    return data;
  }

  clone(): CreateProgramDto {
    const json = this.toJSON();
    let result = new CreateProgramDto();
    result.init(json);
    return result;
  }
}

export interface ICreateProgramDto {
  name: string;
  description: string | undefined;
  backgroundImage: string | undefined;
  colorTheme: string | undefined;
  icon: string | undefined;
  access: CreateProgramDtoAccess | undefined;
  institutions: number[] | undefined;
}

export class ProgramResponseDto implements IProgramResponseDto {
  id: number | undefined;
  indexNumber: number | undefined;
  name: string | undefined;
  description: string | undefined;
  icon: string | undefined;
  backgroundImage: string | undefined;
  colorTheme: string | undefined;
  access: ProgramResponseDtoAccess | undefined;
  lastModificatonTime: moment.Moment | undefined;
  lastActivationTime: moment.Moment | undefined;
  progressPercentage: number | undefined;
  isActive: number | undefined;
  institutions: InstitutionShort[] | undefined;

  constructor(data?: IProgramResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.indexNumber = data['indexNumber'];
      this.name = data['name'];
      this.description = data['description'];
      this.icon = data['icon'];
      this.backgroundImage = data['backgroundImage'];
      this.colorTheme = data['colorTheme'];
      this.access = data['access'];
      this.lastModificatonTime = data['lastModificatonTime']
        ? moment(data['lastModificatonTime'].toString())
        : <any>undefined;
      this.lastActivationTime = data['lastActivationTime']
        ? moment(data['lastActivationTime'].toString())
        : <any>undefined;
      this.progressPercentage = data['progressPercentage'];
      this.isActive = data['isActive'];
      if (data['institutions'] && data['institutions'].constructor === Array) {
        this.institutions = [];
        for (let item of data['institutions'])
          this.institutions.push(InstitutionShort.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ProgramResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['indexNumber'] = this.indexNumber;
    data['name'] = this.name;
    data['description'] = this.description;
    data['icon'] = this.icon;
    data['backgroundImage'] = this.backgroundImage;
    data['colorTheme'] = this.colorTheme;
    data['access'] = this.access;
    data['lastModificatonTime'] = this.lastModificatonTime
      ? this.lastModificatonTime.toISOString()
      : <any>undefined;
    data['lastActivationTime'] = this.lastActivationTime
      ? this.lastActivationTime.toISOString()
      : <any>undefined;
    data['progressPercentage'] = this.progressPercentage;
    data['isActive'] = this.isActive;
    if (this.institutions && this.institutions.constructor === Array) {
      data['institutions'] = [];
      for (let item of this.institutions)
        data['institutions'].push(item.toJSON());
    }
    return data;
  }

  clone(): ProgramResponseDto {
    const json = this.toJSON();
    let result = new ProgramResponseDto();
    result.init(json);
    return result;
  }
}

export interface IProgramResponseDto {
  id: number | undefined;
  indexNumber: number | undefined;
  name: string | undefined;
  description: string | undefined;
  icon: string | undefined;
  backgroundImage: string | undefined;
  colorTheme: string | undefined;
  access: ProgramResponseDtoAccess | undefined;
  lastModificatonTime: moment.Moment | undefined;
  lastActivationTime: moment.Moment | undefined;
  progressPercentage: number | undefined;
  isActive: number | undefined;
  institutions: InstitutionShort[] | undefined;
}

export class UpdateProgramDto implements IUpdateProgramDto {
  id: number | undefined;
  name: string | undefined;
  description: string | undefined;
  icon: string | undefined;
  backgroundImage: string | undefined;
  colorTheme: string | undefined;
  access: UpdateProgramDtoAccess | undefined;
  institutions: number[] | undefined;

  constructor(data?: IUpdateProgramDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.description = data['description'];
      this.icon = data['icon'];
      this.backgroundImage = data['backgroundImage'];
      this.colorTheme = data['colorTheme'];
      this.access = data['access'];
      if (data['institutions'] && data['institutions'].constructor === Array) {
        this.institutions = [];
        for (let item of data['institutions']) this.institutions.push(item);
      }
    }
  }

  static fromJS(data: any): UpdateProgramDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateProgramDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    data['icon'] = this.icon;
    data['backgroundImage'] = this.backgroundImage;
    data['colorTheme'] = this.colorTheme;
    data['access'] = this.access;
    if (this.institutions && this.institutions.constructor === Array) {
      data['institutions'] = [];
      for (let item of this.institutions) data['institutions'].push(item);
    }
    return data;
  }

  clone(): UpdateProgramDto {
    const json = this.toJSON();
    let result = new UpdateProgramDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateProgramDto {
  id: number | undefined;
  name: string | undefined;
  description: string | undefined;
  icon: string | undefined;
  backgroundImage: string | undefined;
  colorTheme: string | undefined;
  access: UpdateProgramDtoAccess | undefined;
  institutions: number[] | undefined;
}

export class UpdateProgramStatusDto implements IUpdateProgramStatusDto {
  programId: number | undefined;
  isActive: boolean | undefined;

  constructor(data?: IUpdateProgramStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.programId = data['programId'];
      this.isActive = data['isActive'];
    }
  }

  static fromJS(data: any): UpdateProgramStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateProgramStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['programId'] = this.programId;
    data['isActive'] = this.isActive;
    return data;
  }

  clone(): UpdateProgramStatusDto {
    const json = this.toJSON();
    let result = new UpdateProgramStatusDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateProgramStatusDto {
  programId: number | undefined;
  isActive: boolean | undefined;
}

export class ProgramOrderDto implements IProgramOrderDto {
  programId: number | undefined;
  indexNumber: number | undefined;

  constructor(data?: IProgramOrderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.programId = data['programId'];
      this.indexNumber = data['indexNumber'];
    }
  }

  static fromJS(data: any): ProgramOrderDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramOrderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['programId'] = this.programId;
    data['indexNumber'] = this.indexNumber;
    return data;
  }

  clone(): ProgramOrderDto {
    const json = this.toJSON();
    let result = new ProgramOrderDto();
    result.init(json);
    return result;
  }
}

export interface IProgramOrderDto {
  programId: number | undefined;
  indexNumber: number | undefined;
}

export class ProgramAssociationDto implements IProgramAssociationDto {
  id: number | undefined;
  name: string | undefined;
  isSelected: boolean | undefined;
  isPublished: boolean | undefined;

  constructor(data?: IProgramAssociationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.isSelected = data['isSelected'];
      this.isPublished = data['isPublished'];
    }
  }

  static fromJS(data: any): ProgramAssociationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProgramAssociationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['isSelected'] = this.isSelected;
    data['isPublished'] = this.isPublished;
    return data;
  }

  clone(): ProgramAssociationDto {
    const json = this.toJSON();
    let result = new ProgramAssociationDto();
    result.init(json);
    return result;
  }
}

export interface IProgramAssociationDto {
  id: number | undefined;
  name: string | undefined;
  isSelected: boolean | undefined;
  isPublished: boolean | undefined;
}

export class AssociateProgramDto implements IAssociateProgramDto {
  programId: number | undefined;
  associations: number[] | undefined;

  constructor(data?: IAssociateProgramDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.programId = data['programId'];
      if (data['associations'] && data['associations'].constructor === Array) {
        this.associations = [];
        for (let item of data['associations']) this.associations.push(item);
      }
    }
  }

  static fromJS(data: any): AssociateProgramDto {
    data = typeof data === 'object' ? data : {};
    let result = new AssociateProgramDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['programId'] = this.programId;
    if (this.associations && this.associations.constructor === Array) {
      data['associations'] = [];
      for (let item of this.associations) data['associations'].push(item);
    }
    return data;
  }

  clone(): AssociateProgramDto {
    const json = this.toJSON();
    let result = new AssociateProgramDto();
    result.init(json);
    return result;
  }
}

export interface IAssociateProgramDto {
  programId: number | undefined;
  associations: number[] | undefined;
}

export class QuizDto implements IQuizDto {
  id: number | undefined;
  title: string | undefined;
  questions: QuestionDto[] | undefined;

  constructor(data?: IQuizDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.title = data['title'];
      if (data['questions'] && data['questions'].constructor === Array) {
        this.questions = [];
        for (let item of data['questions'])
          this.questions.push(QuestionDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): QuizDto {
    data = typeof data === 'object' ? data : {};
    let result = new QuizDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['title'] = this.title;
    if (this.questions && this.questions.constructor === Array) {
      data['questions'] = [];
      for (let item of this.questions) data['questions'].push(item.toJSON());
    }
    return data;
  }

  clone(): QuizDto {
    const json = this.toJSON();
    let result = new QuizDto();
    result.init(json);
    return result;
  }
}

export interface IQuizDto {
  id: number | undefined;
  title: string | undefined;
  questions: QuestionDto[] | undefined;
}

export class QuestionDto implements IQuestionDto {
  id: number | undefined;
  title: string | undefined;
  body: string | undefined;
  correctAnswer: string | undefined;
  imageUrl: string | undefined;
  questionType: QuestionDtoQuestionType | undefined;
  questionOptions: OptionDto[] | undefined;

  constructor(data?: IQuestionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.title = data['title'];
      this.body = data['body'];
      this.correctAnswer = data['correctAnswer'];
      this.questionType = data['questionType'];
      this.imageUrl = data['imageUrl'];
      if (
        data['questionOptions'] &&
        data['questionOptions'].constructor === Array
      ) {
        this.questionOptions = [];
        for (let item of data['questionOptions'])
          this.questionOptions.push(OptionDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): QuestionDto {
    data = typeof data === 'object' ? data : {};
    let result = new QuestionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['title'] = this.title;
    data['body'] = this.body;
    data['correctAnswer'] = this.correctAnswer;
    data['questionType'] = this.questionType;
    data['imageUrl'] = this.imageUrl;
    if (this.questionOptions && this.questionOptions.constructor === Array) {
      data['questionOptions'] = [];
      for (let item of this.questionOptions)
        data['questionOptions'].push(item.toJSON());
    }
    return data;
  }

  clone(): QuestionDto {
    const json = this.toJSON();
    let result = new QuestionDto();
    result.init(json);
    return result;
  }
}

export interface IQuestionDto {
  id: number | undefined;
  title: string | undefined;
  body: string | undefined;
  imageUrl: string | undefined;
  correctAnswer: string | undefined;
  questionType: QuestionDtoQuestionType | undefined;
  questionOptions: OptionDto[] | undefined;
}

export class OptionDto implements IOptionDto {
  id: number | undefined;
  option: string | undefined;
  isCorrect: boolean | undefined;

  constructor(data?: IOptionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.option = data['option'];
      this.isCorrect = data['isCorrect'];
    }
  }

  static fromJS(data: any): OptionDto {
    data = typeof data === 'object' ? data : {};
    let result = new OptionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['option'] = this.option;
    data['isCorrect'] = this.isCorrect;
    return data;
  }

  clone(): OptionDto {
    const json = this.toJSON();
    let result = new OptionDto();
    result.init(json);
    return result;
  }
}

export interface IOptionDto {
  id: number | undefined;
  option: string | undefined;
  isCorrect: boolean | undefined;
}

export class QuizAnswersDto implements IQuizAnswersDto {
  quizId: number | undefined;
  answers: QuizAnswerDto[] | undefined;

  constructor(data?: IQuizAnswersDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.quizId = data['quizId'];
      if (data['answers'] && data['answers'].constructor === Array) {
        this.answers = [];
        for (let item of data['answers'])
          this.answers.push(QuizAnswerDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): QuizAnswersDto {
    data = typeof data === 'object' ? data : {};
    let result = new QuizAnswersDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['quizId'] = this.quizId;
    if (this.answers && this.answers.constructor === Array) {
      data['answers'] = [];
      for (let item of this.answers) data['answers'].push(item.toJSON());
    }
    return data;
  }

  clone(): QuizAnswersDto {
    const json = this.toJSON();
    let result = new QuizAnswersDto();
    result.init(json);
    return result;
  }
}

export interface IQuizAnswersDto {
  quizId: number | undefined;
  answers: QuizAnswerDto[] | undefined;
}

export class QuizAnswerDto implements IQuizAnswerDto {
  questionId: number | undefined;
  answerOptionsId: number[] | undefined;
  textAnswer: string | undefined;

  constructor(data?: IQuizAnswerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.questionId = data['questionId'];
      if (
        data['answerOptionsId'] &&
        data['answerOptionsId'].constructor === Array
      ) {
        this.answerOptionsId = [];
        for (let item of data['answerOptionsId'])
          this.answerOptionsId.push(item);
      }
      this.textAnswer = data['textAnswer'];
    }
  }

  static fromJS(data: any): QuizAnswerDto {
    data = typeof data === 'object' ? data : {};
    let result = new QuizAnswerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['questionId'] = this.questionId;
    if (this.answerOptionsId && this.answerOptionsId.constructor === Array) {
      data['answerOptionsId'] = [];
      for (let item of this.answerOptionsId) data['answerOptionsId'].push(item);
    }
    data['textAnswer'] = this.textAnswer;
    return data;
  }

  clone(): QuizAnswerDto {
    const json = this.toJSON();
    let result = new QuizAnswerDto();
    result.init(json);
    return result;
  }
}

export interface IQuizAnswerDto {
  questionId: number | undefined;
  answerOptionsId: number[] | undefined;
  textAnswer: string | undefined;
}

export class QuizResultDto implements IQuizResultDto {
  score: number | undefined;
  average: number | undefined;
  correctAnswers: number | undefined;
  lastCompletionTime: moment.Moment | undefined;
  shouldReviewClass :boolean | false;

  constructor(data?: IQuizResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.score = data['score'];
      this.average = data['average'];
      this.correctAnswers = data['correctAnswers'];
      this.shouldReviewClass = data['shouldReviewClass'];
      this.lastCompletionTime = data['lastCompletionTime']
        ? moment(data['lastCompletionTime'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): QuizResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new QuizResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['score'] = this.score;
    data['average'] = this.average;
    data['correctAnswers'] = this.correctAnswers;
    data['lastCompletionTime'] = this.lastCompletionTime
      ? this.lastCompletionTime.toISOString()
      : <any>undefined;
    return data;
  }

  clone(): QuizResultDto {
    const json = this.toJSON();
    let result = new QuizResultDto();
    result.init(json);
    return result;
  }
}

export interface IQuizResultDto {
  score: number | undefined;
  average: number | undefined;
  correctAnswers: number | undefined;
  lastCompletionTime: moment.Moment | undefined;
  shouldReviewClass :boolean | false;
}

export class UserQuizResultDto implements IUserQuizResultDto {
  questions: QuestionDto[] | undefined;
  answers: QuizAnswerDto[] | undefined;

  constructor(data?: IUserQuizResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (data['questions'] && data['questions'].constructor === Array) {
        this.questions = [];
        for (let item of data['questions'])
          this.questions.push(QuestionDto.fromJS(item));
      }
      if (data['answers'] && data['answers'].constructor === Array) {
        this.answers = [];
        for (let item of data['answers'])
          this.answers.push(QuizAnswerDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UserQuizResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserQuizResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.questions && this.questions.constructor === Array) {
      data['questions'] = [];
      for (let item of this.questions) data['questions'].push(item.toJSON());
    }
    if (this.answers && this.answers.constructor === Array) {
      data['answers'] = [];
      for (let item of this.answers) data['answers'].push(item.toJSON());
    }
    return data;
  }

  clone(): UserQuizResultDto {
    const json = this.toJSON();
    let result = new UserQuizResultDto();
    result.init(json);
    return result;
  }
}

export interface IUserQuizResultDto {
  questions: QuestionDto[] | undefined;
  answers: QuizAnswerDto[] | undefined;
}

export class PagedResultDtoOfClassItemDto
  implements IPagedResultDtoOfClassItemDto {
  totalCount: number | undefined;
  items: ClassItemDto[] | undefined;

  constructor(data?: IPagedResultDtoOfClassItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(ClassItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfClassItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfClassItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultDtoOfClassItemDto {
    const json = this.toJSON();
    let result = new PagedResultDtoOfClassItemDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultDtoOfClassItemDto {
  totalCount: number | undefined;
  items: ClassItemDto[] | undefined;
}

export class ClassItemDto implements IClassItemDto {
  classId: number | undefined;
  quizId: number | undefined;
  className: string | undefined;
  isClassDeleted: boolean | undefined;
  lowestScore: number | undefined;
  highestScore: number | undefined;
  averageScore: number | undefined;
  completed: number | undefined;

  constructor(data?: IClassItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.classId = data['classId'];
      this.quizId = data['quizId'];
      this.isClassDeleted = data['isClassDeleted'];
      this.className = data['className'];
      this.lowestScore = data['lowestScore'];
      this.highestScore = data['highestScore'];
      this.averageScore = data['averageScore'];
      this.completed = data['completed'];
    }
  }

  static fromJS(data: any): ClassItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClassItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['classId'] = this.classId;
    data['quizId'] = this.quizId;
    data['className'] = this.className;
    data['lowestScore'] = this.lowestScore;
    data['isClassDeleted'] = this.isClassDeleted;
    data['highestScore'] = this.highestScore;
    data['averageScore'] = this.averageScore;
    data['completed'] = this.completed;
    return data;
  }

  clone(): ClassItemDto {
    const json = this.toJSON();
    let result = new ClassItemDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultDtoOfCompletionResultDto {
  totalCount: number | undefined;
  items: CompletionResultDto[] | undefined;
}

export interface ICompletionResultDto {
  userId: string | undefined;
  fullName: string | undefined;
  userName: string | undefined;
  progress: number | undefined;
  completedDate?: moment.Moment | undefined;
  role: string | undefined;
  status: boolean | undefined;
  learningPath: string | undefined;
  additionalInfo: string | undefined;
  additionalInfo1: string | undefined;
  additionalInfo2: string | undefined;
}

export class PagedResultDtoOfCompletionResultDto
  implements IPagedResultDtoOfCompletionResultDto {
  totalCount: number | undefined;
  items: CompletionResultDto[] | undefined;

  constructor(data?: IPagedResultDtoOfCompletionResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(CompletionResultDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfCompletionResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfCompletionResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultDtoOfCompletionResultDto {
    const json = this.toJSON();
    let result = new PagedResultDtoOfCompletionResultDto();
    result.init(json);
    return result;
  }
}

export interface PagedResultDtoOfCompletionResultDto {
  totalCount: number | undefined;
  items: CompletionResultDto[] | undefined;
}

export class CompletionResultDto implements ICompletionResultDto {
  
  userId: string | undefined;
  fullName: string | undefined;
  userName: string | undefined;
  progress: number | undefined;
  completedDate?:  moment.Moment | undefined;
  role: string | undefined;
  status: boolean | undefined;
  learningPath: string | undefined;
  additionalInfo: string | undefined;
  additionalInfo1: string | undefined;
  additionalInfo2: string | undefined;
  
  constructor(data?: ICompletionResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.userId = data['userId'];
      this.fullName = data['fullName'];
      this.userName = data['userName'];
      this.progress = data['progress'];
      this.completedDate = data['completedDate'];
      this.role = data['role'];
      this.status = data['status'];
      this.learningPath = data['learningPath'];
      this.additionalInfo = data['additionalInfo'];
      this.additionalInfo1 = data['additionalInfo1'];
      this.additionalInfo2 = data['additionalInfo2'];
    }
  }

  static fromJS(data: any): CompletionResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new CompletionResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['fullName'] = this.fullName;
    data['userName'] = this.userName;
    data['progress'] = this.progress;
    data['completedDate'] = this.completedDate;
    data['role'] = this.role;
    data['status'] = this.status;
    data['learningPath'] = this.learningPath;
    data['additionalInfo'] = this.additionalInfo;
    data['additionalInfo1'] = this.additionalInfo1;
    data['additionalInfo2'] = this.additionalInfo2;

    return data;
  }

  clone(): CompletionResultDto {
    const json = this.toJSON();
    let result = new CompletionResultDto();
    result.init(json);
    return result;
  }
}

export interface IUserCompletionResultDto {
  progress: number | undefined;
  completedDate?: moment.Moment | undefined;
  programName: string | undefined;
  courseName: string | undefined;
  className: string | undefined;
}

export interface PagedResultDtoOfUserCompletionResultDto {
  totalCount: number | undefined;
  items: UserCompletionResultDto[] | undefined;
}

export class UserCompletionResultDto implements IUserCompletionResultDto {
  
  progress: number;
  completedDate?: moment.Moment;
  programName: string;
  courseName: string;
  className: string;
  
  constructor(data?: IUserCompletionResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.progress = data['progress'];
      this.completedDate = data['completedDate'];
      this.programName = data['programName'];
      this.courseName = data['courseName'];
      this.className = data['className'];
    }
  }

  static fromJS(data: any): UserCompletionResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserCompletionResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['progress'] = this.progress;
    data['completedDate'] = this.completedDate;
    data['programName'] = this.programName;
    data['courseName'] = this.courseName;
    data['className'] = this.className;
    return data;
  }

  clone(): UserCompletionResultDto {
    const json = this.toJSON();
    let result = new UserCompletionResultDto();
    result.init(json);
    return result;
  }
}

export interface IClassItemDto {
  classId: number | undefined;
  quizId: number | undefined;
  className: string | undefined;
  lowestScore: number | undefined;
  highestScore: number | undefined;
  averageScore: number | undefined;
  completed: number | undefined;
}

export class ClassQuizResultDto implements IClassQuizResultDto {
  quizId: number | undefined;
  quizTitle: string | undefined;
  quizStatus: number | string;
  isUserActive: boolean | undefined;
  scorePercentage: number | string;
  questionsCount: number | undefined;
  totalCount: number | undefined;
  items: ClassQuizResultItemDto[] | undefined;

  constructor(data?: IClassQuizResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.quizId = data['quizId'];
      this.quizTitle = data['quizTitle'];
      this.questionsCount = data['questionsCount'];
      this.quizStatus = data['quizStatus'];
      this.isUserActive = data['isUserActive'];
      this.scorePercentage = data['scorePercentage'];
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(ClassQuizResultItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ClassQuizResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClassQuizResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['quizId'] = this.quizId;
    data['quizTitle'] = this.quizTitle;
    data['quizStatus'] = this.quizStatus;
    data['isUserActive'] = this.isUserActive;
    data['scorePercentage'] = this.scorePercentage;
    data['questionsCount'] = this.questionsCount;
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): ClassQuizResultDto {
    const json = this.toJSON();
    let result = new ClassQuizResultDto();
    result.init(json);
    return result;
  }
}

export interface IClassQuizResultDto {
  quizId: number | undefined;
  quizTitle: string | undefined;
  questionsCount: number | undefined;
  quizStatus: number | string;
  isUserActive: boolean | undefined;
  scorePercentage: number | string;
  totalCount: number | undefined;
  items: ClassQuizResultItemDto[] | undefined;
}

export class ClassQuizResultItemDto implements IClassQuizResultItemDto {
  studentName: string | undefined;
  studentId: number | undefined;
  quizId: number | undefined;
  score: number | undefined;
  questionsCount:  number | undefined;
  quizStatus: number | undefined;
  isUserActive: boolean | undefined;
  scorePercentage: number | undefined;
  lastCompletionTime: moment.Moment | undefined;
  classStartedDate: moment.Moment | undefined;
  classCompletedDate: moment.Moment | undefined;
  resultQuizId: number | undefined;

  constructor(data?: IClassQuizResultItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.studentName = data['studentName'];
      this.studentId = data['studentId'];
      this.quizId = data['quizId']
      this.score = data['score'];
      this.quizStatus = data['quizStatus'];
      this.questionsCount = data['questionsCount'];
      this.isUserActive = data['isUserActive'];
      this.scorePercentage = data['scorePercentage'];
      this.lastCompletionTime = data['lastCompletionTime']
        ? moment(data['lastCompletionTime'].toString())
        : <any>undefined;
      this.classStartedDate = data['classStartedDate']
        ? moment(data['classStartedDate'].toString())
        : <any>undefined;
      this.classCompletedDate = data['classCompletedDate']
        ? moment(data['classCompletedDate'].toString())
        : <any>undefined;
      this.resultQuizId = data['resultQuizId'];
    }
  }

  static fromJS(data: any): ClassQuizResultItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClassQuizResultItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['studentName'] = this.studentName;
    data['quizStatus'] = this.quizStatus;
    data['isUserActive'] = this.isUserActive;
    data['scorePercentage'] = this.scorePercentage;
    data['studentId'] = this.studentId;
    data['score'] = this.score;
    data['lastCompletionTime'] = this.lastCompletionTime
      ? this.lastCompletionTime.toISOString()
      : <any>undefined;
    data['classStartedDate'] = this.classStartedDate
      ? this.classStartedDate.toISOString()
      : <any>undefined;
    data['classCompletedDate'] = this.classCompletedDate
      ? this.classCompletedDate.toISOString()
      : <any>undefined;
    data['resultQuizId'] = this.resultQuizId;
    return data;
  }

  clone(): ClassQuizResultItemDto {
    const json = this.toJSON();
    let result = new ClassQuizResultItemDto();
    result.init(json);
    return result;
  }
}

export interface IClassQuizResultItemDto {
  studentName: string | undefined;
  studentId: number | undefined;
  quizId: number | undefined;
  score: number | undefined;
  quizStatus: number | undefined;
  isUserActive: boolean | undefined;
  scorePercentage: number | undefined;
  lastCompletionTime: moment.Moment | undefined;
  classStartedDate: moment.Moment | undefined;
  classCompletedDate: moment.Moment | undefined;
  resultQuizId: number | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
  name: string;
  displayName: string;
  normalizedName: string | undefined;
  description: string | undefined;
  permissions: string[] | undefined;

  constructor(data?: ICreateRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.displayName = data['displayName'];
      this.normalizedName = data['normalizedName'];
      this.description = data['description'];
      if (data['permissions'] && data['permissions'].constructor === Array) {
        this.permissions = [];
        for (let item of data['permissions']) this.permissions.push(item);
      }
    }
  }

  static fromJS(data: any): CreateRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['displayName'] = this.displayName;
    data['normalizedName'] = this.normalizedName;
    data['description'] = this.description;
    if (this.permissions && this.permissions.constructor === Array) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item);
    }
    return data;
  }

  clone(): CreateRoleDto {
    const json = this.toJSON();
    let result = new CreateRoleDto();
    result.init(json);
    return result;
  }
}

export interface ICreateRoleDto {
  name: string;
  displayName: string;
  normalizedName: string | undefined;
  description: string | undefined;
  permissions: string[] | undefined;
}

export class RoleDto implements IRoleDto {
  name: string;
  displayName: string;
  normalizedName: string | undefined;
  description: string | undefined;
  permissions: string[] | undefined;
  id: number | undefined;

  constructor(data?: IRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.displayName = data['displayName'];
      this.normalizedName = data['normalizedName'];
      this.description = data['description'];
      if (data['permissions'] && data['permissions'].constructor === Array) {
        this.permissions = [];
        for (let item of data['permissions']) this.permissions.push(item);
      }
      this.id = data['id'];
    }
  }

  static fromJS(data: any): RoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new RoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['displayName'] = this.displayName;
    data['normalizedName'] = this.normalizedName;
    data['description'] = this.description;
    if (this.permissions && this.permissions.constructor === Array) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item);
    }
    data['id'] = this.id;
    return data;
  }

  clone(): RoleDto {
    const json = this.toJSON();
    let result = new RoleDto();
    result.init(json);
    return result;
  }
}

export interface IRoleDto {
  name: string;
  displayName: string;
  normalizedName: string | undefined;
  description: string | undefined;
  permissions: string[] | undefined;
  id: number | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
  items: RoleListDto[] | undefined;

  constructor(data?: IListResultDtoOfRoleListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(RoleListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfRoleListDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfRoleListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): ListResultDtoOfRoleListDto {
    const json = this.toJSON();
    let result = new ListResultDtoOfRoleListDto();
    result.init(json);
    return result;
  }
}

export interface IListResultDtoOfRoleListDto {
  items: RoleListDto[] | undefined;
}

export class RoleListDto implements IRoleListDto {
  name: string | undefined;
  displayName: string | undefined;
  isStatic: boolean | undefined;
  isDefault: boolean | undefined;
  creationTime: moment.Moment | undefined;
  id: number | undefined;

  constructor(data?: IRoleListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.displayName = data['displayName'];
      this.isStatic = data['isStatic'];
      this.isDefault = data['isDefault'];
      this.creationTime = data['creationTime']
        ? moment(data['creationTime'].toString())
        : <any>undefined;
      this.id = data['id'];
    }
  }

  static fromJS(data: any): RoleListDto {
    data = typeof data === 'object' ? data : {};
    let result = new RoleListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['displayName'] = this.displayName;
    data['isStatic'] = this.isStatic;
    data['isDefault'] = this.isDefault;
    data['creationTime'] = this.creationTime
      ? this.creationTime.toISOString()
      : <any>undefined;
    data['id'] = this.id;
    return data;
  }

  clone(): RoleListDto {
    const json = this.toJSON();
    let result = new RoleListDto();
    result.init(json);
    return result;
  }
}

export interface IRoleListDto {
  name: string | undefined;
  displayName: string | undefined;
  isStatic: boolean | undefined;
  isDefault: boolean | undefined;
  creationTime: moment.Moment | undefined;
  id: number | undefined;
}

export class ListResultDtoOfPermissionDto
  implements IListResultDtoOfPermissionDto {
  items: PermissionDto[] | undefined;

  constructor(data?: IListResultDtoOfPermissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items'])
          this.items.push(PermissionDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfPermissionDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfPermissionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): ListResultDtoOfPermissionDto {
    const json = this.toJSON();
    let result = new ListResultDtoOfPermissionDto();
    result.init(json);
    return result;
  }
}

export interface IListResultDtoOfPermissionDto {
  items: PermissionDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
  id: number | undefined;

  constructor(data?: IPermissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.displayName = data['displayName'];
      this.description = data['description'];
      this.id = data['id'];
    }
  }

  static fromJS(data: any): PermissionDto {
    data = typeof data === 'object' ? data : {};
    let result = new PermissionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['displayName'] = this.displayName;
    data['description'] = this.description;
    data['id'] = this.id;
    return data;
  }

  clone(): PermissionDto {
    const json = this.toJSON();
    let result = new PermissionDto();
    result.init(json);
    return result;
  }
}

export interface IPermissionDto {
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
  id: number | undefined;
}

export class IdentityResult implements IIdentityResult {
  succeeded: boolean | undefined;
  errors: IdentityError[] | undefined;

  constructor(data?: IIdentityResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.succeeded = data['succeeded'];
      if (data['errors'] && data['errors'].constructor === Array) {
        this.errors = [];
        for (let item of data['errors'])
          this.errors.push(IdentityError.fromJS(item));
      }
    }
  }

  static fromJS(data: any): IdentityResult {
    data = typeof data === 'object' ? data : {};
    let result = new IdentityResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['succeeded'] = this.succeeded;
    if (this.errors && this.errors.constructor === Array) {
      data['errors'] = [];
      for (let item of this.errors) data['errors'].push(item.toJSON());
    }
    return data;
  }

  clone(): IdentityResult {
    const json = this.toJSON();
    let result = new IdentityResult();
    result.init(json);
    return result;
  }
}

export interface IIdentityResult {
  succeeded: boolean | undefined;
  errors: IdentityError[] | undefined;
}

export class IdentityError implements IIdentityError {
  code: string | undefined;
  description: string | undefined;

  constructor(data?: IIdentityError) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.code = data['code'];
      this.description = data['description'];
    }
  }

  static fromJS(data: any): IdentityError {
    data = typeof data === 'object' ? data : {};
    let result = new IdentityError();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['code'] = this.code;
    data['description'] = this.description;
    return data;
  }

  clone(): IdentityError {
    const json = this.toJSON();
    let result = new IdentityError();
    result.init(json);
    return result;
  }
}

export interface IIdentityError {
  code: string | undefined;
  description: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
  role: RoleEditDto | undefined;
  permissions: FlatPermissionDto[] | undefined;
  grantedPermissionNames: string[] | undefined;

  constructor(data?: IGetRoleForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.role = data['role']
        ? RoleEditDto.fromJS(data['role'])
        : <any>undefined;
      if (data['permissions'] && data['permissions'].constructor === Array) {
        this.permissions = [];
        for (let item of data['permissions'])
          this.permissions.push(FlatPermissionDto.fromJS(item));
      }
      if (
        data['grantedPermissionNames'] &&
        data['grantedPermissionNames'].constructor === Array
      ) {
        this.grantedPermissionNames = [];
        for (let item of data['grantedPermissionNames'])
          this.grantedPermissionNames.push(item);
      }
    }
  }

  static fromJS(data: any): GetRoleForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetRoleForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['role'] = this.role ? this.role.toJSON() : <any>undefined;
    if (this.permissions && this.permissions.constructor === Array) {
      data['permissions'] = [];
      for (let item of this.permissions)
        data['permissions'].push(item.toJSON());
    }
    if (
      this.grantedPermissionNames &&
      this.grantedPermissionNames.constructor === Array
    ) {
      data['grantedPermissionNames'] = [];
      for (let item of this.grantedPermissionNames)
        data['grantedPermissionNames'].push(item);
    }
    return data;
  }

  clone(): GetRoleForEditOutput {
    const json = this.toJSON();
    let result = new GetRoleForEditOutput();
    result.init(json);
    return result;
  }
}

export interface IGetRoleForEditOutput {
  role: RoleEditDto | undefined;
  permissions: FlatPermissionDto[] | undefined;
  grantedPermissionNames: string[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
  name: string;
  displayName: string;
  description: string | undefined;
  isStatic: boolean | undefined;
  id: number | undefined;

  constructor(data?: IRoleEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.displayName = data['displayName'];
      this.description = data['description'];
      this.isStatic = data['isStatic'];
      this.id = data['id'];
    }
  }

  static fromJS(data: any): RoleEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new RoleEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['displayName'] = this.displayName;
    data['description'] = this.description;
    data['isStatic'] = this.isStatic;
    data['id'] = this.id;
    return data;
  }

  clone(): RoleEditDto {
    const json = this.toJSON();
    let result = new RoleEditDto();
    result.init(json);
    return result;
  }
}

export interface IRoleEditDto {
  name: string;
  displayName: string;
  description: string | undefined;
  isStatic: boolean | undefined;
  id: number | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;

  constructor(data?: IFlatPermissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.displayName = data['displayName'];
      this.description = data['description'];
    }
  }

  static fromJS(data: any): FlatPermissionDto {
    data = typeof data === 'object' ? data : {};
    let result = new FlatPermissionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['displayName'] = this.displayName;
    data['description'] = this.description;
    return data;
  }

  clone(): FlatPermissionDto {
    const json = this.toJSON();
    let result = new FlatPermissionDto();
    result.init(json);
    return result;
  }
}

export interface IFlatPermissionDto {
  name: string | undefined;
  displayName: string | undefined;
  description: string | undefined;
}

export class PagedResultDtoOfRoleDto implements IPagedResultDtoOfRoleDto {
  totalCount: number | undefined;
  items: RoleDto[] | undefined;

  constructor(data?: IPagedResultDtoOfRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items']) this.items.push(RoleDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultDtoOfRoleDto {
    const json = this.toJSON();
    let result = new PagedResultDtoOfRoleDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultDtoOfRoleDto {
  totalCount: number | undefined;
  items: RoleDto[] | undefined;
}

export class GetCurrentLoginInformationsOutput
  implements IGetCurrentLoginInformationsOutput {
  application: ApplicationInfoDto | undefined;
  user: UserLoginInfoDto | undefined;
  tenant: TenantLoginInfoDto | undefined;
  institution: InstitutionLoginInfoDto | undefined;

  constructor(data?: IGetCurrentLoginInformationsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.application = data['application']
        ? ApplicationInfoDto.fromJS(data['application'])
        : <any>undefined;
      this.user = data['user']
        ? UserLoginInfoDto.fromJS(data['user'])
        : <any>undefined;
      this.tenant = data['tenant']
        ? TenantLoginInfoDto.fromJS(data['tenant'])
        : <any>undefined;
      this.institution = data['institution']
        ? InstitutionLoginInfoDto.fromJS(data['institution'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): GetCurrentLoginInformationsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetCurrentLoginInformationsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['application'] = this.application
      ? this.application.toJSON()
      : <any>undefined;
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['tenant'] = this.tenant ? this.tenant.toJSON() : <any>undefined;
    data['institution'] = this.institution
      ? this.institution.toJSON()
      : <any>undefined;
    return data;
  }

  clone(): GetCurrentLoginInformationsOutput {
    const json = this.toJSON();
    let result = new GetCurrentLoginInformationsOutput();
    result.init(json);
    return result;
  }
}

export interface IGetCurrentLoginInformationsOutput {
  application: ApplicationInfoDto | undefined;
  user: UserLoginInfoDto | undefined;
  tenant: TenantLoginInfoDto | undefined;
  institution: InstitutionLoginInfoDto | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
  version: string | undefined;
  releaseDate: moment.Moment | undefined;
  features: { [key: string]: boolean } | undefined;

  constructor(data?: IApplicationInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.version = data['version'];
      this.releaseDate = data['releaseDate']
        ? moment(data['releaseDate'].toString())
        : <any>undefined;
      if (data['features']) {
        this.features = {};
        for (let key in data['features']) {
          if (data['features'].hasOwnProperty(key))
            this.features[key] = data['features'][key];
        }
      }
    }
  }

  static fromJS(data: any): ApplicationInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['version'] = this.version;
    data['releaseDate'] = this.releaseDate
      ? this.releaseDate.toISOString()
      : <any>undefined;
    if (this.features) {
      data['features'] = {};
      for (let key in this.features) {
        if (this.features.hasOwnProperty(key))
          data['features'][key] = this.features[key];
      }
    }
    return data;
  }

  clone(): ApplicationInfoDto {
    const json = this.toJSON();
    let result = new ApplicationInfoDto();
    result.init(json);
    return result;
  }
}

export interface IApplicationInfoDto {
  version: string | undefined;
  releaseDate: moment.Moment | undefined;
  features: { [key: string]: boolean } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
  fullName: string | undefined;
  userName: string | undefined;
  emailAddress: string | undefined;
  id: number | undefined;
  thumbnailUrl?: string | undefined;

  constructor(data?: IUserLoginInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.fullName = data['fullName'];
      this.userName = data['userName'];
      this.emailAddress = data['emailAddress'];
      this.id = data['id'];
      this.thumbnailUrl = data['thumbnailUrl'];
    }
  }

  static fromJS(data: any): UserLoginInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserLoginInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['fullName'] = this.fullName;
    data['userName'] = this.userName;
    data['emailAddress'] = this.emailAddress;
    data['id'] = this.id;
    return data;
  }

  clone(): UserLoginInfoDto {
    const json = this.toJSON();
    let result = new UserLoginInfoDto();
    result.init(json);
    return result;
  }
}

export interface IUserLoginInfoDto {
  fullName: string | undefined;
  userName: string | undefined;
  emailAddress: string | undefined;
  id: number | undefined;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
  tenancyName: string | undefined;
  name: string | undefined;
  id: number | undefined;
  isScormEnabled: boolean | undefined;

  constructor(data?: ITenantLoginInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.tenancyName = data['tenancyName'];
      this.name = data['name'];
      this.id = data['id'];
      this.isScormEnabled = data['isScormEnabled'];
    }
  }

  static fromJS(data: any): TenantLoginInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantLoginInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenancyName'] = this.tenancyName;
    data['name'] = this.name;
    data['id'] = this.id;
    data['isScormEnabled'] = this.isScormEnabled;
    return data;
  }

  clone(): TenantLoginInfoDto {
    const json = this.toJSON();
    let result = new TenantLoginInfoDto();
    result.init(json);
    return result;
  }
}

export interface ITenantLoginInfoDto {
  tenancyName: string | undefined;
  name: string | undefined;
  id: number | undefined;
  isScormEnabled: boolean | undefined;
}

export class InstitutionLoginInfoDto implements IInstitutionLoginInfoDto {
  name: string | undefined;
  picture: string | undefined;
  id: number | undefined;

  constructor(data?: IInstitutionLoginInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.picture = data['pictureUrl'];
      this.id = data['id'];
    }
  }

  static fromJS(data: any): InstitutionLoginInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new InstitutionLoginInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['pictureUrl'] = this.picture;
    data['id'] = this.id;
    return data;
  }

  clone(): InstitutionLoginInfoDto {
    const json = this.toJSON();
    let result = new InstitutionLoginInfoDto();
    result.init(json);
    return result;
  }
}

export interface IInstitutionLoginInfoDto {
  name: string | undefined;
  picture: string | undefined;
  id: number | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
  name: string;
  institutionId: number;
  subscriptionStartDate: moment.Moment;
  subscriptionRenewalDate: moment.Moment | undefined;
  billingFrequency: CreateTenantDtoBillingFrequency;
  maximumUsers: number;

  constructor(data?: ICreateTenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.institutionId = data['institutionId'];
      this.subscriptionStartDate = data['subscriptionStartDate']
        ? moment(data['subscriptionStartDate'].toString())
        : <any>undefined;
      this.subscriptionRenewalDate = data['subscriptionRenewalDate']
        ? moment(data['subscriptionRenewalDate'].toString())
        : <any>undefined;
      this.billingFrequency = data['billingFrequency'];
      this.maximumUsers = data['maximumUsers'];
    }
  }

  static fromJS(data: any): CreateTenantDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateTenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['institutionId'] = this.institutionId;
    data['subscriptionStartDate'] = this.subscriptionStartDate
      ? this.subscriptionStartDate.toISOString()
      : <any>undefined;
    data['subscriptionRenewalDate'] = this.subscriptionRenewalDate
      ? this.subscriptionRenewalDate.toISOString()
      : <any>undefined;
    data['billingFrequency'] = this.billingFrequency;
    data['maximumUsers'] = this.maximumUsers;
    return data;
  }

  clone(): CreateTenantDto {
    const json = this.toJSON();
    let result = new CreateTenantDto();
    result.init(json);
    return result;
  }
}

export interface ICreateTenantDto {
  name: string;
  institutionId: number;
  subscriptionStartDate: moment.Moment;
  subscriptionRenewalDate: moment.Moment | undefined;
  billingFrequency: CreateTenantDtoBillingFrequency;
  maximumUsers: number;
}

export class TenantDto implements ITenantDto {
  name: string | undefined;
  isActive: boolean | undefined;
  lastActivationtime: moment.Moment | undefined;
  lastModificationTime: moment.Moment | undefined;
  subscriptionStartDate: moment.Moment | undefined;
  subscriptionRenewalDate: moment.Moment | undefined;
  billingFrequency: TenantDtoBillingFrequency | undefined;
  maximumUsers: number | undefined;
  usersCount: number | undefined;
  institution: GetInstitutionsNameResponseDto | undefined;
  id: number | undefined;

  constructor(data?: ITenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.isActive = data['isActive'];
      this.lastActivationtime = data['lastActivationtime']
        ? moment(data['lastActivationtime'].toString())
        : <any>undefined;
      this.lastModificationTime = data['lastModificationTime']
        ? moment(data['lastModificationTime'].toString())
        : <any>undefined;
      this.subscriptionStartDate = data['subscriptionStartDate']
        ? moment(data['subscriptionStartDate'].toString())
        : <any>undefined;
      this.subscriptionRenewalDate = data['subscriptionRenewalDate']
        ? moment(data['subscriptionRenewalDate'].toString())
        : <any>undefined;
      this.billingFrequency = data['billingFrequency'];
      this.maximumUsers = data['maximumUsers'];
      this.usersCount = data['usersCount'];
      this.institution = data['institution']
        ? GetInstitutionsNameResponseDto.fromJS(data['institution'])
        : <any>undefined;
      this.id = data['id'];
    }
  }

  static fromJS(data: any): TenantDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['isActive'] = this.isActive;
    data['lastActivationtime'] = this.lastActivationtime
      ? this.lastActivationtime.toISOString()
      : <any>undefined;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['subscriptionStartDate'] = this.subscriptionStartDate
      ? this.subscriptionStartDate.toISOString()
      : <any>undefined;
    data['subscriptionRenewalDate'] = this.subscriptionRenewalDate
      ? this.subscriptionRenewalDate.toISOString()
      : <any>undefined;
    data['billingFrequency'] = this.billingFrequency;
    data['maximumUsers'] = this.maximumUsers;
    data['usersCount'] = this.usersCount;
    data['institution'] = this.institution
      ? this.institution.toJSON()
      : <any>undefined;
    data['id'] = this.id;
    return data;
  }

  clone(): TenantDto {
    const json = this.toJSON();
    let result = new TenantDto();
    result.init(json);
    return result;
  }
}

export interface ITenantDto {
  name: string | undefined;
  isActive: boolean | undefined;
  lastActivationtime: moment.Moment | undefined;
  lastModificationTime: moment.Moment | undefined;
  subscriptionStartDate: moment.Moment | undefined;
  subscriptionRenewalDate: moment.Moment | undefined;
  billingFrequency: TenantDtoBillingFrequency | undefined;
  maximumUsers: number | undefined;
  usersCount: number | undefined;
  institution: GetInstitutionsNameResponseDto | undefined;
  id: number | undefined;
}

export class PagedResultDtoOfTenantDto implements IPagedResultDtoOfTenantDto {
  totalCount: number | undefined;
  items: TenantDto[] | undefined;

  constructor(data?: IPagedResultDtoOfTenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items']) this.items.push(TenantDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfTenantDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfTenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultDtoOfTenantDto {
    const json = this.toJSON();
    let result = new PagedResultDtoOfTenantDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultDtoOfTenantDto {
  totalCount: number | undefined;
  items: TenantDto[] | undefined;
}

export class UpdateTenantStatusDto implements IUpdateTenantStatusDto {
  id: number;
  isActive: boolean;

  constructor(data?: IUpdateTenantStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.isActive = data['isActive'];
    }
  }

  static fromJS(data: any): UpdateTenantStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateTenantStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['isActive'] = this.isActive;
    return data;
  }

  clone(): UpdateTenantStatusDto {
    const json = this.toJSON();
    let result = new UpdateTenantStatusDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateTenantStatusDto {
  id: number;
  isActive: boolean;
}

export class UpdateTenantNameDto implements IUpdateTenantNameDto {
  id: number;
  name: string;

  constructor(data?: IUpdateTenantNameDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
    }
  }

  static fromJS(data: any): UpdateTenantNameDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateTenantNameDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }

  clone(): UpdateTenantNameDto {
    const json = this.toJSON();
    let result = new UpdateTenantNameDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateTenantNameDto {
  id: number;
  name: string;
}

export class UpdateTenantDto implements IUpdateTenantDto {
  id: number;
  name: string | undefined;
  institutionId: number | undefined;
  subscriptionStartDate: moment.Moment | undefined;
  subscriptionRenewalDate: moment.Moment | undefined;
  billingFrequency: UpdateTenantDtoBillingFrequency | undefined;
  maximumUsers: number | undefined;

  constructor(data?: IUpdateTenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.name = data['name'];
      this.institutionId = data['institutionId'];
      this.subscriptionStartDate = data['subscriptionStartDate']
        ? moment(data['subscriptionStartDate'].toString())
        : <any>undefined;
      this.subscriptionRenewalDate = data['subscriptionRenewalDate']
        ? moment(data['subscriptionRenewalDate'].toString())
        : <any>undefined;
      this.billingFrequency = data['billingFrequency'];
      this.maximumUsers = data['maximumUsers'];
    }
  }

  static fromJS(data: any): UpdateTenantDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateTenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['institutionId'] = this.institutionId;
    data['subscriptionStartDate'] = this.subscriptionStartDate
      ? this.subscriptionStartDate.toISOString()
      : <any>undefined;
    data['subscriptionRenewalDate'] = this.subscriptionRenewalDate
      ? this.subscriptionRenewalDate.toISOString()
      : <any>undefined;
    data['billingFrequency'] = this.billingFrequency;
    data['maximumUsers'] = this.maximumUsers;
    return data;
  }

  clone(): UpdateTenantDto {
    const json = this.toJSON();
    let result = new UpdateTenantDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateTenantDto {
  id: number;
  name: string | undefined;
  institutionId: number | undefined;
  subscriptionStartDate: moment.Moment | undefined;
  subscriptionRenewalDate: moment.Moment | undefined;
  billingFrequency: UpdateTenantDtoBillingFrequency | undefined;
  maximumUsers: number | undefined;
}

export class GoogleAuthRequestDto implements IGoogleAuthRequestDto {
  url: string | undefined;

  constructor(data?: IGoogleAuthRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.url = data['url'];
    }
  }

  static fromJS(data: any): GoogleAuthRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new GoogleAuthRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['url'] = this.url;
    return data;
  }

  clone(): GoogleAuthRequestDto {
    const json = this.toJSON();
    let result = new GoogleAuthRequestDto();
    result.init(json);
    return result;
  }
}

export interface IGoogleAuthRequestDto {
  url: string | undefined;
}

export class InstitutionWhiteLabelDto implements IInstitutionWhiteLabelDto {
  isCustomizationEnabled: boolean | undefined;
  isHideFooter: boolean | undefined;
  mainLogo: string | undefined;
  loginLogo: string | undefined;
  favIcon: string | undefined;
  redirect: string | undefined;

  constructor(data?: IInstitutionWhiteLabelDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.isCustomizationEnabled = data['isCustomizationEnabled'];
      this.isHideFooter = data['isHideFooter'];
      this.mainLogo = data['mainLogo'];
      this.loginLogo = data['loginLogo'];
      this.favIcon = data['favIcon'];
      this.redirect = data['redirect'];
    }
  }

  static fromJS(data: any): InstitutionWhiteLabelDto {
    data = typeof data === 'object' ? data : {};
    let result = new InstitutionWhiteLabelDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isCustomizationEnabled'] = this.isCustomizationEnabled;
    data['isHideFooter'] = this.isHideFooter;
    data['mainLogo'] = this.mainLogo;
    data['loginLogo'] = this.loginLogo;
    data['favIcon'] = this.favIcon;
    data['redirect'] = this.redirect;
    return data;
  }

  clone(): InstitutionWhiteLabelDto {
    const json = this.toJSON();
    let result = new InstitutionWhiteLabelDto();
    result.init(json);
    return result;
  }
}

export interface IInstitutionWhiteLabelDto {
  isCustomizationEnabled: boolean | undefined;
  isHideFooter: boolean | undefined;
  mainLogo: string | undefined;
  loginLogo: string | undefined;
  favIcon: string | undefined;
  redirect: string | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
  userNameOrEmailAddress: string;
  password: string;
  rememberClient: boolean | undefined;

  constructor(data?: IAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.userNameOrEmailAddress = data['userNameOrEmailAddress'];
      this.password = data['password'];
      this.rememberClient = data['rememberClient'];
    }
  }

  static fromJS(data: any): AuthenticateModel {
    data = typeof data === 'object' ? data : {};
    let result = new AuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userNameOrEmailAddress'] = this.userNameOrEmailAddress;
    data['password'] = this.password;
    data['rememberClient'] = this.rememberClient;
    return data;
  }

  clone(): AuthenticateModel {
    const json = this.toJSON();
    let result = new AuthenticateModel();
    result.init(json);
    return result;
  }
}

export class SsoAuthenticateModel implements ISsoAuthenticateModel {
  email: string;
  idToken: string;
  accessToken: string;

  constructor(data?: ISsoAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.email = data['email'];
      this.idToken = data['idToken'];
      this.accessToken = data['accessToken'];
    }
  }

  static fromJS(data: any): SsoAuthenticateModel {
    data = typeof data === 'object' ? data : {};
    let result = new SsoAuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['email'] = this.email;
    data['idToken'] = this.idToken;
    data['accessToken'] = this.accessToken;
    return data;
  }

  clone(): SsoAuthenticateModel {
    const json = this.toJSON();
    let result = new SsoAuthenticateModel();
    result.init(json);
    return result;
  }
}

export interface IAuthenticateModel {
  userNameOrEmailAddress: string;
  password: string;
  rememberClient: boolean | undefined;
}

export interface ISsoAuthenticateModel {
  email: string;
  idToken: string;
  accessToken: string;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number | undefined;
  userId: number | undefined;

  constructor(data?: IAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.accessToken = data['accessToken'];
      this.encryptedAccessToken = data['encryptedAccessToken'];
      this.expireInSeconds = data['expireInSeconds'];
      this.userId = data['userId'];
    }
  }

  static fromJS(data: any): AuthenticateResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new AuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['accessToken'] = this.accessToken;
    data['encryptedAccessToken'] = this.encryptedAccessToken;
    data['expireInSeconds'] = this.expireInSeconds;
    data['userId'] = this.userId;
    return data;
  }

  clone(): AuthenticateResultModel {
    const json = this.toJSON();
    let result = new AuthenticateResultModel();
    result.init(json);
    return result;
  }
}

export interface IAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number | undefined;
  userId: number | undefined;
}

export class ExternalLoginProviderInfoModel
  implements IExternalLoginProviderInfoModel {
  name: string | undefined;
  clientId: string | undefined;

  constructor(data?: IExternalLoginProviderInfoModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.name = data['name'];
      this.clientId = data['clientId'];
    }
  }

  static fromJS(data: any): ExternalLoginProviderInfoModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalLoginProviderInfoModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['clientId'] = this.clientId;
    return data;
  }

  clone(): ExternalLoginProviderInfoModel {
    const json = this.toJSON();
    let result = new ExternalLoginProviderInfoModel();
    result.init(json);
    return result;
  }
}

export interface IExternalLoginProviderInfoModel {
  name: string | undefined;
  clientId: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
  authProvider: string;
  providerKey: string;
  providerAccessCode: string;

  constructor(data?: IExternalAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.authProvider = data['authProvider'];
      this.providerKey = data['providerKey'];
      this.providerAccessCode = data['providerAccessCode'];
    }
  }

  static fromJS(data: any): ExternalAuthenticateModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalAuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['authProvider'] = this.authProvider;
    data['providerKey'] = this.providerKey;
    data['providerAccessCode'] = this.providerAccessCode;
    return data;
  }

  clone(): ExternalAuthenticateModel {
    const json = this.toJSON();
    let result = new ExternalAuthenticateModel();
    result.init(json);
    return result;
  }
}

export interface IExternalAuthenticateModel {
  authProvider: string;
  providerKey: string;
  providerAccessCode: string;
}

export class ExternalAuthenticateResultModel
  implements IExternalAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number | undefined;
  waitingForActivation: boolean | undefined;

  constructor(data?: IExternalAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.accessToken = data['accessToken'];
      this.encryptedAccessToken = data['encryptedAccessToken'];
      this.expireInSeconds = data['expireInSeconds'];
      this.waitingForActivation = data['waitingForActivation'];
    }
  }

  static fromJS(data: any): ExternalAuthenticateResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalAuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['accessToken'] = this.accessToken;
    data['encryptedAccessToken'] = this.encryptedAccessToken;
    data['expireInSeconds'] = this.expireInSeconds;
    data['waitingForActivation'] = this.waitingForActivation;
    return data;
  }

  clone(): ExternalAuthenticateResultModel {
    const json = this.toJSON();
    let result = new ExternalAuthenticateResultModel();
    result.init(json);
    return result;
  }
}

export interface IExternalAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number | undefined;
  waitingForActivation: boolean | undefined;
}

export class ForgotPasswordModel implements IForgotPasswordModel {
  email: string | undefined;

  constructor(data?: IForgotPasswordModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.email = data['email'];
    }
  }

  static fromJS(data: any): ForgotPasswordModel {
    data = typeof data === 'object' ? data : {};
    let result = new ForgotPasswordModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['email'] = this.email;
    return data;
  }

  clone(): ForgotPasswordModel {
    const json = this.toJSON();
    let result = new ForgotPasswordModel();
    result.init(json);
    return result;
  }
}

export interface IForgotPasswordModel {
  email: string | undefined;
}

export class ResetPasswordModel implements IResetPasswordModel {
  userId: string;
  token: string;
  newPassword: string;
  repeatNewPassword: string;

  constructor(data?: IResetPasswordModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.userId = data['userId'];
      this.token = data['token'];
      this.newPassword = data['newPassword'];
      this.repeatNewPassword = data['repeatNewPassword'];
    }
  }

  static fromJS(data: any): ResetPasswordModel {
    data = typeof data === 'object' ? data : {};
    let result = new ResetPasswordModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['token'] = this.token;
    data['newPassword'] = this.newPassword;
    data['repeatNewPassword'] = this.repeatNewPassword;
    return data;
  }

  clone(): ResetPasswordModel {
    const json = this.toJSON();
    let result = new ResetPasswordModel();
    result.init(json);
    return result;
  }
}

export interface IResetPasswordModel {
  userId: string;
  token: string;
  newPassword: string;
  repeatNewPassword: string;
}

export class ActivateUserDto implements IActivateUserDto {
  userId: string;
  token: string;
  newPassword: string;
  repeatNewPassword: string;

  constructor(data?: IActivateUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.userId = data['userId'];
      this.token = data['token'];
      this.newPassword = data['newPassword'];
      this.repeatNewPassword = data['repeatNewPassword'];
    }
  }

  static fromJS(data: any): ActivateUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new ActivateUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['token'] = this.token;
    data['newPassword'] = this.newPassword;
    data['repeatNewPassword'] = this.repeatNewPassword;
    return data;
  }

  clone(): ActivateUserDto {
    const json = this.toJSON();
    let result = new ActivateUserDto();
    result.init(json);
    return result;
  }
}

export interface IActivateUserDto {
  userId: string;
  token: string;
  newPassword: string;
  repeatNewPassword: string;
}

export class CreateUserDto implements ICreateUserDto {
  fullName: string;
  emailAddress: string;
  additionalInfo?: string;
  additionalInfo1?: string;
  additionalInfo2?: string;
  roleNames: string[] | undefined;
  manageableGroups: any;
  groupId: any;
  loginType: any;
  impersonateTenantId: number | undefined;
  tenantId?: any;

  constructor(data?: ICreateUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.fullName = data['fullName'];
      this.additionalInfo = data['additionalInfo'];
      this.emailAddress = data['emailAddress'];
      this.additionalInfo1 = data['additionalInfo1'];
      this.additionalInfo2 = data['additionalInfo2'];
      this.tenantId = data['tenantId'];
      this.groupId = data['groupId'];
      this.manageableGroups = data['manageableGroups'];
      if (data['roleNames'] && data['roleNames'].constructor === Array) {
        this.roleNames = [];
        for (let item of data['roleNames']) this.roleNames.push(item);
      }
      this.impersonateTenantId = data['impersonateTenantId'];
    }
  }

  static fromJS(data: any): CreateUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['fullName'] = this.fullName;
    data['loginType'] = this.loginType;
    data['additionalInfo'] = this.additionalInfo;
    data['tenantId'] = this.tenantId;
    data['groupId'] = this.groupId;
    data['additionalInfo1'] = this.additionalInfo1;
    data['additionalInfo2'] = this.additionalInfo2;
    data['manageableGroups'] = this.manageableGroups;
    data['emailAddress'] = this.emailAddress;
    if (this.roleNames && this.roleNames.constructor === Array) {
      data['roleNames'] = [];
      for (let item of this.roleNames) data['roleNames'].push(item);
    }
    data['impersonateTenantId'] = this.impersonateTenantId;
    return data;
  }

  clone(): CreateUserDto {
    const json = this.toJSON();
    let result = new CreateUserDto();
    result.init(json);
    return result;
  }
}

export interface ICreateUserDto {
  fullName: string;
  emailAddress: string;
  tenantId?: any;
  manageableGroups?: any;
  additionalInfo1?: string;
  additionalInfo2?: string;
  additionalInfo?: string;
  roleNames: any;
  groupId: any;
  loginType: any;
  impersonateTenantId: number | undefined;
}

export class UserDto implements IUserDto {
  userName: string;
  fullName: string;
  additionalInfo: string;
  additionalInfo1: string;
  additionalInfo2: string;
  manageableGroups: any;
  emailAddress: string;
  tenant: string;
  isActive: boolean | undefined;
  isEmailAddressConfirmed: boolean | undefined;
  lastLoginTime: moment.Moment | undefined;
  creationTime: moment.Moment | undefined;
  roleNames: string[] | undefined;
  group: any;
  lastModificationTime: moment.Moment | undefined;
  id: number | undefined;

  constructor(data?: IUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.isEmailAddressConfirmed = data['isEmailAddressConfirmed'];
      this.userName = data['userName'];
      this.fullName = data['fullName'];
      this.additionalInfo = data['additionalInfo'];
      this.emailAddress = data['emailAddress'];
      this.additionalInfo1 = data['additionalInfo1'];
      this.additionalInfo2 = data['additionalInfo2'];
      this.isActive = data['isActive'];
      this.group = data['group'];
      this.manageableGroups = data['manageableGroups']
      this.tenant = data['tenant'];
      this.lastLoginTime = data['lastLoginTime']
        ? moment(data['lastLoginTime'].toString())
        : <any>undefined;
      this.creationTime = data['creationTime']
        ? moment(data['creationTime'].toString())
        : <any>undefined;
      if (data['roleNames'] && data['roleNames'].constructor === Array) {
        this.roleNames = [];
        for (let item of data['roleNames']) this.roleNames.push(item);
      }
      this.lastModificationTime = data['lastModificationTime']
        ? moment(data['lastModificationTime'].toString())
        : <any>undefined;
      this.id = data['id'];
    }
  }

  static fromJS(data: any): UserDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userName'] = this.userName;
    data['fullName'] = this.fullName;
    data['additionalInfo'] = this.additionalInfo;
    data['emailAddress'] = this.emailAddress;
    data['tenant'] = this.tenant;
    data['additionalInfo1'] = this.additionalInfo1;
    data['additionalInfo2'] = this.additionalInfo2;
    data['group'] = this.group;
    data['manageableGroups'] = this.manageableGroups;
    data['isActive'] = this.isActive;
    data['lastLoginTime'] = this.lastLoginTime
      ? this.lastLoginTime.toISOString()
      : <any>undefined;
    data['creationTime'] = this.creationTime
      ? this.creationTime.toISOString()
      : <any>undefined;
    if (this.roleNames && this.roleNames.constructor === Array) {
      data['roleNames'] = [];
      for (let item of this.roleNames) data['roleNames'].push(item);
    }
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['id'] = this.id;
    return data;
  }

  clone(): UserDto {
    const json = this.toJSON();
    let result = new UserDto();
    result.init(json);
    return result;
  }
}

export interface IUserDto {
  userName: string;
  fullName: string;
  additionalInfo?: string;
  additionalInfo1?: string;
  additionalInfo2?: string;
  emailAddress: string;
  manageableGroups: any;
  isActive: boolean | undefined;
  isEmailAddressConfirmed: boolean | undefined;
  lastLoginTime: moment.Moment | undefined;
  creationTime: moment.Moment | undefined;
  roleNames: string[] | undefined;
  lastModificationTime: moment.Moment | undefined;
  id: number | undefined;
}

export class PagedResultDtoOfUserDto implements IPagedResultDtoOfUserDto {
  totalCount: number | undefined;
  items: UserDto[] | undefined;

  constructor(data?: IPagedResultDtoOfUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.totalCount = data['totalCount'];
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items']) this.items.push(UserDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): PagedResultDtoOfUserDto {
    const json = this.toJSON();
    let result = new PagedResultDtoOfUserDto();
    result.init(json);
    return result;
  }
}

export interface IPagedResultDtoOfUserDto {
  totalCount: number | undefined;
  items: UserDto[] | undefined;
}

export class UpdateUserDto implements IUpdateUserDto {
  id: number;
  fullName: string;
  additionalInfo?: string;
  additionalInfo1?: string;
  additionalInfo2?: string;
  roleNames: string[] | undefined;
  manageableGroups?: any;
  ImpersonateTenantId: number | undefined;
  groupId: number | undefined;

  constructor(data?: IUpdateUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.id = data['id'];
      this.fullName = data['fullName'];
      this.additionalInfo = data['additionalInfo'];
      this.additionalInfo1 = data['additionalInfo1']
      this.additionalInfo2 = data['additionalInfo2']
      this.manageableGroups = data['manageableGroups'];
      if (data['roleNames'] && data['roleNames'].constructor === Array) {
        this.roleNames = [];
        for (let item of data['roleNames']) this.roleNames.push(item);
      }
      this.ImpersonateTenantId = data['ImpersonateTenantId'];
      this.groupId = data['groupId'];
    }
  }

  static fromJS(data: any): UpdateUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['manageableGroups'] = this.manageableGroups;
    data['additionalInfo'] = this.additionalInfo;
    data['additionalInfo1'] = this.additionalInfo1;
    data['additionalInfo2'] = this.additionalInfo2;
    if (this.roleNames && this.roleNames.constructor === Array) {
      data['roleNames'] = [];
      for (let item of this.roleNames) data['roleNames'].push(item);
    }
    data['ImpersonateTenantId'] = this.ImpersonateTenantId;
    data['groupId'] = this.groupId;
    return data;
  }

  clone(): UpdateUserDto {
    const json = this.toJSON();
    let result = new UpdateUserDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateUserDto {
  id: number;
  fullName: string;
  additionalInfo?: string;
  additionalInfo1?: string;
  additionalInfo2?: string;
  roleNames: string[] | undefined;
  ImpersonateTenantId: number | undefined;
  manageableGroups?: any;
  userId?: number;
  groupId: number | undefined;
}

export class UpdateUserStatusDto implements IUpdateUserStatusDto {
  userId: number | undefined;
  isActive: boolean | undefined;
  ImpersonateTenantId: number | undefined;
  id?: number;

  constructor(data?: IUpdateUserStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.userId = data['userId'];
      this.isActive = data['isActive'];
      this.ImpersonateTenantId = data['ImpersonateTenantId'];
    }
  }

  static fromJS(data: any): UpdateUserStatusDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateUserStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['isActive'] = this.isActive;
    data['ImpersonateTenantId'] = this.ImpersonateTenantId;
    return data;
  }

  clone(): UpdateUserStatusDto {
    const json = this.toJSON();
    let result = new UpdateUserStatusDto();
    result.init(json);
    return result;
  }
}

export interface IUpdateUserStatusDto {
  userId?: number | undefined;
  isActive: boolean | undefined;
  ImpersonateTenantId: number | undefined;
  id?: number;
}

export class ListResultDtoOfRoleDto implements IListResultDtoOfRoleDto {
  items: RoleDto[] | undefined;

  constructor(data?: IListResultDtoOfRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      if (data['items'] && data['items'].constructor === Array) {
        this.items = [];
        for (let item of data['items']) this.items.push(RoleDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.items && this.items.constructor === Array) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }

  clone(): ListResultDtoOfRoleDto {
    const json = this.toJSON();
    let result = new ListResultDtoOfRoleDto();
    result.init(json);
    return result;
  }
}

export interface IListResultDtoOfRoleDto {
  items: RoleDto[] | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
  languageName: string;

  constructor(data?: IChangeUserLanguageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.languageName = data['languageName'];
    }
  }

  static fromJS(data: any): ChangeUserLanguageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChangeUserLanguageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['languageName'] = this.languageName;
    return data;
  }

  clone(): ChangeUserLanguageDto {
    const json = this.toJSON();
    let result = new ChangeUserLanguageDto();
    result.init(json);
    return result;
  }
}

export interface IChangeUserLanguageDto {
  languageName: string;
}

export class ChangePasswordDto implements IChangePasswordDto {
  currentPassword: string;
  newPassword: string;

  constructor(data?: IChangePasswordDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(data?: any) {
    if (data) {
      this.currentPassword = data['currentPassword'];
      this.newPassword = data['newPassword'];
    }
  }

  static fromJS(data: any): ChangePasswordDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChangePasswordDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['currentPassword'] = this.currentPassword;
    data['newPassword'] = this.newPassword;
    return data;
  }

  clone(): ChangePasswordDto {
    const json = this.toJSON();
    let result = new ChangePasswordDto();
    result.init(json);
    return result;
  }
}

export interface IChangePasswordDto {
  currentPassword: string;
  newPassword: string;
}

export enum Progress {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum Status {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum Status2 {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum LevelOfDifficulty {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum Progress2 {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum LevelOfDifficulty2 {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum Progress3 {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum LevelOfDifficulty3 {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum Progress4 {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum Access {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum Access2 {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum IsTenantAvailableOutputState {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum ClassOverviewDtoProgressStatus {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum CreateClassDtoAccess {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum ClassForEditDtoStatus {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum ClassForEditDtoAccess {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum UpdateClassDtoAccess {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum ClassMainInfoDtoStatus {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum UploadVideoRequestDtoVideoType {
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
}

export enum ClearClassVideoRequestDtoVideoType {
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
}

export enum CountCourseResultRequestDtoLevelOfDifficulty {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum CountCourseResultRequestDtoProgress {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum CourseOverviewDtoLevelOfDifficulty {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum PagedProgramsResponseDtoAccess {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum CreateProgramDtoAccess {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum ProgramResponseDtoAccess {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum UpdateProgramDtoAccess {
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export enum QuestionDtoQuestionType {
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
}

export enum CreateTenantDtoBillingFrequency {
  _1 = 1,
  _2 = 2,
}

export enum TenantDtoBillingFrequency {
  _1 = 1,
  _2 = 2,
}

export enum UpdateTenantDtoBillingFrequency {
  _1 = 1,
  _2 = 2,
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else
    return _observableThrow(
      new SwaggerException(message, status, response, headers, null)
    );
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((<any>event.target).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}

function _getErrorMessage(_responseText) {
  let message = 'An unexpected server error occurred.';
  const resp = JSON.parse(_responseText);
  if (resp.error.message) {
    message = resp.error.message;
  }
  return message;
}
